import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import Header from '../../common_components/Header';
import Footer from '../../common_components/Footer';
import Drawer from '../../common_components/Drawer';
import {
    primaryChapterAdd_action, getPreviewDetails_action, getDoubleStoreySSI_action, deleteSSicertificate_action, deleteTMMAITAMMA_action, deleteChapterDoc_action
} from '../../actions/primary_chapter_action'
import {
    getAgentDetails_action
} from '../../actions/registration_action'
import Resizer from "react-image-file-resizer";

import {
    getPendingRegDetails_action, generateNewForm_action
} from '../../actions/registration_action'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';
import moment from 'moment';
import Modal from "react-modal";
import Loader from '../../utils/Loader'
import {
    clearSessionStorage, primaryChapterListActionId, BASE_URL, openSideListActionId, internationalAreaSlabActionId,
    toastError, toastSuccess, stallTypeActionId, stallSizeActionId, GSTvalidationActionId, fullStallAreaActionId,
    countryActionId, BarActionId,
    CFMActionId,
    lengthActionId,
    breadthActionId,
    link_BASE_URL,
    formatAmount, IntAreaRules
} from '../../utils/constants'
import { fill_action } from '../../actions/fillCombo_action'
import StepHeader from './stepHeader'
import $ from 'jquery'
import {
    contactNoValidator,
    panNoValidator,
    tanNoValidator,
    gstNoValidator,
    emailValidator,
} from "../../utils/Validator";
import ConfirmationModal from "../../common_components/confirmationa_modal";
import "pdfjs-dist/build/pdf.worker.entry";
import * as pdfjsLib from "pdfjs-dist";
import { insertUserRegistration_action, getExhibitionSSRCountryMappingData_action } from '../../actions/user_registration_action';

import {
    getPowerConnectionList_action,
} from "../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/power_connection_action/power_connection_action";
import {
    getWaterDetails_action
} from "../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/water_form_action/water_form_action";
import {
    getAirConnectionDetails_action,
} from "../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/airConnection_action/airConnection_action";
/* 
* mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
* mapStateToProps
*/
const mapStateToProps = state => ({
    ...state
})

class PrimaryChapter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            open: false,
            isOpenAgree: false,
            isOpen4: false,
            areaValidationPopFlag: 1,
            expectedArea: '',
            expectedAreaId: '',
            exhibitionID: "",
            exhRegistrationID: "",
            primaryChapterListData: [],
            level0: [],
            level2: [],
            level3: [],
            level4: [],
            schemeType: '',
            schemeTypeList: [],
            stallAreaList: [],
            selectedPrimaryChapterId: '',
            selectedPrimaryChapterIdList: [],
            stallAreaId: '',
            stallAreaName: '',
            PrimaryChapterId: '',
            // openSlideRadio: '',
            countryId: "",
            countryName: "",
            primaryChapterRadio: "",
            openSlides: "1",
            exhibitDetailsList: [],
            schemeTypeErr: "",
            primaryChapterIdErr: "",
            stallAreaIdErr: "",
            openSlidesErr: "",
            exhibitDetailsTableErr: "",
            lengthWidthErr: '',
            exhRegistrationNo: '',
            area: '',
            minAreaPercent: '',
            minArea: '',
            doubleStoreyArea: '',
            doubleStoreyAreaErr: '',
            isDoubleStorey: false,
            isSSi: false,
            isSSifile: '',
            isSSifileErr: '',
            isSSifileType: '',
            isSSifilePath: '',
            isSSIandTMMAITAMMMA: false,
            TMMAITAMMA: '',
            TMMAITAMMAfile: '',
            TMMAITAMMAfileErr: '',
            TMMAITAMMAfileType: '',
            TMMAITAMMAfilePath: '',
            openSideList: [],
            isDoubleStoreyExhibition: false,
            isChargesforOpenSides: false,
            isSSIExhibition: false,
            isSSIdeleted: true,
            isTMMAITAMMAdeleted: true,
            isDel1Open: false,
            isDel2Open: false,
            isDel3Open: false,
            isDataLoad: false,
            isShowChapterNotes: false,
            isShowHighlightChapters: false,
            isShowMachineryGuidelines: false,
            guideLines: [],
            note: [],
            SSIMaxArea: '',
            gstValidationList: [],
            agentChapterIDList: [],
            url: '',
            DoubleStoreyPath: '',
            OpenSidePath: '',
            remark: '',
            minAreafor4OpenSide: 300,
            ExhibitDetailsNote: [],
            SSRCountryList: [],
            isOpen2: false,
            intAreaRulesPop: false,
            ExhPrimaryUndertakingPersonName: '',
            ExhPrimaryUndertakingDesignation: '',
            ExhPrimaryUndertakingCompanyName: '',
            ExhPrimaryUndertakingEmail: '',
            ExhPrimaryUndertakingMobileNo: '',
            PreExhPrimaryUndertakingMobileNo: '',
            ExhPrimaryUndertakingPersonNameErr: '',
            ExhPrimaryUndertakingDesignationErr: '',
            ExhPrimaryUndertakingCompanyNameErr: '',
            ExhPrimaryUndertakingEmailErr: '',
            ExhPrimaryUndertakingMobileNoErr: '',
            ExhPrimaryChapterComment: '',
            MultiSelectNotes: [],
            undertakingNote: [],
            ExhPrimaryChapterCommentErr: '',
            MinBareArea: [],
            minShellArea: [],
            referenceStallAreaArr: [],

            countryList: [],
            tempCountryList: [],
            isDisplayCountryList: false,
            manufactureCountryIndex: '',
            lengthList: [],
            breadthList: [],
            InternationalArea: '',
            InternationalAreaErr: '',
            isShowInternationalArea: false,
            defaultprimaryChapterIdErr: '',
            DueDate: '',
            internationalAreaSlabList: [],
            toNewPop: false,
            UUID: '',
            newPopCountry: '',
            isAllBro: false,
            isOpenForInternationalForm: false,
            InternationalFormCountryId: '',
            InternationalFormAreaNew: '',
            isMachineMandatory: true,
            slabpop: false,

            delChapterID: '',
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            natAreaErr: false,
            isMixRuleAgree: false,
            OpenMixExhibitorRule: false,
            OpensameCountryManuErr: false,
            barQuantityList: [],
            CFMQuantityList: [],
            SSIPop: false,
            isOpenUtility: false,
            UtilityName: '',
            CurrencyName: '',
            powerPriceList: [],
            waterPriceList: [],
            airPriceList: [],
            minAreaPop1: false,
            minAreaPop2: false,
            prefferedType: '',
            prefferedPop: false,
            prefferedPopAsk: false,
            IAbare: 0,
            IAshell: 0,
            isOpen10: false,
            IntRulesPath: '',
        }
        this.pdfContainerRef = createRef();
        this.getFillList = this.getFillList.bind(this)
        this.onPreviousClick = this.onPreviousClick.bind(this)
        this.onSelectLevel4 = this.onSelectLevel4.bind(this)
        this.filterLevelData = this.filterLevelData.bind(this)
        this.record = this.record.bind(this)
        this.recordFour = this.recordFour.bind(this)
        this.onSchemeTypeChange = this.onSchemeTypeChange.bind(this)
        this.onLengthTypeChange = this.onLengthTypeChange.bind(this)
        this.onEnterHSNCode = this.onEnterHSNCode.bind(this)
        this.onMBclick = this.onMBclick.bind(this)
        this.onEnterProductName = this.onEnterProductName.bind(this)
        this.handleStep2Insert = this.handleStep2Insert.bind(this)
        this.onAddManualChapter = this.onAddManualChapter.bind(this)
        this.handleClickSelectPrimaryChapter = this.handleClickSelectPrimaryChapter.bind(this)
        this.preventMinus = this.preventMinus.bind(this)
        this.onCheckLevel2 = this.onCheckLevel2.bind(this)
        this.onCheckLevel3 = this.onCheckLevel3.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.loadscript = this.loadscript.bind(this)
        this.getPendingRegDetailsByCode = this.getPendingRegDetailsByCode.bind(this)
        this.getAgentDetails = this.getAgentDetails.bind(this)
        this.adjustInternationalArea = this.adjustInternationalArea.bind(this)
        this.fillInternationalForm = this.fillInternationalForm.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.handleChapterDocDelete = this.handleChapterDocDelete.bind(this)
        this.onChapterDocDelete = this.onChapterDocDelete.bind(this)
        this.renderNewImage = this.renderNewImage.bind(this)
        this.handleConfirmation = this.handleConfirmation.bind(this)
        this.getExhibitionSSRCountryMappingData = this.getExhibitionSSRCountryMappingData.bind(this)
        this.adjustIntAreaNew = this.adjustIntAreaNew.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.handleStep2Insert()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    async PdfRender() {
        // const { IntRulesPath } = this.state;
        // console.log("IntAreaRules--------------------------------------------->", IntAreaRules)
        // if (!IntRulesPath) return;

        const container = this.pdfContainerRef.current;
        // console.log("container--------------------------------------------->", container)
        if (!container) return;

        container.innerHTML = ""; // clear old pages

        const url = `${BASE_URL.split("/api")[0]}/document/Exhibition/InternationalAreaRules/International-Area-Rules.pdf`;
        // const url = IntAreaRules
        console.log("url--------------------------------------------->", url)
        try {
            const pdf = await pdfjsLib.getDocument(url).promise;
            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: 1.5 });

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.height = viewport.height;
                canvas.width = viewport.width;
                canvas.style.width = "100%";
                canvas.style.height = "auto";
                canvas.style.display = "block";
                canvas.style.margin = "20px auto";

                container.appendChild(canvas);
                await page.render({ canvasContext: context, viewport }).promise;
            }
        } catch (err) {
            console.error("PDF rendering error:", err);
        }
    }

    componentDidMount() {
        this.getPowerDetails()
        this.getWaterDetails()
        this.getAirDetails()
        this.contextMenuHandler = (e) => e.preventDefault();
        document.addEventListener("contextmenu", this.contextMenuHandler);

        this.keyDownHandler = (e) => {
            if (
                e.keyCode === 123 || // F12
                (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || // Ctrl+Shift+I/J
                (e.ctrlKey && e.keyCode === 85) // Ctrl+U
            ) {
                e.preventDefault();
                return false;
            }
        };
        document.addEventListener("keydown", this.keyDownHandler);
        this.getFillList(countryActionId, '', '', '', '', '')
        console.log('prop is :', this.props);
        console.log('sessionExhRegistrationNo is :', sessionStorage.getItem('sessionExhRegistrationNo'));
        const url = BASE_URL.split('/api')
        this.setState({ url: url[0] })
        //if pending link call.........................................
        if (this.props.location.pathname.includes('/primary_chapter/')) {
            var code = this.props.location.pathname.replace('/primary_chapter/', '');
            var fullUrl = window.location.href
            fullUrl = fullUrl.split('#&')
            // console.log('prop is :', code);
            // if (fullUrl.length > 1) {
            //     this.setState({
            //         isOpenForInternationalForm: true,
            //         InternationalFormCountryId: parseInt(fullUrl[2]),
            //         InternationalFormAreaNew: parseInt(fullUrl[3]),
            //         is_update: true
            //     }, () => {
            //         console.log('this.props.location.state', this.props.location.state)
            //         this.getExhibitionSSRCountryMappingData(sessionStorage.getItem("sessionExhCode"))
            //         sessionStorage.setItem("renderPage", "primaryChapter")
            //         this.getPendingRegDetailsByCode(code).then(agentCode => {
            //             sessionStorage.setItem("fillInternationalForm", 1)
            //             // this.getFillList(countryActionId, '', '', '', '', '')
            //             agentCode != null && sessionStorage.setItem("agentCode", agentCode)
            //             if (agentCode != null) {
            //                 (
            //                     this.getAgentDetails().then(res => {
            //                         res && this.getDoubleStroeySSI()
            //                         res && this.getPreviewDetails()
            //                     })
            //                 )
            //             } else {
            //                 this.getDoubleStroeySSI()
            //                 this.getPreviewDetails()
            //             }
            //         })
            //     })
            // } else {
            console.log('this.props.location.state', this.props.location.state)
            sessionStorage.setItem("renderPage", "primaryChapter")
            this.getPendingRegDetailsByCode(code).then(agentCode => {
                agentCode != null && sessionStorage.setItem("agentCode", agentCode)
                if (agentCode != null) {
                    (
                        this.getAgentDetails().then(res => {
                            res && this.getDoubleStroeySSI()
                            res && this.getPreviewDetails()
                        })
                    )
                } else {
                    this.getDoubleStroeySSI()
                    this.getPreviewDetails()
                }
            })
            // }
        } else {
            sessionStorage.setItem("renderPage", "primaryChapter")
            this.setState({
                isDataLoad: true,
                countryId: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.countryId != " " ? this.props.location.state.countryId : '',
                countryName: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.countryName != " " ? this.props.location.state.countryName : '',
                exhibitionID: sessionStorage.getItem("sessionExhibitionID"),
                exhRegistrationID: sessionStorage.getItem("sessionExhRegistrationID"),
                is_update: sessionStorage.getItem("fillInternationalForm") == 1 ? true : this.props.location.state != null && this.props.location.state != "" && this.props.location.state.is_update != " " ? this.props.location.state.is_update : '',

            })
            var countryid = '';
            if (this.props.location.state != null && this.props.location.state != "" && this.props.location.state.countryId != undefined && this.props.location.state.countryId != "") {
                countryid = this.props.location.state.countryId;
            } else {
                countryid = sessionStorage.getItem("countryId");
            }
            this.setState({
                countryId: countryid
            })
            console.log('prepared country id : ', countryid);
            // this.getFillList(primaryChapterListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', sessionStorage.getItem("sessionExhRegistrationID"))
            this.getExhibitionSSRCountryMappingData(sessionStorage.getItem("sessionExhCode"))
            this.getFillList(stallTypeActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
            this.getFillList(openSideListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
            this.getFillList(BarActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
            this.getFillList(CFMActionId, sessionStorage.getItem("sessionExhibitionID"), '', 13, "", 1)
            this.getFillList(GSTvalidationActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
            this.getFillList(internationalAreaSlabActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '').then(() => {
                this.props.location.state.is_update && this.getPreviewDetails();
                sessionStorage.getItem("fillInternationalForm") == 1 && this.getPreviewDetails();
                this.loadscript()
                setTimeout(() => {
                    if (
                        this.props.location != null &&
                        this.props.location.state != null &&
                        sessionStorage.getItem("agentCode") != null &&
                        sessionStorage.getItem("agentCode") != ""
                    ) {
                        this.getAgentDetails().then(res => {
                            res && this.getDoubleStroeySSI()
                        });
                    } else {
                        this.getDoubleStroeySSI()
                    }

                }, 200);
            })
        }
    }

    getPowerDetails() {
        this.props
            .getPowerConnectionList_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        powerPriceList: data.data,
                        CurrencyName: data.data[0]["CurrencyName"],
                    });
                } else {
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getWaterDetails() {
        this.props
            .getWaterDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        waterPriceList: data.data,
                    })
                } else {
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getAirDetails() {
        this.props
            .getAirConnectionDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        airPriceList: data.ChargesList,
                    })
                } else {
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getDoubleStroeySSI() {
        const { exhRegistrationID, exhibitionID } = this.state

        this.setState({ isLoading: true });

        this.props
            .getDoubleStoreySSI_action(exhRegistrationID, exhibitionID)
            .then((data) => {
                if (data.error != 1) {
                    console.log('data is : ', data.data);
                    console.log(data.data[1], sessionStorage.getItem("sessionExhRegistrationNo"))
                    // var exNo = data.data[0][0].ExhRegistrationNo.replace(`/`, '_')
                    var guideLines = []
                    var notes = []
                    var multiSelectNotes = []
                    var exhibitDetailsNote = []
                    for (var i = 0; i < data.data[1].length; i++) {
                        if (data.data[1][i].NoteType == 'Guidelines') {
                            guideLines.push(data.data[1][i])
                        }
                        if (data.data[1][i].NoteType == 'Chapter Notes') {
                            notes.push(data.data[1][i])
                        }
                        if (data.data[1][i].NoteType == 'PrimaryChapter MultiSelect') {
                            multiSelectNotes.push(data.data[1][i])
                        }
                        if (data.data[1][i].NoteType == 'exhibit details') {
                            exhibitDetailsNote.push(data.data[1][i])
                        }
                    }
                    console.log(guideLines, notes)
                    var undertakingContent = []
                    data.data[2][0]['UndertakingContent1'] != null && data.data[2][0]['UndertakingContent1'] != undefined && undertakingContent.push(data.data[2][0]['UndertakingContent1'])
                    data.data[2][0]['UndertakingContent2'] != null && data.data[2][0]['UndertakingContent2'] != undefined && undertakingContent.push(data.data[2][0]['UndertakingContent2'])
                    data.data[2][0]['UndertakingContent3'] != null && data.data[2][0]['UndertakingContent3'] != undefined && undertakingContent.push(data.data[2][0]['UndertakingContent3'])
                    this.setState({
                        UUID: data.data[0][0].UUID,
                        minAreaPercent: data.data[0][0].DoubleStoreyAreaPercentage,
                        minArea: data.data[0][0].DoubleStoreyArea,
                        isDoubleStoreyExhibition: data.data[0][0].isDoubleStorey,
                        // isDoubleStorey: data.data[0][0].isDoubleStorey,
                        isSSIExhibition: data.data[0][0].isSSICertificate,
                        guideLines: guideLines,
                        note: notes,
                        MultiSelectNotes: multiSelectNotes,
                        ExhibitDetailsNote: exhibitDetailsNote,
                        isShowChapterNotes: data.data[0][0].isShowChapterNotes,
                        isShowHighlightChapters: data.data[0][0].isShowHighlightChapters,
                        isShowMachineryGuidelines: data.data[0][0].isShowMachineryGuidelines,
                        isChargesforOpenSides: data.data[0][0].isChargesForOpenSide,
                        SSIMaxArea: data.data[0][0].SSIArea,
                        DoubleStoreyPath: data.data[0][0].DoubleStoreyPath,
                        OpenSidePath: data.data[0][0].OpenSidePath,
                        DueDate: data.data[0][0].DueDate,

                        ExhPrimaryUndertakingMobileNo: data.data[0][0].MobileNo != null ? data.data[0][0].MobileNo.split('-').length == 2 ? data.data[0][0].MobileNo.split('-')[1] : data.data[0][0].MobileNo.split('-')[0] : '',
                        PreExhPrimaryUndertakingMobileNo: data.data[0][0].MobileNo != null ? data.data[0][0].MobileNo.split('-').length == 2 ? data.data[0][0].MobileNo.split('-')[0] : '' : '',
                        ExhPrimaryUndertakingPersonName: data.data[0][0].PersonName,
                        ExhPrimaryUndertakingDesignation: data.data[0][0].Designation,
                        ExhPrimaryUndertakingCompanyName: data.data[0][0].CompanyName,
                        ExhPrimaryUndertakingEmail: data.data[0][0].PrimaryEmail,
                        undertakingNote: undertakingContent,
                    })
                    setTimeout(() => {

                        this.getFillList(primaryChapterListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', sessionStorage.getItem("sessionExhRegistrationID")).then(res => {
                            this.setState({ isLoading: false })
                        })
                    }, 500);

                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    getPendingRegDetailsByCode(code) {
        console.log('code is : ', code);
        const { isOpenForInternationalForm } = this.state

        this.setState({ isLoading: true });
        return new Promise((resolve, reject) => {

            this.props
                .getPendingRegDetails_action(code, isOpenForInternationalForm ? 1 : 0)
                .then((data) => {
                    if (data.error != 1) {
                        console.log('data is : ', data.data[0]);
                        console.log('ExhRegistrationID is : ', data.data[0].ExhRegistrationID);
                        sessionStorage.setItem("sessionExhibitionID", data.data.length > 0 ? data.data[0].ExhibitionID : '')
                        // sessionStorage.setItem("sessionExhRegistrationID", data.data.length > 0 ? data.data[0].ExhRegistrationID : '')
                        if (sessionStorage.getItem("isOpenedForInternationalForm") == null) {
                            sessionStorage.setItem(
                                "sessionExhRegistrationID",
                                data.data.length > 0 ? data.data[0].ExhRegistrationID : ""
                            );
                        }
                        if (sessionStorage.getItem("isOpenedForInternationalForm") == null) {
                            sessionStorage.setItem(
                                "sessionExhRegistrationNo",
                                data.data.length > 0 ? data.data[0].ExhRegistrationNo : ""
                            );
                        }
                        sessionStorage.setItem("sessionContryNamePre", this.state.isOpenForInternationalForm ? parseInt(this.state.InternationalFormCountryId) : data.data.length > 0 ? data.data[0].CountryCode : '')
                        sessionStorage.setItem("isCountrySelected", true)
                        sessionStorage.setItem("isFirstStepCompleted", true)
                        sessionStorage.setItem("sessionContryName", this.state.isOpenForInternationalForm ? this.state.countryName : data.data.length > 0 ? data.data[0].CountryName : '')
                        sessionStorage.setItem("countryId", data.data.length > 0 ? data.data[0].CountryID : '')
                        sessionStorage.setItem("sessionExhRegistrationNo", data.data.length > 0 ? data.data[0].ExhRegistrationNo : "");
                        var emailArr = data.data.length > 0 && data.data[0].ExhMailEmail != '' && data.data[0].ExhMailEmail != null ? data.data[0].ExhMailEmail.split(",") : []
                        var mobileArr = data.data.length > 0 && data.data[0].ExhMailMobile != '' && data.data[0].ExhMailMobile != null ? data.data[0].ExhMailMobile.split(",") : []
                        sessionStorage.setItem("exhibitionAddress", data.data.length > 0 ? data.data[0]['Address'] : '')
                        sessionStorage.setItem("sessionBannerPath", data.data.length > 0 ? data.data[0]['Banner'] : '')
                        sessionStorage.setItem("exhibitionDateFrom", data.data.length > 0 ? data.data[0]['ExhibitionDateFrom'] : '')
                        sessionStorage.setItem("exhibitionDateTo", data.data.length > 0 ? data.data[0]['ExhibitionDateTo'] : '')
                        sessionStorage.setItem("sessionLogoPath", data.data.length > 0 ? data.data[0]['Logo'] : '')
                        sessionStorage.setItem("sessionExhibitionName", data.data.length > 0 ? data.data[0]['ExhibitionName'] : '')
                        sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                        sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                        sessionStorage.setItem("SSRLink", data.data[0]['SSRLink'])
                        sessionStorage.setItem("sessionExhCode", data.data[0].Code)
                        sessionStorage.setItem("companyName", data.data[0].CompanyName)
                        this.getExhibitionSSRCountryMappingData(data.data[0].Code)

                        // this.setState({ isLoading: false })
                        var agentCode = data.data.length > 0 ? data.data[0].agentcode != '' && data.data[0].agentcode != null ? data.data[0].agentcode : null : null
                        this.setState({
                            isDataLoad: true,
                            countryId: data.data.length > 0 ? data.data[0].CountryID : '',
                            countryName: data.data.length > 0 ? data.data[0].CountryName : '',
                            exhibitionID: data.data.length > 0 ? data.data[0].ExhibitionID : '',
                            exhRegistrationID: data.data.length > 0 ? data.data[0].ExhRegistrationID : '',
                            exhRegistrationNo: data.data.length > 0 ? data.data[0].ExhRegistrationNo : "",
                            is_update: true,
                        })
                        setTimeout(() => {
                            var countryid = '';
                            if (this.props.location.state != null && this.props.location.state != "" && this.props.location.state.countryId != undefined && this.props.location.state.countryId != "") {
                                countryid = this.props.location.state.countryId;
                            } else {
                                countryid = sessionStorage.getItem("countryId");
                            }
                            this.setState({
                                countryId: countryid
                            })
                            // console.log('prepared country id : ', countryid);
                            // this.getFillList(primaryChapterListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', sessionStorage.getItem("sessionExhRegistrationID")).then(() => {
                            // this.setState({ isLoading: false })
                            // })
                            this.getFillList(stallTypeActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
                            this.getFillList(openSideListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
                            this.getFillList(BarActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
                            this.getFillList(CFMActionId, sessionStorage.getItem("sessionExhibitionID"), '', 13, "", 1)
                            this.getFillList(internationalAreaSlabActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '').then(() => {
                                // this.getPreviewDetails();
                                this.loadscript()
                                // this.getDoubleStroeySSI()
                                resolve(agentCode)
                            })
                        }, 300);
                    }
                    else {
                        this.setState({ isLoading: false })
                        if (!this.state.isOpenForInternationalForm) {
                            if (data.msg.includes("Registration completed with ")) {
                                sessionStorage.setItem(
                                    "sessionExhRegistrationNo",
                                    data.msg.replace("Registration completed with ", "")
                                );
                                this.props.navigate("/thankYou");
                            }
                        }

                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    getAgentDetails() {
        this.setState({ isLoading: true });
        return new Promise((resolve, reject) => {
            this.props
                .getAgentDetails_action(sessionStorage.getItem("agentCode"))
                .then((data) => {
                    if (data.error != 1 && data.data != null && data.data.length > 0) {
                        console.log(data.data, 'agent')
                        var chapterIDArr = data.data[0]["ChapterID"] != '' && data.data[0]["ChapterID"] != null ? data.data[0]["ChapterID"].split(',') : []
                        console.log(chapterIDArr, 'chapterIDArr')
                        for (var i = 0; i < chapterIDArr.length; i++) {
                            chapterIDArr[i] = chapterIDArr[i].trim()
                            chapterIDArr[i] = parseInt(chapterIDArr[i])
                        }
                        this.setState({ agentChapterIDList: chapterIDArr });
                        resolve(true)
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.msg);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    inputValidate() {
        const { schemeType, stallAreaId, openSlides, exhibitDetailsList } = this.state
        if (schemeType == '') {
            this.setState({
                schemeTypeErr: 'Please select scheme type'
            })
        }
        if (stallAreaId == '') {
            this.setState({
                stallAreaIdErr: 'Please select stall area'
            })
        }
        if (openSlides == '') {
            this.setState({
                openSlidesErr: 'Please select open sides'
            })
        }
        if (exhibitDetailsList.length == 0) {
            console.log("exhibitDetailsList", exhibitDetailsList)
            this.setState({
                exhibitDetailsTableErr: 'Please select atleast one chapter'
            })
        }
    }
    // get preview Details
    getPreviewDetails() {
        const { level2, level3, level4, exhibitDetailsList, primaryChapterListData, stallAreaId, schemeType, stallAreaList } = this.state
        this.setState({ isLoading: true })
        var exbid = sessionStorage.getItem("sessionExhibitionID");
        var regid = sessionStorage.getItem("sessionExhRegistrationID")

        this.props
            .getPreviewDetails_action(regid, exbid)
            .then((data) => {
                if (data.error != 1) {
                    console.log("stallAreaId", data.data)
                    if (data.data[0]['ExhibitionStallSizeID'] != null && data.data[0]['StallTypeID'] != null && data.data[0]['OpenSides'] != null) {
                        var primaryChapterListTemp = data.data[0]['PrimaryChapter'] != null ? data.data[0]['PrimaryChapter'].split(',') : []
                        if (primaryChapterListTemp.length > 0) {
                            for (var i = 0; i < primaryChapterListTemp.length; i++) {
                                primaryChapterListTemp[i] = parseInt(primaryChapterListTemp[i].trim())
                            }
                        }
                        var mainPrimary = data.data[0]['PrimaryChapter'] != null ? (data.data[0]['PrimaryChapter'].split(',')[0]) : ''
                        this.setState({
                            InternationalArea: data.data[0]['InternationalArea'] != null ? data.data[0]['InternationalArea'] : '',
                            stallAreaId: data.data[0]['ExhibitionStallSizeID'] != null ? data.data[0]['ExhibitionStallSizeID'] : '',
                            schemeType: data.data[0]['StallTypeID'] != null ? data.data[0]['StallTypeID'] : '',
                            openSlides: data.data[0]['OpenSides'] != null ? data.data[0]['OpenSides'] : '',
                            primaryChapterRadio: mainPrimary != '' ? parseInt(mainPrimary) : '',
                            selectedPrimaryChapterId: mainPrimary != '' ? parseInt(mainPrimary) : '',
                            selectedPrimaryChapterIdList: primaryChapterListTemp.length > 0 ? primaryChapterListTemp : [],
                            area: data.data[0]['StallArea'] != null ? data.data[0]['StallArea'] : '',

                            ExhPrimaryUndertakingCompanyName: data.data[0]['ExhPrimaryUndertakingCompanyName'] != null ? data.data[0]['ExhPrimaryUndertakingCompanyName'] : '',
                            ExhPrimaryUndertakingDesignation: data.data[0]['ExhPrimaryUndertakingDesignation'] != null ? data.data[0]['ExhPrimaryUndertakingDesignation'] : '',
                            ExhPrimaryUndertakingEmail: data.data[0]['ExhPrimaryUndertakingEmail'] != null ? data.data[0]['ExhPrimaryUndertakingEmail'] : '',
                            ExhPrimaryUndertakingPersonName: data.data[0]['ExhPrimaryUndertakingPersonName'] != null ? data.data[0]['ExhPrimaryUndertakingPersonName'] : '',
                            ExhPrimaryChapterComment: data.data[0]['ExhPrimaryChapterComment'] != null ? data.data[0]['ExhPrimaryChapterComment'] : '',
                            ExhPrimaryUndertakingMobileNo: data.data[0]['ExhPrimaryUndertakingMobileNo'] != null ? data.data[0]['ExhPrimaryUndertakingMobileNo'].split('-').length == 2 ? data.data[0]['ExhPrimaryUndertakingMobileNo'].split('-')[1] : data.data[0]['ExhPrimaryUndertakingMobileNo'].split('-')[0] : '',
                            PreExhPrimaryUndertakingMobileNo: data.data[0]['ExhPrimaryUndertakingMobileNo'] != null ? data.data[0]['ExhPrimaryUndertakingMobileNo'].split('-').length == 2 ? data.data[0]['ExhPrimaryUndertakingMobileNo'].split('-')[0] : '' : '',
                            minAreafor4OpenSide: data.data[0]['minAreafor4OpenSide'] != null ? data.data[0]['minAreafor4OpenSide'] : '',
                            isMixRuleAgree: data.data[0]['IsMixRuleAgree'] != null ? data.data[0]['IsMixRuleAgree'] : false,


                            // primaryChapterRadio : data.data[0]['PrimaryChapter']
                        })
                        for (var i = 0; i < stallAreaList.length; i++) {
                            if (stallAreaList[i].Code == data.data[0]['ExhibitionStallSizeID']) {
                                console.log('Description : ', stallAreaList[i].Description);
                                this.setState({ stallAreaName: stallAreaList[i].Description, })
                            }
                        }
                    }
                    if (data.data[0].SSIDocumentPath != null && data.data[0].SSIDocumentPath != '') {
                        var filePath = data.data[0].SSIDocumentPath
                        var array = data.data[0].SSIDocumentPath != null &&
                            data.data[0].SSIDocumentPath != "" && filePath.split("/")
                        const FileName = array[array.length - 1]
                        console.log('filePath', filePath)
                        this.setState({
                            isSSifilePath: filePath,
                            isSSifile: FileName,
                            isSSIdeleted: false,
                        })
                    }
                    if (data.data[0].TMMA_ITAMMA_DocumentPath != null && data.data[0].TMMA_ITAMMA_DocumentPath != '') {
                        var filePath = data.data[0].TMMA_ITAMMA_DocumentPath
                        var array = data.data[0].TMMA_ITAMMA_DocumentPath != null &&
                            data.data[0].TMMA_ITAMMA_DocumentPath != "" && filePath.split("/")
                        const FileName = array[array.length - 1]
                        this.setState({
                            TMMAITAMMAfilePath: filePath,
                            TMMAITAMMAfile: FileName,
                            isTMMAITAMMAdeleted: false,
                        })
                    }
                    this.setState({
                        isDoubleStorey: data.data[0].isDoubleStorey,
                        isSSi: data.data[0].isSSICertified,
                        isSSIandTMMAITAMMMA: data.data[0].isSSICertified == true || data.data[0].TMMA_ITAMMA != null ? true : false,
                        doubleStoreyArea: data.data[0].DoubleStoreyArea,
                        TMMAITAMMA: data.data[0].TMMA_ITAMMA != null ? data.data[0].TMMA_ITAMMA == 'TMMA' ? 1 : 2 : '',
                        // TMMAITAMMAfilePath: data.data[0].TMMA_ITAMMA_DocumentPath
                    })
                    setTimeout(() => {
                        // this.setState({ isLoading: false })
                        this.getFillList(primaryChapterListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '', sessionStorage.getItem("sessionExhRegistrationID")).then(() => {
                            var minAreaAsModule = 0
                            for (var i = 0; i < this.state.exhibitDetailsList.length; i++) {
                                if (parseInt(data.data[0]['StallTypeID']) == 1) {
                                    console.log('exhibitDetailsList[i].MinBareArea', this.state.exhibitDetailsList[i].MinBareArea)
                                    if (this.state.exhibitDetailsList[i].MinBareArea != '' && this.state.exhibitDetailsList[i].MinBareArea != null) {
                                        if (minAreaAsModule < this.state.exhibitDetailsList[i].MinBareArea) {
                                            minAreaAsModule = this.state.exhibitDetailsList[i].MinBareArea
                                        }
                                    }
                                } else if (parseInt(data.data[0]['StallTypeID']) == 2) {
                                    if (this.state.exhibitDetailsList[i].MinShellArea != '' && this.state.exhibitDetailsList[i].MinShellArea != null) {
                                        if (minAreaAsModule < this.state.exhibitDetailsList[i].MinShellArea) {
                                            minAreaAsModule = this.state.exhibitDetailsList[i].MinShellArea
                                        }
                                    }
                                }
                            }
                            console.log("level2.length00000000000000000", parseInt(data.data[0]['StallTypeID']), minAreaAsModule, this.state.exhibitDetailsList)

                            this.getFillList(stallSizeActionId, sessionStorage.getItem("sessionExhibitionID"), minAreaAsModule == 0 ? '' : minAreaAsModule, data.data[0]['StallTypeID'], countryId, '')
                            this.getFillList(fullStallAreaActionId, sessionStorage.getItem("sessionExhibitionID"), '', 1, countryId, '')
                            this.setState({ isLoading: false })
                        })
                        Promise.all([
                            this.getFillList(primaryChapterListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '', sessionStorage.getItem("sessionExhRegistrationID")),
                            this.getFillList(lengthActionId, sessionStorage.getItem("sessionExhibitionID"), '', data.data[0]['StallTypeID'], sessionStorage.getItem("countryId"), ''),
                            this.getFillList(breadthActionId, sessionStorage.getItem("sessionExhibitionID"), '', data.data[0]['StallTypeID'], sessionStorage.getItem("countryId"), '')
                        ]).then(() => {
                            if (this.state.isOpenForInternationalForm) {
                                var tempArea = ''
                                var tempAreaId = ''
                                for (var i = 0; i < this.state.stallAreaList.length; i++) {
                                    console.log(' this.state.InternationalFormAreaNew', this.state.stallAreaList[i].StallArea, this.state.InternationalFormAreaNew)
                                    if (this.state.stallAreaList[i].StallArea >= this.state.InternationalFormAreaNew) {
                                        tempArea = this.state.stallAreaList[i].StallArea
                                        tempAreaId = this.state.stallAreaList[i].Code
                                        this.setState({
                                            stallAreaId: this.state.stallAreaList[i].Code,
                                            area: this.state.stallAreaList[i].StallArea,
                                        })
                                        break
                                    }
                                    // else if (this.state.stallAreaList[i].StallArea > this.state.InternationalFormAreaNew) {
                                    //     this.setState({
                                    //         stallAreaId: this.state.stallAreaList[i].Code,
                                    //         area: this.state.stallAreaList[i].StallArea,
                                    //     })
                                    //     break
                                    // }
                                }
                                if (this.state.isOpenForInternationalForm && sessionStorage.getItem("isOpenedForInternationalForm") == null) {
                                    this.generateNewForm(sessionStorage.getItem("sessionExhRegistrationID"), this.state.InternationalFormCountryId, tempAreaId, tempArea)
                                }
                            }
                            console.log('this.state.isOpenForInternationalForm', this.state.stallAreaList, this.state.isOpenForInternationalForm)
                            this.setState({ isLoading: false });
                        }).catch(error => {
                            console.error("Error in getFillList calls:", error);
                            this.setState({ isLoading: false });
                        });

                        const { countryId } = this.state
                        // this.setState({ isLoading: false })

                        console.log("stallAreaId state", stallAreaId)
                        console.log("schemeType state", schemeType)

                    }, 500);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    generateNewForm(exhid, countryid, ExhibitionStallSizeID, StallArea) {
        console.log("code is : ",);
        const { exhRegistrationID, exhRegistrationNo } = this.state;

        this.setState({ isLoading: true });
        return new Promise((resolve, reject) => {
            this.props
                .generateNewForm_action(exhid, sessionStorage.getItem("sessionExhibitionID"), countryid, ExhibitionStallSizeID, StallArea)
                .then((data) => {
                    if (data.error != 1) {
                        console.log(data.data[0][0].ExhRegistrationID)
                        sessionStorage.setItem("sessionExhRegistrationID", parseInt(data.data[0][0].ExhRegistrationID))
                        sessionStorage.setItem("sessionExhRegistrationNo", data.data[0][0].ExhRegistrationNo)
                        this.setState({
                            exhRegistrationID: parseInt(data.data[0][0].ExhRegistrationID),
                            exhRegistrationNo: data.data[0][0].ExhRegistrationNo,
                        })
                        sessionStorage.setItem('isOpenedForInternationalForm', true)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    handleSSIDelete(e) {
        const { isSSIandTMMAITAMMMA } = this.state
        console.log(e)
        e != undefined && e.preventDefault()
        const { isDelOpen, logoImg, exhRegistrationID, isDel1Open, exhibitionID, SSIDocumentPath, isSSifile, isSSIdeleted } = this.state
        this.setState({ isLoading: true })
        this.props.deleteSSicertificate_action(parseInt(exhRegistrationID), parseInt(exhibitionID),)
            .then((data) => {
                if (data.error != 1) {
                    isSSIandTMMAITAMMMA && toastSuccess(" Document Deleted SuccessFully")
                    this.setState({ isLoading: false, isDel1Open: false, isSSifile: "", isSSifilePath: '', isSSIdeleted: true })
                } else {
                    isSSIandTMMAITAMMMA && toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    handleTMMAITAMMADelete(e) {
        const { isSSIandTMMAITAMMMA } = this.state
        e != undefined && e.preventDefault()
        const { isDel2Open, logoImg, exhRegistrationID, isDel1Open, exhibitionID, SSIDocumentPath, isSSifile, isSSIdeleted, TMMAITAMMAfile, isTMMAITAMMAdeleted } = this.state
        this.setState({ isLoading: true })
        this.props.deleteTMMAITAMMA_action(parseInt(exhRegistrationID), parseInt(exhibitionID),)
            .then((data) => {
                if (data.error != 1) {
                    isSSIandTMMAITAMMMA && toastSuccess(" Document Deleted SuccessFully")
                    this.setState({ isLoading: false, isDel2Open: false, TMMAITAMMAfile: "", TMMAITAMMAfilePath: '', isTMMAITAMMAdeleted: true })
                } else {
                    isSSIandTMMAITAMMMA && toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    handleChapterDocDelete(e) {
        const { isSSIandTMMAITAMMMA, delChapterID, exhibitDetailsList, } = this.state
        e != undefined && e.preventDefault()
        const { isDel2Open, logoImg, exhRegistrationID, isDel1Open, exhibitionID, SSIDocumentPath, isSSifile, isSSIdeleted, TMMAITAMMAfile, isTMMAITAMMAdeleted } = this.state
        this.setState({ isLoading: true })
        this.props.deleteChapterDoc_action(parseInt(exhRegistrationID), parseInt(exhibitionID), delChapterID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess(" Document Deleted SuccessFully")
                    exhibitDetailsList.map(item => {
                        if (item.ChapterID == delChapterID) {
                            item.DocumentName = ''
                            item.DocumentType = ''
                            item.DocumentFile = ''
                            item.DocumentPath = ''
                            item.DocDeleted = true
                        }
                    })
                    this.setState({ isLoading: false, isDel3Open: false, exhibitDetailsList: exhibitDetailsList })
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    onSSIDocDelete() {
        const { isDel1Open } = this.state
        this.setState({ isDel1Open: !isDel1Open })
    }
    onTMMAITAMMADocDelete() {
        const { isDel2Open } = this.state
        this.setState({ isDel2Open: !isDel2Open })
    }

    onChapterDocDelete(id, i) {
        const { isDel3Open, exhibitDetailsList } = this.state
        console.log(id)
        if (!exhibitDetailsList[i].DocDeleted) {
            this.setState({ isDel3Open: !isDel3Open, delChapterID: id })
        } else {
            exhibitDetailsList[i].DocumentType = ''
            exhibitDetailsList[i].DocumentFile = ''
            exhibitDetailsList[i].DocumentName = ''
            this.setState({ exhibitDetailsList: exhibitDetailsList })
        }

    }

    preventMinus = (e) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }

    handleClickSelectPrimaryChapter(data, id) {
        const { primaryChapterRadio, primaryChapterListData, selectedPrimaryChapterId, isOpenAgree, selectedPrimaryChapterIdList, isShowHighlightChapters, level2 } = this.state
        data.IsSelect = !data.IsSelect
        // data.isChecked = !data.IsSelect
        var listData = [...primaryChapterListData]
        if (id != '') {
            for (var i = 0; i < listData.length; i++) {
                if (listData[i].ChapterID == id) {
                    if (listData[i].isChecked == true) {
                        console.log("p1")
                        listData[i].isChecked = false;
                        for (var j = 0; j < selectedPrimaryChapterIdList.length; j++) {
                            if (selectedPrimaryChapterIdList[j] == listData[i].ChapterID) {
                                selectedPrimaryChapterIdList.splice(j, 1)
                            }
                        }
                        this.setState({
                            selectedPrimaryChapterIdList: selectedPrimaryChapterIdList,
                        })
                        this.setState({
                            selectedPrimaryChapterId: selectedPrimaryChapterIdList.length == 1 ? selectedPrimaryChapterIdList[0] : selectedPrimaryChapterIdList.length > 1 ? parseInt(id) != parseInt(selectedPrimaryChapterId) ? selectedPrimaryChapterId : "" : '',
                            primaryChapterRadio: selectedPrimaryChapterIdList.length == 1 ? selectedPrimaryChapterIdList[0] : selectedPrimaryChapterIdList.length > 1 ? parseInt(id) != parseInt(primaryChapterRadio) ? primaryChapterRadio : "" : '',
                        })
                    } else {
                        console.log("p2")
                        selectedPrimaryChapterIdList.push(listData[i].ChapterID)
                        listData[i].isChecked = true;
                        this.setState({
                            selectedPrimaryChapterId: selectedPrimaryChapterIdList.length == 1 ? id : selectedPrimaryChapterIdList.includes(1382) ? 1382 : '',
                            primaryChapterRadio: selectedPrimaryChapterIdList.length == 1 ? id : selectedPrimaryChapterIdList.includes(1382) ? 1382 : '',
                            primaryChapterIdErr: '',
                            selectedPrimaryChapterIdList: selectedPrimaryChapterIdList
                        })
                    }
                }
            }
            console.log('updated list : ', this.state.selectedPrimaryChapterId, this.state.primaryChapterRadio, selectedPrimaryChapterIdList, listData);
            if (listData) {
                listData.sort((a, b) =>
                    a.ChapterName.toLowerCase().localeCompare(b.ChapterName.toLowerCase())
                );
                this.setState({
                    primaryChapterListData: listData,
                })
            }
            var lev2List = [...level2]
            console.log('isShowHighlightChapters', isShowHighlightChapters)
            if (isShowHighlightChapters) {
                var parentIDArr = []
                for (var j = 0; j < listData.length; j++) {
                    if (listData[j].isChecked == true) {
                        parentIDArr.push(listData[j].ChapterID == 2033 ? 2046 : listData[j].ChapterID)
                    }
                }
                for (var i = 0; i < lev2List.length; i++) {
                    if (lev2List[i].ParentChapterIDs != null) {
                        var isParent = false
                        var ParentChapterIDs = lev2List[i].ParentChapterIDs.split(',')
                        for (var j = 0; j < ParentChapterIDs.length; j++) {
                            ParentChapterIDs[j] = parseInt(ParentChapterIDs[j])
                        }
                        for (var j = 0; j < ParentChapterIDs.length; j++) {
                            if (parentIDArr.includes(ParentChapterIDs[j])) {
                                console.log(ParentChapterIDs)
                                isParent = true
                                lev2List[i]['isHighlight'] = true;
                            }
                        }
                        if (!isParent) {
                            lev2List[i]['isHighlight'] = false;
                        }
                    } else {
                        var isParent = false
                        if (parentIDArr.includes(lev2List[i].ParentChapterID)) {
                            isParent = true
                            lev2List[i]['isHighlight'] = true;
                        }
                        if (!isParent) {
                            lev2List[i]['isHighlight'] = false;
                        }
                    }
                }
            }
            // primaryChapterListData.filter(item => item.isChecked).length > 1 && !isOpenAgree && this.setState({
            //     open: true
            // })
            primaryChapterListData.filter(item => item.isChecked).length > 1 ? this.setState({
                isOpenAgree: true
            }) : this.setState({
                isOpenAgree: false
            })
            this.setState({
                level2: lev2List,
            })
        }


        // if (selectedPrimaryChapterIdList.length == 1) {
        //     this.setState({
        //         defaultprimaryChapterIdErr: ''
        //     })
        // }
        // this.setState({ primaryChapterRadio: id == 2033 ? 2046 : id })
        // primaryChapterListData.length > 0 && primaryChapterListData.map(data => {
        //     if (data.ChapterID == id) {
        //         data.IsSelect = !data.IsSelect
        //         this.setState({ primaryChapterListData : primaryChapterListData})

        //     }
        // })

    }

    // onClickOpenSideRadio(value) {
    //     const { openSlides } = this.state
    //     if (value == 'openSlides3') {
    //         this.setState({ openSlides: 'openSlides3' })
    //     }
    //     else  if (value == 'openSlides1') {
    //         this.setState({ openSlides: 'openSlides1' })
    //     }
    //     else  if (value == 'openSlides2') {
    //         this.setState({ openSlides: 'openSlides2' })
    //     }
    // }


    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
        // object.target.value.length == maxLength &&
        //   setTimeout(() => {
        //     this.contactAadhaarValidation()
        //   }, 200);
    }

    handleStep2Insert(mode) {
        const { selectedPrimaryChapterId, countryList, internationalAreaSlabList, area, exhibitionID, exhRegistrationID, stallAreaId, schemeType, openSlides, ExhPrimaryChapterComment, stallAreaList, isShowInternationalArea, referenceStallAreaArr,
            exhibitDetailsList, isDoubleStorey, isSSi, isAllBro, primaryChapterRadio, isSSIandTMMAITAMMMA, stallAreaIdErr, schemeTypeErr, openSlidesErr, countryId, exhibitDetailsTableErr, lengthWidthErr, stallAreaName, isSSIdeleted, isTMMAITAMMAdeleted, isSSifile, isSSifilePath, isSSifileType, TMMAITAMMAfile, TMMAITAMMAfilePath, TMMAITAMMAfileType, ExhPrimaryChapterCommentErr, PrimaryChapterId, level0, level2, level3, level4, primaryChapterListData,
            ExhPrimaryUndertakingPersonName, ExhPrimaryUndertakingDesignation, PreExhPrimaryUndertakingMobileNo, ExhPrimaryUndertakingCompanyName, ExhPrimaryUndertakingEmail, isOpenAgree, ExhPrimaryUndertakingMobileNo, selectedPrimaryChapterIdList, InternationalArea, InternationalAreaErr } = this.state
        // if(stallAreaId == '' ||  schemeType == '' || openSlides == ''){
        //     toastError("Please select mandatory fields.");
        //     return;
        // }
        return new Promise((resolve, reject) => {
            const array = []
            const sortHighlightList = level2.filter(item => item.isHighlight)
            console.log("sortHighlightList2", sortHighlightList)
            for (let i = 0; i < sortHighlightList.length; i++) {
                for (let j = 0; j < level3.length; j++) {
                    if (sortHighlightList[i]['ChapterID'] == level3[j]['ParentChapterID']) {
                        array.push(level3[j])
                        for (let k = 0; k < level4.length; k++) {
                            if (level3[j]['ChapterID'] == level4[k]['ParentChapterID']) {
                                array.push(level4[k])
                            }
                        }
                    }
                }
            }
            const checkedHighlightSelected = array.some(item => item.IsSelect)
            console.log("checkedHighlightSelected--------------->", checkedHighlightSelected)
            var iserror = false;
            if (this.state.selectedPrimaryChapterIdList.length == 1) {
                this.setState({ defaultprimaryChapterIdErr: '' })
            }
            if (selectedPrimaryChapterId == null || selectedPrimaryChapterId == '') {
                if (this.state.selectedPrimaryChapterIdList.length > 1) {
                    this.setState({ defaultprimaryChapterIdErr: 'Please select default primary chapter.' })
                    console.log("1")
                } else {
                    this.setState({ primaryChapterIdErr: 'Please select primary chapter.' })
                    console.log("2")
                }
                iserror = true;
            }
            console.log(selectedPrimaryChapterId, selectedPrimaryChapterIdList, primaryChapterRadio)
            if (stallAreaId == null || stallAreaId == '') {
                this.setState({ stallAreaIdErr: 'Please select stall area.' })
                iserror = true;
            }
            if (schemeType == null || schemeType == '') {
                this.setState({ schemeTypeErr: 'Please select scheme type.' })
                iserror = true;
            }
            if (openSlides == null || openSlides == '') {
                this.setState({ openSlidesErr: 'Please select open side.' })
                iserror = true;
            }
            if (exhibitDetailsList == null || exhibitDetailsList.length == 0) {
                this.setState({ exhibitDetailsTableErr: 'Please select atleast one chapter' })
                iserror = true;
            }
            if (isDoubleStorey) {
                if (this.state.doubleStoreyArea == '' || this.state.doubleStoreyArea == null) {
                    this.setState({ doubleStoreyAreaErr: 'Please fill Double storey area' })
                    iserror = true;
                }
            }
            var isSSIfile = null
            var isSSIfileType = null
            var TMMA_ITAMMAfile = null
            var TMMA_ITAMMAfiletype = null
            if (isSSi) {

                if (this.state.isSSifile == '' || this.state.isSSifile == null) {
                    this.setState({ isSSifileErr: 'Please upload SSI certificate' })
                    iserror = true;
                }
                else {
                    isSSIfile = this.state.isSSifile
                    isSSIfileType = this.state.isSSifileType
                    // this.setState({ isSSifilePath: '' })
                }
                if (this.state.TMMAITAMMA != '' && this.state.TMMAITAMMA != null) {
                    if (this.state.TMMAITAMMAfile == '' || this.state.TMMAITAMMAfile == null) {
                        this.setState({ TMMAITAMMAfileErr: 'Please upload TMMA or ITAMMA certificate' })
                        iserror = true;
                    }
                    else {
                        TMMA_ITAMMAfile = this.state.TMMAITAMMAfile
                        TMMA_ITAMMAfiletype = this.state.TMMAITAMMAfileType
                        // this.setState({ TMMAITAMMAfilePath: '' })
                    }
                }
                else {
                    TMMA_ITAMMAfile = null
                    TMMA_ITAMMAfiletype = null
                    this.setState({ TMMAITAMMAfilePath: '' })
                }
            }
            else {
                isSSIfile = null
                isSSIfileType = null
                this.setState({ isSSifilePath: '' })
            }

            var lenerr = ''
            var isSSIvalidAndTable = true
            const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
            const filterArrayNational = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
            var isIntBrochure = filterArray.some((item) => !item.isMachine && (item.isBrochure || item.IsAccessory))
            // var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            // var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            var totalNational = filterArrayNational.length > 0 ? filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0) : area - InternationalArea
            var remArea = area - InternationalArea
            if (remArea > totalNational) {
                totalNational = remArea
            }
            console.log(filterArray, filterArrayNational)
            console.log(this.state.InternationalArea, (area - InternationalArea), sessionStorage.getItem("countryId") == 91, totalArea, area, '...', filterArrayNational)

            if (sessionStorage.getItem("countryId") == 91 && filterArray.length > 0) {
                if (!this.state.isMixRuleAgree) {
                    this.setState({ intAreaRulesPop: true })
                    return
                }

                var inLimit = false
                var totalArea = totalNational + InternationalArea
                var natAreaErr = false

                // if (!isAllBro) {
                if (schemeType == 1) {
                    if (totalNational < 27) {
                        totalArea = InternationalArea + 27
                        natAreaErr = true
                    }
                } else if (schemeType == 2) {
                    if (totalNational < 18) {
                        totalArea = InternationalArea + 18
                        natAreaErr = true
                    }
                }
                var isNatinSlag = false
                for (var j = 0; j < stallAreaList.length; j++) {
                    if (totalNational == stallAreaList[j].StallArea) {
                        isNatinSlag = true
                        break
                    }
                }
                if (!isNatinSlag) {
                    var temptptal = totalArea
                    for (var i = 0; i < stallAreaList.length; i++) {
                        if (totalNational <= stallAreaList[i].StallArea) {
                            temptptal = InternationalArea + stallAreaList[i].StallArea
                            for (var j = 0; j < stallAreaList.length; j++) {
                                if (temptptal == stallAreaList[j].StallArea) {
                                    inLimit = true
                                    this.setState({
                                        expectedArea: stallAreaList[j].StallArea, expectedAreaId: stallAreaList[j].Code, isOpen10: true
                                        // natAreaErr: true 
                                    })
                                    return
                                }
                            }
                        }
                    }
                    if (!inLimit) {
                        if (this.state.schemeType == 2) {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than Shell space limit. Kindly switch to Bare space' })
                            lenerr = 'Total sum of area is more than Shell space limit. Kindly switch to Bare space'
                        } else {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than limit. Kindly change to accomodate within space limits or contact  ITME 2026 Exhibition Team' })
                            lenerr = 'Total sum of area is more than limit. Kindly change to accomodate within space limits or contact  ITME 2026 Exhibition Team'
                        }
                    }
                    iserror = true;
                }
                // }
                console.log(totalArea, InternationalArea, totalNational, 'totalNationaltotalNationaltotalNational')
                if (natAreaErr) {
                    for (var i = 0; i < stallAreaList.length; i++) {
                        if (totalArea <= stallAreaList[i].StallArea) {
                            inLimit = true
                            this.setState({
                                expectedArea: stallAreaList[i].StallArea, expectedAreaId: stallAreaList[i].Code, isOpen4: true, areaValidationPopFlag: 3,
                                // natAreaErr: true 
                            })
                            return
                        }
                    }
                    if (!inLimit) {
                        if (this.state.schemeType == 2) {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than Shell space limit. Kindly switch to Bare space' })
                            lenerr = 'Total sum of area is more than Shell space limit. Kindly switch to Bare space'
                        } else {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than limit. Kindly change to accomodate within space limits or contact  ITME 2026 Exhibition Team' })
                            lenerr = 'Total sum of area is more than limit. Kindly change to accomodate within space limits or contact  ITME 2026 Exhibition Team'
                        }
                    }
                    iserror = true;
                }
                else {

                    if (totalArea > area) {
                        for (var i = 0; i < stallAreaList.length; i++) {
                            if (totalArea <= stallAreaList[i].StallArea) {
                                inLimit = true
                                this.setState({ expectedArea: stallAreaList[i].StallArea, expectedAreaId: stallAreaList[i].Code, isOpen4: true, areaValidationPopFlag: InternationalArea > area ? 1 : 2 })
                                return
                            }
                        }
                        if (!inLimit) {
                            if (this.state.schemeType == 2) {
                                this.setState({ lengthWidthErr: 'Total sum of area is more than Shell space limit. Kindly switch to Bare space' })
                                lenerr = 'Total sum of area is more than Shell space limit. Kindly switch to Bare space'
                            } else {
                                this.setState({ lengthWidthErr: 'Total sum of area is more than limit. Kindly change to accomodate within space limits' })
                                lenerr = 'Total sum of area is more than limit. Kindly change to accomodate within space limits'
                            }
                        }
                        // this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
                        iserror = true;
                    }
                }

                // if (totalInternational != 0) {
                //     if (area >= totalInternational) {
                //         this.setState({ lengthWidthErr: '' })
                //     } else {
                //         this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
                //         iserror = true;
                //     }
                // } else {
                //     var remArea = 0
                //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
                //         // console.log('internationalAreaSlabList[i].FromRange', internationalAreaSlabList[i].FromRange, area)
                //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
                //             remArea = area - internationalAreaSlabList[i].MinArea
                //             // total = internationalAreaSlabList[i].MinArea
                //         }
                //     }
                //     if (remArea < (totalInternational + totalNational)) {
                //         this.setState({ lengthWidthErr: "Total sum of area cannot be greater than remaining stall area" })
                //         iserror = true;
                //         // isSSIvalidAndTable = false
                //     } else {
                //         this.setState({ lengthWidthErr: '' })
                //     }
                // }
            } else {
                var totalArea = exhibitDetailsList.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                if (area < totalArea) {
                    var inLimit = false
                    // this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
                    for (var i = 0; i < stallAreaList.length; i++) {
                        if (totalArea < stallAreaList[i].StallArea) {
                            inLimit = true
                            this.setState({ expectedArea: stallAreaList[i].StallArea, expectedAreaId: stallAreaList[i].Code, isOpen4: true, areaValidationPopFlag: 2 })
                            return
                        }
                    }
                    if (!inLimit) {
                        if (this.state.schemeType == 2) {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than Shell space limit. Kindly switch to Bare space' })
                            lenerr = 'Total sum of area is more than Shell space limit. Kindly switch to Bare space'
                        } else {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than limit. Kindly change to accomodate within space limits' })
                            lenerr = 'Total sum of area is more than limit. Kindly change to accomodate within space limits'
                        }
                    }
                    iserror = true;
                } else {
                    this.setState({ lengthWidthErr: '' })
                    lenerr = ''
                }
            }

            for (var i = 0; i < exhibitDetailsList.length; i++) {
                if (exhibitDetailsList[i].ManufacturingCountry != '' && exhibitDetailsList[i].ManufacturingCountry != null) {
                    if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india') {
                        if (this.state.isSSi) {
                            toastError("SSI is not applicable for Mixed Exhibitors")
                            isSSIvalidAndTable = false
                        }
                    }
                }
            }
            // return
            if (!isSSIvalidAndTable) {
                return
            }
            // if (exhibitDetailsList.length > 0 && stallAreaName != null && stallAreaName != '') {
            //     for (var i = 0; i < exhibitDetailsList.length; i++) {
            //         if (exhibitDetailsList[i].Length != null && exhibitDetailsList[i].Length != 0 && exhibitDetailsList[i].Breadth != null && exhibitDetailsList[i].Breadth != 0) {
            //             var totalSpace;
            //             var totalEnterSpace;
            //             var lengthWidthList
            //             if (stallAreaName.includes('x')) {
            //                 lengthWidthList = stallAreaName.split('x');
            //             } else if (stallAreaName.includes('X')) {
            //                 lengthWidthList = stallAreaName.split('X');
            //             }
            //             totalSpace = parseFloat(lengthWidthList[0]) * parseFloat(lengthWidthList[1]);
            //             totalEnterSpace = parseFloat(exhibitDetailsList[i].Length) * parseFloat(exhibitDetailsList[i].Breadth);
            //             if (totalEnterSpace > totalSpace) {
            //                 this.setState({ lengthWidthErr: 'Length and breadth must be below or equal to stall area.' })
            //                 return;
            //             } 
            //             else {
            //                 this.setState({ lengthWidthErr: '' })
            //             }
            //         }

            //         //check for heaight....................................
            //         // if (exhibitDetailsList[i].Height != null && exhibitDetailsList[i].Height != '' && exhibitDetailsList[i].Height != 0 && exhibitDetailsList[i].Height > 3) {
            //         //     this.setState({ lengthWidthErr: 'Height must be less than or equal to 3.' })
            //         //     return;
            //         // } else {
            //         //     this.setState({ lengthWidthErr: '' })
            //         // }
            //     }
            // }


            // debugger
            // var prodList = []
            // for (var i = 0; i < exhibitDetailsList.length; i++) {
            //     // console.log("onEnterProductName validate : ", index, ' ', i, ' ', exhibitDetailsList[i].ChapterName.toString().trim().toLowerCase(), ' ', e.target.value.toString().trim().toLowerCase())
            //     if (!prodList.includes(exhibitDetailsList[i].ChapterName.toString().trim().toLowerCase())) {
            //         prodList.push(exhibitDetailsList[i].ChapterName.toString().trim().toLowerCase())
            //     } else {
            //         this.setState({ lengthWidthErr: 'Product name must be unique.' })
            //         lenerr = 'Product name must be unique.'
            //         iserror = true;
            //     }
            // }
            if (iserror) {
                setTimeout(() => {
                    toastError(lenerr != '' ? lenerr : "Please fill mandatory fields")
                }, 500);
                return
            }


            var list = []
            var concatedChapterList = level0.concat(level0, level2, level3, level4)
            //first add with chapter id available data..............
            exhibitDetailsList.map(data => {
                if (data.ChapterID != 0) {
                    var data = {
                        "ExhibitionID": parseInt(exhibitionID),
                        "ExhRegistrationID": exhRegistrationID,
                        "ChapterID": data.ChapterID,
                        'ChapterName': data.ChapterName,
                        "HSNCode": data.HSNCode,
                        "CompanyEmail": data.CompanyEmail,
                        "registrationHQaddress": data.registrationHQaddress,
                        "MachineDetails": data.MachineDetails,
                        "Length": !data.isMachine ? 0 : data.Length,
                        "Breadth": !data.isMachine ? 0 : data.Breadth,
                        "Height": !data.isMachine ? 0 : data.Height,
                        "FloorCapacity": !data.isMachine ? 0 : data.FloorCapacity,
                        "MachineWeight": !data.isMachine ? 0 : data.MachineWeight,
                        "ManufacturerName": data.ManufacturerName,
                        "ManufacturingCountry": data.ManufacturingCountry,
                        'isMachine': data.isMachine,
                        'isBrochure': data.isBrochure,
                        'IsAccessory': data.IsAccessory,
                        'DocumentFile': data.DocumentFile,
                        'DocumentName': data.DocumentName,
                        'DocumentPath': data.DocumentPath,
                        'DocumentType': data.DocumentType,
                        'DocDeleted': data.DocDeleted,
                        SinglePhasePower: data.SinglePhasePower == null ? 0 : data.SinglePhasePower,
                        ThreePhasePower: data.ThreePhasePower == null ? 0 : data.ThreePhasePower,
                        WaterConsumption: data.WaterConsumption == null ? 0 : data.WaterConsumption,
                        InletQuantity: data.InletQuantity == null ? 0 : data.InletQuantity,
                        OutletQuantity: data.OutletQuantity == null ? 0 : data.OutletQuantity,
                        BarQuantity: data.BarQuantity == null ? 0 : data.BarQuantity,
                        CFMQuantity: data.CFMQuantity == null ? 0 : data.CFMQuantity,
                        MaxCompressedAir: data.MaxCompressedAir == null ? 0 : data.MaxCompressedAir,
                        errArr: data.errArr,
                        'ShellScheme': data.ShellScheme != '' && data.ShellScheme != null ? data.ShellScheme : null,
                        'CalculatedArea': data.CalculatedArea != '' && data.CalculatedArea != null ? data.CalculatedArea : null,

                    }
                    list.push(data)
                }
            })
            //then without chapter id data...................................
            exhibitDetailsList.map(data => {
                if (data.ChapterID == 0 && data.ChapterName != null && data.ChapterName != '') {
                    var data = {
                        "ExhibitionID": parseInt(exhibitionID),
                        "ExhRegistrationID": exhRegistrationID,
                        "ChapterID": data.ChapterID,
                        'ChapterName': data.ChapterName,
                        "HSNCode": data.HSNCode,
                        "CompanyEmail": data.CompanyEmail,
                        "registrationHQaddress": data.registrationHQaddress,
                        "MachineDetails": data.MachineDetails,
                        "Length": !data.isMachine ? 0 : data.Length,
                        "Breadth": !data.isMachine ? 0 : data.Breadth,
                        "Height": !data.isMachine ? 0 : data.Height,
                        "FloorCapacity": !data.isMachine ? 0 : data.FloorCapacity,
                        "MachineWeight": !data.isMachine ? 0 : data.MachineWeight,
                        "ManufacturerName": data.ManufacturerName,
                        "ManufacturingCountry": data.ManufacturingCountry,
                        'isMachine': data.isMachine,
                        'isBrochure': data.isBrochure,
                        'IsAccessory': data.IsAccessory,
                        'DocumentFile': data.DocumentFile,
                        'DocumentName': data.DocumentName,
                        'DocumentPath': data.DocumentPath,
                        'DocumentType': data.DocumentType,
                        'DocDeleted': data.DocDeleted,
                        SinglePhasePower: data.SinglePhasePower == null ? 0 : data.SinglePhasePower,
                        ThreePhasePower: data.ThreePhasePower == null ? 0 : data.ThreePhasePower,
                        WaterConsumption: data.WaterConsumption == null ? 0 : data.WaterConsumption,
                        InletQuantity: data.InletQuantity == null ? 0 : data.InletQuantity,
                        OutletQuantity: data.OutletQuantity == null ? 0 : data.OutletQuantity,
                        BarQuantity: data.BarQuantity == null ? 0 : data.BarQuantity,
                        CFMQuantity: data.CFMQuantity == null ? 0 : data.CFMQuantity,
                        MaxCompressedAir: data.MaxCompressedAir == null ? 0 : data.MaxCompressedAir,
                        errArr: data.errArr,
                        'ShellScheme': data.ShellScheme != '' && data.ShellScheme != null ? data.ShellScheme : null,
                        'CalculatedArea': data.CalculatedArea != '' && data.CalculatedArea != null ? data.CalculatedArea : null,
                    }
                    list.push(data)
                }
            })
            var chapterSelecterr = true
            for (var i = 0; i < list.length; i++) {
                var currentChpId = list[i].ChapterID
                concatedChapterList.map((item1) => {
                    if (item1.ChapterID == currentChpId) {
                        if (item1.primaryChapterId == primaryChapterRadio) {
                            chapterSelecterr = false
                        }
                        console.log(primaryChapterRadio, item1, 'list', list, exhibitDetailsList, chapterSelecterr)
                    }
                })
            }
            var primaryChapterList = []
            var multiselectErr = false
            primaryChapterListData.length > 0 && primaryChapterListData.map(item => {
                if (item.isChecked) {
                    primaryChapterList.push(item)
                }
            })
            if (primaryChapterList.length > 1) {
                // emailValidator(ExhPrimaryUndertakingEmail) != '' && this.setState({ ExhPrimaryUndertakingEmailErr: emailValidator(ExhPrimaryUndertakingEmail) })
                // multiselectErr = emailValidator(ExhPrimaryUndertakingEmail) != '' ? true : false
                // if (ExhPrimaryUndertakingPersonName == '' || ExhPrimaryUndertakingPersonName == null) {
                //     this.setState({ ExhPrimaryUndertakingPersonNameErr: 'Please enter Person Name' })
                //     multiselectErr = true
                // }
                // if (ExhPrimaryUndertakingMobileNo == '' || ExhPrimaryUndertakingMobileNo == null) {
                //     this.setState({ ExhPrimaryUndertakingMobileNoErr: 'Please enter Person Mobile' })
                //     multiselectErr = true
                // }
                // if (ExhPrimaryUndertakingEmail == '' || ExhPrimaryUndertakingEmail == null) {
                //     this.setState({ ExhPrimaryUndertakingEmailErr: 'Please enter Person Email' })
                //     multiselectErr = true
                // }
                // if (ExhPrimaryUndertakingDesignation == '' || ExhPrimaryUndertakingDesignation == null) {
                //     this.setState({ ExhPrimaryUndertakingDesignationErr: 'Please enter Person Designation' })
                //     multiselectErr = true
                // }
                // if (ExhPrimaryUndertakingCompanyName == '' || ExhPrimaryUndertakingCompanyName == null) {
                //     this.setState({ ExhPrimaryUndertakingCompanyNameErr: 'Please enter Exhibitor Company Name' })
                //     multiselectErr = true
                // }
                if (ExhPrimaryChapterComment == '' || ExhPrimaryChapterComment == null) {
                    this.setState({ ExhPrimaryChapterCommentErr: 'Please Enter Primary Chapter Comment' })
                    multiselectErr = true
                }
            }
            if (!isSSIandTMMAITAMMMA) {
                if (!isSSIdeleted) {
                    this.handleSSIDelete()
                }
                if (!isTMMAITAMMAdeleted) {
                    this.handleTMMAITAMMADelete()
                }
            }
            const isAllManufacturerName = list.every(item => item.ManufacturerName != null && item.ManufacturerName != '')
            const isAllManufacturingCountry = list.every(item => item.ManufacturingCountry != null && item.ManufacturingCountry != '')
            const isAllCompanyEmail = list.every(item => item.CompanyEmail != null && item.CompanyEmail != '')
            const isAllregistrationHQaddress = list.every(item => item.registrationHQaddress != null && item.registrationHQaddress != '')

            const isAllSinglePhasePower = list.every(item => item.SinglePhasePower !== null &&
                item.SinglePhasePower !== undefined &&
                item.SinglePhasePower !== '')
            const isAllThreePhasePower = list.every(item => item.ThreePhasePower !== null &&
                item.ThreePhasePower !== undefined &&
                item.ThreePhasePower !== '')
            const isAllWaterConsumption = list.every(item => item.WaterConsumption !== null &&
                item.WaterConsumption !== undefined &&
                item.WaterConsumption !== '')
            const isAllInletQuantity = list.every(item => item.InletQuantity !== null &&
                item.InletQuantity !== undefined &&
                item.InletQuantity !== '')
            const isAllOutletQuantity = list.every(item => item.OutletQuantity !== null &&
                item.OutletQuantity !== undefined &&
                item.OutletQuantity !== '')
            const isAllBarQuantity = list.every(item =>
                item.BarQuantity !== undefined &&
                item.BarQuantity !== '')
            const isAllCFMQuantity = list.every(item =>
                item.CFMQuantity !== undefined &&
                item.CFMQuantity !== '')
            const isAllMaxCompressedAir = list.every(item => item.MaxCompressedAir !== null &&
                item.MaxCompressedAir !== undefined &&
                item.MaxCompressedAir !== '')

            // var isAllCompanyEmail = true
            // var isAllregistrationHQaddress = true
            // // if (sessionStorage.getItem("countryId") == 91 && filterArray.length > 0) {
            // isAllCompanyEmail = list.every(item => item.CompanyEmail != null && item.CompanyEmail != '')
            // isAllregistrationHQaddress = list.every(item => item.registrationHQaddress != null && item.registrationHQaddress != '')
            // }
            const isAllCountry = list.every(item => item.ManufacturingCountry == sessionStorage.getItem("sessionContryName"))
            const isAllMB = list.every(item => item.isMachine != undefined && item.isBrochure != undefined && item.IsAccessory != undefined ? item.isMachine || item.isBrochure || item.IsAccessory : false)
            const isAllCompanyEmailValid = list.every(
                item => !item.CompanyEmail?.trim() || emailValidator(item.CompanyEmail) == ''
            );
            const isAllBreadth = list.every(item => item.isMachine != undefined && item.isBrochure != undefined && item.IsAccessory != undefined && !item.isMachine && (item.isBrochure || item.IsAccessory) ? true : item.Breadth != null && item.Breadth != '' && item.Breadth != '0' && item.Breadth != 0 && item.Breadth != 'Select')
            const isAllLength = list.every(item => item.isMachine != undefined && item.isBrochure != undefined && item.IsAccessory != undefined && !item.isMachine && (item.isBrochure || item.IsAccessory) ? true : item.Length != null && item.Length != '' && item.Length != '0' && item.Length != 0 && item.Length != 'Select')
            const isAllHeight = list.every(item => item.isMachine != undefined && item.isBrochure != undefined && item.IsAccessory != undefined && !item.isMachine && (item.isBrochure || item.IsAccessory) ? true : item.Height != null && item.Height != '' && item.Height != '0' && item.Height != 0 && item.Height != 'Select')
            list.every(item => console.log(item.Length != null, item.Length != '', item.Length != '0', item.Length != 0, item.Length != 'Select', item.Length))
            // const isAllMachineDoc = list.every(item => item.isMachine != undefined && item.IsAccessory != undefined && (item.isMachine || item.IsAccessory) ? item.DocDeleted ? item.DocumentType != '' && item.DocumentFile != '' : item.DocumentPath != '' : true)
            list.map(item => {
                console.log(item.isMachine != undefined, item.isBrochure != undefined, item.IsAccessory != undefined, item.isMachine, item.isBrochure, item.IsAccessory)
            })
            var DueDateValidation = false
            if (this.state.DueDate != '') {
                if (new Date(this.state.DueDate) < new Date()) {
                    DueDateValidation = true
                }
            }
            if (!isAllCountry) {
                if ((InternationalArea == null || InternationalArea == '') && (this.state.isShowInternationalArea) && sessionStorage.getItem("sessionContryName").toLowerCase().trim() == 'india') {
                    this.setState({ InternationalAreaErr: 'Please select length and breadth against international country inside exhibit details table.' })
                    iserror = true;
                }
            }
            console.log("lengthWidthErr", lengthWidthErr)
            console.log("lengthWidthErr == ''", lengthWidthErr == '')
            console.log("lengthWidthErr != ''", lengthWidthErr != '')


            setTimeout(() => {
                console.log('==>', this.state.isSSifilePath, this.state.isSSifile)
                this.inputValidate()
                if ((stallAreaId == "" && schemeType == "" && openSlides == "" && exhibitDetailsList.length == 0 && this.state.area != '' && this.state.area != null &&
                    stallAreaIdErr != '' && schemeTypeErr != '' && openSlidesErr != '' && exhibitDetailsTableErr != '')
                    // || chapterSelecterr == true
                ) {
                    // if (chapterSelecterr == true) {
                    // toastError("Please select  atleast 1 product of the selected primary chapter")
                    // } else {
                    toastError("Please select mandatory fields")
                    // }
                } else {
                    console.log(isAllCountry, isAllLength, isAllBreadth)
                    if (checkedHighlightSelected) {
                        if (multiselectErr) {
                            toastError("Please Enter Madatory Fields")
                        } else {
                            for (var i = 0; i < exhibitDetailsList.length; i++) {
                                if (!isAllMB) {
                                    exhibitDetailsList.length > 0 && exhibitDetailsList.map((item2, index) => {
                                        if (i == index) {
                                            if (!item2.isMachine && !item2.isBrochure && !item2.IsAccessory) {
                                                if (!item2.errArr.includes('isAllMB')) {
                                                    item2.errArr.push('isAllMB')
                                                }
                                            }
                                        }
                                    })
                                    console.log("-------------------------------------------------------------------mb4", 1)
                                } if (exhibitDetailsList[i].CompanyEmail == '' || exhibitDetailsList[i].CompanyEmail == null) {
                                    if (!exhibitDetailsList[i].errArr.includes('CompanyEmail')) {
                                        exhibitDetailsList[i].errArr.push('CompanyEmail')
                                    }
                                    console.log("-------------------------------------------------------------------mb5", 2, exhibitDetailsList[i].errArr)
                                } if (exhibitDetailsList[i].registrationHQaddress == '' || exhibitDetailsList[i].registrationHQaddress == null) {
                                    if (!exhibitDetailsList[i].errArr.includes('registrationHQaddress')) {
                                        exhibitDetailsList[i].errArr.push('registrationHQaddress')
                                    }
                                    console.log("-------------------------------------------------------------------mb5", 3)
                                } if (exhibitDetailsList[i].ManufacturerName == '' || exhibitDetailsList[i].ManufacturerName == null) {
                                    if (!exhibitDetailsList[i].errArr.includes('ManufacturerName')) {
                                        exhibitDetailsList[i].errArr.push('ManufacturerName')
                                    }
                                    console.log("-------------------------------------------------------------------mb5", 4)
                                } if (exhibitDetailsList[i].ManufacturingCountry == '' || exhibitDetailsList[i].ManufacturingCountry == null) {
                                    if (!exhibitDetailsList[i].errArr.includes('ManufacturingCountry')) {
                                        exhibitDetailsList[i].errArr.push('ManufacturingCountry')
                                    }
                                    console.log("-------------------------------------------------------------------mb6", 5)
                                } if (exhibitDetailsList[i].SinglePhasePower === '' || exhibitDetailsList[i].SinglePhasePower === null) {
                                    if (!exhibitDetailsList[i].errArr.includes('SinglePhasePower')) {
                                        exhibitDetailsList[i].errArr.push('SinglePhasePower')
                                    }
                                    console.log("-------------------------------------------------------------------mb6", 6)
                                } if (exhibitDetailsList[i].ThreePhasePower === '' || exhibitDetailsList[i].ThreePhasePower === null) {
                                    if (!exhibitDetailsList[i].errArr.includes('ThreePhasePower')) {
                                        exhibitDetailsList[i].errArr.push('ThreePhasePower')
                                    }
                                    console.log("-------------------------------------------------------------------mb6", 7)
                                } if (exhibitDetailsList[i].WaterConsumption === '' || exhibitDetailsList[i].WaterConsumption === null) {
                                    if (!exhibitDetailsList[i].errArr.includes('WaterConsumption')) {
                                        exhibitDetailsList[i].errArr.push('WaterConsumption')
                                    }
                                    console.log("-------------------------------------------------------------------mb6", 8)
                                } if (exhibitDetailsList[i].InletQuantity === '' || exhibitDetailsList[i].InletQuantity === null) {
                                    if (!exhibitDetailsList[i].errArr.includes('InletQuantity')) {
                                        exhibitDetailsList[i].errArr.push('InletQuantity')
                                    }
                                    console.log("-------------------------------------------------------------------mb6", 9)
                                } if (exhibitDetailsList[i].OutletQuantity === '' || exhibitDetailsList[i].OutletQuantity === null) {
                                    if (!exhibitDetailsList[i].errArr.includes('OutletQuantity')) {
                                        exhibitDetailsList[i].errArr.push('OutletQuantity')
                                    }
                                    console.log("-------------------------------------------------------------------mb6", 10)
                                }
                                // else if (
                                //     exhibitDetailsList[i].BarQuantity === undefined ||
                                //     exhibitDetailsList[i].BarQuantity === '') {
                                //     console.log('exhibitDetailsList[i].BarQuantity', exhibitDetailsList[i].BarQuantity)
                                //     console.log("-------------------------------------------------------------------mb6", 11)
                                //     this.setState({
                                //         lengthWidthErr: 'Please Select all Bar Quantity'
                                //     })
                                //     iserror = true
                                //     lengthErr = "Please Select all Bar Quantity'"

                                // } else if (
                                //     exhibitDetailsList[i].CFMQuantity === undefined ||
                                //     exhibitDetailsList[i].CFMQuantity === '') {
                                //     console.log("-------------------------------------------------------------------mb6", 12)
                                //     this.setState({
                                //         lengthWidthErr: 'Please Select all CMF Quantity'
                                //     })
                                //     iserror = true
                                //     lengthErr = "Please Select all CMF Quantity"

                                // } 
                                if (exhibitDetailsList[i].MaxCompressedAir === '' || exhibitDetailsList[i].MaxCompressedAir === null) {
                                    if (!exhibitDetailsList[i].errArr.includes('MaxCompressedAir')) {
                                        exhibitDetailsList[i].errArr.push('MaxCompressedAir')
                                    }
                                    console.log("-------------------------------------------------------------------mb6", 13)
                                } if (exhibitDetailsList[i].Length == '' || exhibitDetailsList[i].Length == 0 || exhibitDetailsList[i].Length == null) {
                                    console.log("-------------------------------------------------------------------mb1", 14)
                                    if (this.state.isMachineMandatory ? !(exhibitDetailsList[i].isMachine != undefined && exhibitDetailsList[i].isBrochure != undefined && exhibitDetailsList[i].IsAccessory != undefined && !exhibitDetailsList[i].isMachine && (exhibitDetailsList[i].isBrochure || exhibitDetailsList[i].IsAccessory)) : DueDateValidation && !(exhibitDetailsList[i].isMachine != undefined && exhibitDetailsList[i].isBrochure != undefined && exhibitDetailsList[i].IsAccessory != undefined && !exhibitDetailsList[i].isMachine && (exhibitDetailsList[i].isBrochure || exhibitDetailsList[i].IsAccessory))) {
                                        if (!exhibitDetailsList[i].errArr.includes('Length')) {
                                            exhibitDetailsList[i].errArr.push('Length')
                                        }
                                    }
                                } if (exhibitDetailsList[i].Breadth == '' || exhibitDetailsList[i].Breadth == null || exhibitDetailsList[i].Breadth == 0) {
                                    console.log("-------------------------------------------------------------------mb2", 15)
                                    if (this.state.isMachineMandatory ? !(exhibitDetailsList[i].isMachine != undefined && exhibitDetailsList[i].isBrochure != undefined && exhibitDetailsList[i].IsAccessory != undefined && !exhibitDetailsList[i].isMachine && (exhibitDetailsList[i].isBrochure || exhibitDetailsList[i].IsAccessory)) : DueDateValidation && !(exhibitDetailsList[i].isMachine != undefined && exhibitDetailsList[i].isBrochure != undefined && exhibitDetailsList[i].IsAccessory != undefined && !exhibitDetailsList[i].isMachine && (exhibitDetailsList[i].isBrochure || exhibitDetailsList[i].IsAccessory))) {
                                        if (!exhibitDetailsList[i].errArr.includes('Breadth')) {
                                            exhibitDetailsList[i].errArr.push('Breadth')
                                        }
                                    }
                                } if (exhibitDetailsList[i].Height == '' || exhibitDetailsList[i].Height == null || exhibitDetailsList[i].Height == 0) {
                                    console.log("-------------------------------------------------------------------mb3", 15.2)
                                    if (this.state.isMachineMandatory ? !(exhibitDetailsList[i].isMachine != undefined && exhibitDetailsList[i].isBrochure != undefined && exhibitDetailsList[i].IsAccessory != undefined && !exhibitDetailsList[i].isMachine && (exhibitDetailsList[i].isBrochure || exhibitDetailsList[i].IsAccessory)) : DueDateValidation && !(exhibitDetailsList[i].isMachine != undefined && exhibitDetailsList[i].isBrochure != undefined && exhibitDetailsList[i].IsAccessory != undefined && !exhibitDetailsList[i].isMachine && (exhibitDetailsList[i].isBrochure || exhibitDetailsList[i].IsAccessory))) {
                                        if (!exhibitDetailsList[i].errArr.includes('Height')) {
                                            exhibitDetailsList[i].errArr.push('Height')
                                        }
                                        console.log("-------------------------------------------------------------------mb3", 16)
                                    }
                                }
                            }
                            this.setState({ exhibitDetailsList: exhibitDetailsList })
                            console.log(list, isAllCompanyEmail, isAllregistrationHQaddress)
                            if ((!isAllCountry && (this.state.isShowInternationalArea) && sessionStorage.getItem("sessionContryName").toLowerCase().trim() == 'india') ? InternationalArea == '' : false) {
                                toastError("Please Enter Madatory Fields")
                            } else if (lengthWidthErr != '') {
                                toastError(lengthWidthErr)
                            } else if (!isAllManufacturerName) {
                                toastError("Please Enter all Manufacturer Name")
                            } else if (!isAllManufacturingCountry) {
                                toastError("Please Select all Manufacturer Country")
                            } else if (!isAllMB) {
                                toastError("Please Select Machine/Brochure/Accessories")
                            } else if (!isAllCompanyEmail) {
                                toastError("Please Enter all Company Email")
                            } else if (!isAllregistrationHQaddress) {
                                toastError("Please Enter all Registration Head Quarters address")
                            } else if (!isAllSinglePhasePower) {
                                toastError("Please Enter all Single Phase Power")
                            } else if (!isAllThreePhasePower) {
                                toastError("Please Enter all Three Phase Power")
                            } else if (!isAllWaterConsumption) {
                                toastError("Please Enter all Water Consumption")
                            } else if (!isAllInletQuantity) {
                                toastError("Please Enter all Inlet Quantity")
                            } else if (!isAllOutletQuantity) {
                                toastError("Please Enter all Outlet Quantity")
                            } else if (!isAllCompanyEmailValid) {
                                toastError("Please Enter Valid Company Email")
                            }
                            //  else if (!isAllBarQuantity) {
                            //     toastError("Please Select Bar Quantity")
                            // } else if (!isAllCFMQuantity) {
                            //     toastError("Please Select CMF Quantity")
                            // }
                            else if (!isAllMaxCompressedAir) {
                                toastError("Please Enter all Max Compressed Air")
                            }

                            else {
                                if (this.state.isMachineMandatory ? (!isAllBreadth || !isAllLength || !isAllHeight) : DueDateValidation ? (!isAllBreadth || !isAllLength || !isAllHeight) : false) {
                                    // if (!isAllCountry ? (!isAllBreadth || !isAllLength) : false) {
                                    if (!isAllBreadth) {
                                        toastError("Please Select Breadth")
                                    } else if (!isAllLength) {
                                        toastError("Please Select Length")
                                    } else {
                                        toastError("Please Select Height")
                                    }
                                } else {
                                    this.checksameMFandCountry().then((resflag) => {
                                        // var uniqueManuNameAcc = []
                                        // var uniqueManuNameManuCountry = []
                                        // var uniqueManuNameBro = []
                                        // var uniqueManuNameMachine = []
                                        // if (((this.state.isShowInternationalArea) && sessionStorage.getItem("sessionContryName").toLowerCase().trim() == 'india')) {
                                        //     for (var i = 0; i < list.length; i++) {
                                        //         if (list[i].ManufacturingCountry.toLowerCase().trim() != 'india') {
                                        //             if (list[i].isMachine) {
                                        //                 if (!uniqueManuNameMachine.includes(list[i].ManufacturerName)) {
                                        //                     console.log("listconsolemach", list[i])
                                        //                     for (var j = 0; j < referenceStallAreaArr.length; j++) {
                                        //                         if ((list[i].Breadth * list[i].Length) <= referenceStallAreaArr[j].StallArea && referenceStallAreaArr[j].StallArea >= 18) {
                                        //                             list[i].Area = (list[i].Breadth * list[i].Length)
                                        //                             list[i].CalculatedArea = referenceStallAreaArr[j].StallArea
                                        //                             list[i].ShellScheme = referenceStallAreaArr[j].StallArea > 18 ? 1 : 2
                                        //                             break
                                        //                         }
                                        //                     }
                                        //                     uniqueManuNameMachine.push(list[i].ManufacturerName.toLowerCase().trim())
                                        //                 } else {
                                        //                     for (var j = 0; j < list.length; j++) {
                                        //                         if (list[j].isMachine) {
                                        //                             if (list[j].ManufacturerName.toLowerCase().trim() == list[i].ManufacturerName.toLowerCase().trim()) {
                                        //                                 list[j].Area = list[j].Area + (list[i].Breadth * list[i].Length)
                                        //                                 for (var k = 0; k < referenceStallAreaArr.length; k++) {
                                        //                                     if (list[j].Area <= referenceStallAreaArr[k].StallArea && referenceStallAreaArr[k].StallArea >= 18) {
                                        //                                         list[j].CalculatedArea = referenceStallAreaArr[k].StallArea
                                        //                                         list[j].ShellScheme = referenceStallAreaArr[k].StallArea > 18 ? 1 : 2
                                        //                                         break
                                        //                                     }
                                        //                                 }
                                        //                                 break
                                        //                             }
                                        //                         }
                                        //                     }
                                        //                 }
                                        //             }
                                        //         }
                                        //     }
                                        //     for (var i = 0; i < list.length; i++) {
                                        //         if (list[i].ManufacturingCountry.toLowerCase().trim() != 'india') {
                                        //             if (!list[i].isMachine && list[i].IsAccessory) {
                                        //                 var isSameAcc = false
                                        //                 for (var a = 0; a < uniqueManuNameManuCountry.length; a++) {
                                        //                     if (uniqueManuNameManuCountry[a].ManufacturerName == list[i].ManufacturerName.toLowerCase().trim() && uniqueManuNameManuCountry[a].ManufacturingCountry == list[i].ManufacturingCountry.toLowerCase().trim()) {
                                        //                         isSameAcc = true
                                        //                     }
                                        //                 }
                                        //                 if (uniqueManuNameMachine.includes(list[i].ManufacturerName.toLowerCase().trim())) {
                                        //                     isSameAcc = true
                                        //                 }
                                        //                 if (!uniqueManuNameAcc.includes(list[i].ManufacturerName)) {
                                        //                     uniqueManuNameAcc.push(list[i].ManufacturerName.toLowerCase().trim())
                                        //                 }
                                        //                 if (!isSameAcc) {
                                        //                     console.log("listconsoleacc", list[i])
                                        //                     uniqueManuNameManuCountry.push({ ManufacturerName: list[i].ManufacturerName.toLowerCase().trim(), ManufacturingCountry: list[i].ManufacturingCountry.toLowerCase().trim() })
                                        //                     list[i].CalculatedArea = 18
                                        //                     list[i].ShellScheme = 2
                                        //                 }
                                        //             }
                                        //         }
                                        //     }
                                        //     var noBro = 0
                                        //     for (var i = 0; i < list.length; i++) {
                                        //         if (list[i].ManufacturingCountry.toLowerCase().trim() != 'india') {
                                        //             if (!list[i].isMachine && !list[i].IsAccessory && list[i].isBrochure) {
                                        //                 console.log("listconsolebto", list[i])
                                        //                 if (!uniqueManuNameAcc.includes(list[i].ManufacturerName.toLowerCase().trim()) && !uniqueManuNameMachine.includes(list[i].ManufacturerName.toLowerCase().trim()) && !uniqueManuNameBro.includes(list[i].ManufacturerName.toLowerCase().trim())) {
                                        //                     noBro = noBro + 1
                                        //                     uniqueManuNameBro.push(list[i].ManufacturerName.toLowerCase().trim())
                                        //                 }
                                        //             }
                                        //         }
                                        //     }
                                        //     var totalBroChap = Math.ceil(noBro / 3)
                                        //     console.log('totalBroChap', totalBroChap, noBro)
                                        //     var totalAssigned = 0
                                        //     for (var i = 0; i < list.length; i++) {
                                        //         if (totalAssigned < totalBroChap) {
                                        //             if (!list[i].isMachine && !list[i].IsAccessory && list[i].isBrochure) {
                                        //                 list[i].CalculatedArea = 9
                                        //                 list[i].ShellScheme = 2
                                        //                 totalAssigned = totalAssigned + 1
                                        //             }
                                        //         }
                                        //     }
                                        // }


                                        // var toNewForm = false
                                        // var toNewCountry = ''
                                        // var toNewCountryId = ''
                                        // if (sessionStorage.getItem("sessionContryName").toLowerCase().trim() == 'india') {
                                        //     console.log('toNewForm2')
                                        //     for (var i = 0; i < list.length; i++) {
                                        //         if (list[i].ManufacturingCountry != undefined && list[i].ManufacturingCountry != null && list[i].ManufacturingCountry != '') {
                                        //             console.log('toNewForm3')
                                        //             if (list[i].ManufacturingCountry.toLowerCase().trim() != 'india' && list[i].isMachine) {
                                        //                 console.log('toNewForm')
                                        //                 toNewForm = true
                                        //                 toNewCountry = list[i].ManufacturingCountry.toLowerCase().trim()
                                        //                 break
                                        //             }
                                        //         } else {
                                        //             toastError("Please Enter Manufacturing Country")
                                        //             return
                                        //         }
                                        //     }
                                        //     if (toNewForm && mode != 1) {
                                        //         if (toNewCountry != undefined && toNewCountry != null && toNewCountry != '') {
                                        //             var isMatch = false
                                        //             for (var i = 0; i < countryList.length; i++) {
                                        //                 if (toNewCountry == countryList[i].Description.toLowerCase().trim()) {
                                        //                     isMatch = true
                                        //                     toNewCountryId = countryList[i].Code
                                        //                     break
                                        //                 }
                                        //             }
                                        //             if (isMatch) {
                                        //                 this.setState({
                                        //                     newPopCountry: toNewCountryId,
                                        //                     toNewPop: true
                                        //                 })
                                        //                 return
                                        //             } else {
                                        //                 toastError("Please Enter Proper Manufacturing Country Name")
                                        //                 return
                                        //             }
                                        //         } else {
                                        //             toastError("Please Enter Manufacturing Country")
                                        //             return
                                        //         }
                                        //     }
                                        // }
                                        console.log("listconsole", list)
                                        // return
                                        if (resflag) {
                                            setTimeout(() => {
                                                this.setState({ isLoading: true })
                                                //ExhRegistrationID,ExhibitionStallSizeID,exhRegistrationID
                                                this.props
                                                    .primaryChapterAdd_action(parseInt(exhibitionID),
                                                        parseInt(exhRegistrationID),
                                                        parseInt(stallAreaId),
                                                        this.state.area,
                                                        parseInt(schemeType),
                                                        parseInt(openSlides),
                                                        list,
                                                        parseInt(primaryChapterRadio),
                                                        this.state.isDoubleStorey,
                                                        this.state.isDoubleStorey ? this.state.doubleStoreyArea != '' && this.state.doubleStoreyArea != null ? this.state.doubleStoreyArea : null : null,
                                                        this.state.isSSi,
                                                        isSSIandTMMAITAMMMA ? (this.state.TMMAITAMMA == 1 ? 'TMMA' : this.state.TMMAITAMMA == 2 ? 'ITAMMA' : null) : null,
                                                        sessionStorage.getItem("sessionExhRegistrationNo"),
                                                        isSSIandTMMAITAMMMA ? (this.state.isSSi == true ? isSSIfile : null) : null,
                                                        isSSIandTMMAITAMMMA ? ((this.state.TMMAITAMMA != '' && this.state.TMMAITAMMA != null) ? TMMA_ITAMMAfile : null) : null,
                                                        isSSIandTMMAITAMMMA ? (this.state.isSSi == true ? isSSIfileType : null) : null,
                                                        isSSIandTMMAITAMMMA ? ((this.state.TMMAITAMMA != '' && this.state.TMMAITAMMA != null) ? TMMA_ITAMMAfiletype : null) : null,
                                                        this.state.isSSifilePath,
                                                        this.state.TMMAITAMMAfilePath,
                                                        primaryChapterList,
                                                        ExhPrimaryUndertakingPersonName,
                                                        PreExhPrimaryUndertakingMobileNo != null && PreExhPrimaryUndertakingMobileNo != '' ? `${PreExhPrimaryUndertakingMobileNo}-${ExhPrimaryUndertakingMobileNo}` : ExhPrimaryUndertakingMobileNo,
                                                        ExhPrimaryUndertakingEmail,
                                                        ExhPrimaryUndertakingDesignation,
                                                        ExhPrimaryUndertakingCompanyName,
                                                        ExhPrimaryChapterComment,
                                                        isOpenAgree,
                                                        ((this.state.isShowInternationalArea) && sessionStorage.getItem("sessionContryName").toLowerCase().trim() == 'india') ? InternationalArea : 0,
                                                        sessionStorage.getItem("sessionContryName").toLowerCase().trim() == 'india' ? this.state.isMixRuleAgree : false
                                                    )
                                                    .then((data) => {
                                                        if (data.error != 1) {
                                                            if (mode != 1) {
                                                                sessionStorage.setItem("renderPage", "description")
                                                                // sessionStorage.setItem("IA", InternationalArea)
                                                                this.props.navigate('/description')
                                                                sessionStorage.setItem("fillInternationalForm-description", 1)
                                                            } else {
                                                                sessionStorage.setItem("fillInternationalForm", 1)
                                                                this.setState({
                                                                    toNewPop: false
                                                                })
                                                                resolve(true)
                                                            }
                                                            this.setState({ isLoading: false })
                                                            // this.setState({
                                                            //     countryList: data.data, isLoading: false,
                                                            // })

                                                        }
                                                        else {
                                                            this.setState({ isLoading: false })
                                                            toastError(data.msg)
                                                        }
                                                    })
                                                    .catch((e) => {
                                                        console.log(e);
                                                    });
                                            }, 100);
                                        }
                                    })
                                }
                            }
                        }
                    } else {
                        toastError("Please select atleast one sub chapter of selected primary chapter")
                    }

                }
            }, 200);
        })

    }

    removeIfExists(index, value) {
        const { level4, exhibitDetailsList } = this.state
        for (var i = 0; i < exhibitDetailsList.length; i++) {
            if (index == i) {
                var indexInArr = exhibitDetailsList[i].errArr.indexOf(value)
                if (indexInArr !== -1) {
                    exhibitDetailsList[i].errArr.splice(indexInArr, 1);
                }
            }
        }
        this.setState({ exhibitDetailsList: exhibitDetailsList })
    }

    onPreviousClick() {
        sessionStorage.setItem("renderPage", "registerForm")
        sessionStorage.setItem("registeris_update", true)
        setTimeout(() => {
            this.props.navigate('/registration', { state: { is_update: true } })
        }, 200);
    }


    filterLevelData() {
        const { level2, level3, level4 } = this.state
        return new Promise((resolve, reject) => {
            var newLevel = [...level2]
            for (var i = 0; i < level3.length; i++) {
                var tempLevel4 = [];
                for (var j = 0; j < level4.length; j++) {
                    if (level3[i]['ChapterID'] == level4[j]['ParentChapterID']) {
                        tempLevel4.push(level4[j]);
                    }
                }
                level3[i]['level_four_List'] = tempLevel4;
                // console.log(" level3[i]['level_four_List']", tempLevel4);
            }

            for (var i = 0; i < newLevel.length; i++) {
                var tempLevel3 = [];
                for (var j = 0; j < level3.length; j++) {
                    if (newLevel[i]['ChapterID'] == level3[j]['ParentChapterID']) {
                        tempLevel3.push(level3[j]);
                    }
                }
                newLevel[i]['level_third_List'] = tempLevel3;
                // console.log("level2[i]['level_third_List']", tempLevel3);

            }
            if (this.state.isShowHighlightChapters) {
                for (var i = 0; i < newLevel.length; i++) {
                    if (newLevel[i].ParentChapterID == this.state.primaryChapterRadio) {
                        console.log("level2.lengthprimaryChapterRadioprimaryChapterRadio", newLevel[i])
                        newLevel[i]['isHighlight'] = true;
                    } else {
                        newLevel[i]['isHighlight'] = false;
                    }
                }
            }
            this.setState({
                level2: level2,
            })
            ///////////============
            console.log("level2", newLevel, this.state.primaryChapterListData)
            this.setState({ level2: newLevel }, () => {
                resolve(true)
            })
        })
    }

    // search state
    onManufacturingCountryChange(e, id, index) {
        const { countryList, tempCountryList, area, exhibitDetailsList, SSRCountryList } = this.state;
        var err = false
        console.log('SSRCountryList, id', SSRCountryList, id)
        // if (SSRCountryList.length > 0) {
        //     SSRCountryList.map(item2 => {
        //         if (item2.CountryID == id) {
        //             err = true
        //             this.setState({
        //                 isOpen2: true
        //             })
        //             return
        //         }
        //     })
        // }
        // if (!err) {
        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                this.removeIfExists(i, 'ManufacturingCountry')
                if (e.target.value != "") {
                    var searchStateList = tempCountryList.filter((data) => {
                        return data.Description.toLowerCase().includes(
                            e.target.value.toLowerCase()
                        );
                    });
                    data.ManufacturingCountry = e.target.value
                    this.setState({
                        tempCountryList: searchStateList,
                        isDisplayCountryList: true,
                        manufactureCountryIndex: index
                    });
                } else {
                    data.ManufacturingCountry = e.target.value
                    this.setState({
                        tempCountryList: countryList,
                        isDisplayCountryList: false,
                        manufactureCountryIndex: index
                    });
                }
            }
        })
        setTimeout(() => {
            this.setState({ exhibitDetailsList: exhibitDetailsList }, () => {
                this.adjustCalculatedArea(area)
            })
        }, 100);
        // }
    }

    // render state
    // renderCountryList() {
    //     const { countryList, tempCountryList, internationalAreaSlabList } = this.state;
    //     return (
    //         <ul
    //             class="list-group pincode-drop"
    //             style={{ position: "absolute", zIndex: 1 }}
    //         >
    //             {tempCountryList.length > 0 &&
    //                 tempCountryList.map((data) => (
    //                     <li
    //                         class="list-group-item"
    //                         key={Math.random()}
    //                         onClick={(e) => this.callCountryList(data.Description, data.Code)}
    //                     >
    //                         {data.Description}
    //                     </li>
    //                 ))}
    //         </ul>
    //     );
    // }

    renderCountryList() {
        const { countryList, tempCountryList, internationalAreaSlabList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempCountryList.length > 0 && tempCountryList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({}, () => {
                                this.getFillList(countryActionId, "", "", "", '', "", "");
                                this.callCountryList(data.Description, data.Code)

                            })}
                        >{data.Description}</li>

                    ))
                }
            </ul>

        )
    }

    onCountryBlur(value, index) {
        const { manufactureCountryIndex, isSSIandTMMAITAMMMA, isMixRuleAgree, OpenMixExhibitorRule, SSRCountryList, countryList, exhibitDetailsList, area, internationalAreaSlabList } = this.state
        var err = false
        // if (SSRCountryList.length > 0) {
        //     SSRCountryList.map(item2 => {
        //         if (item2.CountryName.toLowerCase().trim() == value.toLowerCase().trim()) {
        //             err = true
        //             exhibitDetailsList.map((data, i) => {
        //                 if (index == i) {
        //                     data.ManufacturingCountry = ''
        //                     this.setState({
        //                         tempCountryList: countryList,
        //                         isDisplayCountryList: false,
        //                         manufactureCountryIndex: index
        //                     });
        //                 }
        //             })

        //             this.setState({
        //                 isOpen2: true
        //             })
        //             this.setState({ isDisplayCountryList: false, exhibitDetailsList: exhibitDetailsList });
        //             return
        //         }
        //     })
        // }
        console.log(value.toLowerCase().trim(), '1', index)
        setTimeout(() => {
            if (exhibitDetailsList[index].ManufacturingCountry.toLowerCase().trim() != 'india') {
                if (area == 9 && area != '' && area != null && sessionStorage.getItem("countryId") == 91) {
                    this.setState({ minAreaPop1: true, InternationalArea: 0, IAbare: 0, IAshell: 0, isShowInternationalArea: false })
                    return
                }
                if (area == 18 && area != '' && area != null && sessionStorage.getItem("countryId") == 91) {
                    this.setState({ minAreaPop2: true })
                    return
                }
                if (!isMixRuleAgree) {
                    // for (var i = 0; i < exhibitDetailsList.length; i++) {
                    //     if (index == i) {
                    if (exhibitDetailsList[index].ManufacturingCountry.toLowerCase().trim() != 'india' && sessionStorage.getItem("countryId") == 91) {
                        this.setState({ intAreaRulesPop: true })
                    }
                    // }
                    // }
                }
                if (isSSIandTMMAITAMMMA) {
                    this.setState({ SSIPop: true })
                    return
                }
            } else {
                this.checksameMFandCountry()
            }
            console.log(value.toLowerCase().trim(), '2')
        }, 500);
    }

    callCountryList(value, id) {
        const { manufactureCountryIndex, SSRCountryList, countryList, exhibitDetailsList, area, internationalAreaSlabList } = this.state
        // var err = false
        // if (SSRCountryList.length > 0) {
        //     SSRCountryList.map(item2 => {
        //         if (item2.CountryID == id) {
        //             err = true
        //             exhibitDetailsList.map((data, i) => {
        //                 if (manufactureCountryIndex == i) {
        //                     data.ManufacturingCountry = ''
        //                     this.setState({
        //                         tempCountryList: countryList,
        //                         isDisplayCountryList: false,
        //                         manufactureCountryIndex: manufactureCountryIndex
        //                     });
        //                 }
        //             })
        //             this.setState({
        //                 isOpen2: true
        //             })
        //             this.setState({ isDisplayCountryList: false, exhibitDetailsList: exhibitDetailsList });
        //             return
        //         }
        //     })
        // }
        // if (!err) {

        exhibitDetailsList.map((data, i) => {
            if (manufactureCountryIndex == i) {
                data.ManufacturingCountry = value
            }
        })
        // const totalArea = exhibitDetailsList.reduce((sum, obj) => sum + obj.Area, 0)
        // if (area < totalArea) {
        //     this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
        // } else {
        //     this.setState({ lengthWidthErr: '' })
        // }
        // const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayBroSome = exhibitDetailsList.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayNational = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
        // var tempTotal = exhibitDetailsList.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        // var total = 0
        // if (tempTotal == 0) {
        //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
        //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
        //             total = internationalAreaSlabList[i].MinArea
        //         }
        //     }
        // } else {
        //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     if (totalInternational == 0) {
        //         if ((area - totalNational) > 0) {
        //             total = area - totalNational
        //         } else {
        //             total = 0
        //         }
        //     } else {
        //         if (area >= totalInternational) {
        //             total = totalInternational
        //         } else {
        //             total = 0
        //         }
        //     }
        // }
        // setTimeout(() => {
        //     if (filterArrayBroSome) {
        //         this.setState({ InternationalArea: total })
        //     } else {
        //         this.setState({ InternationalArea: 0 })
        //     }
        //     setTimeout(() => {
        //         this.setState({ exhibitDetailsList: exhibitDetailsList, isShowInternationalArea: filterArrayBroSome })
        //         this.adjustInternationalArea(area)
        //     }, 100);
        // }, 100);
        setTimeout(() => {
            // if (value != 91 && sessionStorage.getItem("countryId") == 91) {
            //     this.setState({ OpenMixExhibitorRule: true })
            // }
            this.adjustCalculatedArea(area)
        }, 100);
        this.setState({ isDisplayCountryList: false });
        this.getFillList(countryActionId, "", "", "", "", "", "");
        // }
    }

    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { level3, level4, level2, level0, is_update, selectedPrimaryChapterIdList, agentChapterIDList, PrimaryChapterId, isShowHighlightChapters, primaryChapterRadio, stallAreaId, area } = this.state
        return new Promise((resolve, reject) => {
            if (!is_update) {
                this.setState({ isLoading: true })
            }

            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, sessionStorage.getItem("sessionExhRegistrationID"))
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === primaryChapterListActionId) {
                            for (let i = 0; i < data.data.level0.length; i++) {
                                data.data.level0[i]['Area'] = parseFloat(data.data.level0[i]['Length'] || 0) * parseFloat(data.data.level0[i]['Breadth'] || 0)
                            }
                            for (let i = 0; i < data.data.level2.length; i++) {
                                data.data.level2[i]['Area'] = parseFloat(data.data.level2[i]['Length'] || 0) * parseFloat(data.data.level2[i]['Breadth'] || 0)
                            }
                            for (let i = 0; i < data.data.level3.length; i++) {
                                data.data.level3[i]['Area'] = parseFloat(data.data.level3[i]['Length'] || 0) * parseFloat(data.data.level3[i]['Breadth'] || 0)
                            }
                            for (let i = 0; i < data.data.level4.length; i++) {
                                data.data.level4[i]['Area'] = parseFloat(data.data.level4[i]['Length'] || 0) * parseFloat(data.data.level4[i]['Breadth'] || 0)
                            }
                            for (let i = 0; i < data.data.primaryChapter.length; i++) {
                                data.data.primaryChapter[i]['Area'] = parseFloat(data.data.primaryChapter[i]['Length'] || 0) * parseFloat(data.data.primaryChapter[i]['Breadth'] || 0)
                            }
                            // this.setState({ isLoading: true })
                            async function seqnoFormat(arr) {
                                for (var i = 0; i < arr.length; i++) {
                                    if (arr[i].seqno != '' && arr[i].seqno != null) {
                                        arr[i].ChapterName.trim()
                                        if (arr[i].ChapterID == 2138) {

                                            // console.log(arr[i].ChapterName, i, arr[i].ChapterName[0], /^\d$/.test(arr[i].ChapterName[0]),)
                                        }
                                        if (/^\d$/.test(arr[i].ChapterName[0])) {
                                            for (var j = 0; j < arr[i].ChapterName.length; j++) {
                                                if (arr[i].ChapterName[j] == ' ') {
                                                    var str = arr[i].ChapterName.slice(j)
                                                    var finalName = arr[i].seqno + str
                                                    arr[i].ChapterName = finalName
                                                    // console.log("primaryChapterListActionId 121212", i, finalName)
                                                    break
                                                }
                                            }
                                        }
                                        else {
                                            var str = arr[i].ChapterName
                                            var finalName = arr[i].seqno + ' ' + str
                                            arr[i].ChapterName = finalName
                                        }
                                        if (arr[i].ChapterID == 2138) {

                                            // console.log('[][]', arr[i].ChapterName)
                                        }
                                    }
                                }
                                return
                            }
                            if (agentChapterIDList.length > 0) {
                                var agentChpterList = []
                                var agentPrimaryChpterIDarr = []
                                var agentPrimaryChapterIDList = []
                                for (var a = 0; a < agentChapterIDList.length; a++) {
                                    for (var i = 0; i < data.data['level2'].length; i++) {
                                        // console.log('agentChapterIDListOOOOOOOOOOOOOO', data.data['level2'])
                                        if (agentChapterIDList[a] == data.data['level2'][i].ChapterID) {
                                            agentChpterList.push(data.data['level2'][i])
                                            !agentPrimaryChpterIDarr.includes(data.data['level2'][i].ParentChapterID) && agentPrimaryChpterIDarr.push(data.data['level2'][i].ParentChapterID)
                                        }
                                    }
                                }
                                if (!agentPrimaryChpterIDarr.includes(2046) && agentPrimaryChpterIDarr.includes(2033)) {
                                    agentPrimaryChpterIDarr.push(2046)
                                } else if (!agentPrimaryChpterIDarr.includes(2033) && agentPrimaryChpterIDarr.includes(2046)) {
                                    agentPrimaryChpterIDarr.push(2033)
                                }
                                for (var a = 0; a < agentPrimaryChpterIDarr.length; a++) {
                                    for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                        if (agentPrimaryChpterIDarr[a] == data.data['primaryChapter'][i].ChapterID) {
                                            agentPrimaryChapterIDList.push(data.data['primaryChapter'][i])
                                        }
                                    }
                                }
                                // console.log(agentChpterList, 'agentChapterIDList', agentPrimaryChapterIDList)
                                data.data['level2'] = agentChpterList
                                data.data['primaryChapter'] = agentPrimaryChapterIDList
                            }
                            // console.log(data.data['level2'])

                            for (var i = 0; i < data.data['level2'].length; i++) {
                                for (var j = 0; j < data.data['level2'].length - 1 - i; j++) {
                                    var seq1 = data.data['level2'][j].seqno
                                    var seq2 = data.data['level2'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level2'][j]
                                        data.data['level2'][j] = data.data['level2'][j + 1]
                                        data.data['level2'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                data.data['level2'][i].primaryChapterId = data.data['level2'][i].ParentChapterID
                                seqnoFormat(data.data['level2'])
                            }
                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                for (var j = 0; j < data.data['primaryChapter'].length - 1 - i; j++) {
                                    var seq1 = data.data['primaryChapter'][j].seqno
                                    var seq2 = data.data['primaryChapter'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['primaryChapter'][j]
                                        data.data['primaryChapter'][j] = data.data['primaryChapter'][j + 1]
                                        data.data['primaryChapter'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                if (data.data['primaryChapter'][i].seqno == null || data.data['primaryChapter'][i].seqno == undefined) {
                                    // console.log(data.data['primaryChapter'][i].seqno, i)
                                }
                                // seqnoFormat(data.data['primaryChapter'])
                            }
                            console.log("prr",)
                            for (var i = 0; i < data.data['level3'].length; i++) {
                                for (var j = 0; j < data.data['level3'].length - 1 - i; j++) {

                                    var seq1 = data.data['level3'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level3'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')

                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level3'][j]
                                        data.data['level3'][j] = data.data['level3'][j + 1]
                                        data.data['level3'][j + 1] = temp;
                                    }
                                }
                                for (var j = 0; j < data.data['level2'].length; j++) {
                                    if (data.data['level2'][j].ChapterID == data.data['level3'][i].ParentChapterID) {
                                        data.data['level3'][i].primaryChapterId = data.data['level2'][j].ParentChapterID
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level3'])
                            }
                            for (var i = 0; i < data.data['level4'].length; i++) {
                                for (var j = 0; j < data.data['level4'].length - 1 - i; j++) {
                                    var seq1 = data.data['level4'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level4'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level4'][j]
                                        data.data['level4'][j] = data.data['level4'][j + 1]
                                        data.data['level4'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                for (var j = 0; j < data.data['level3'].length; j++) {
                                    if (data.data['level3'][j].ChapterID == data.data['level4'][i].ParentChapterID) {
                                        for (var k = 0; k < data.data['level2'].length; k++) {
                                            if (data.data['level2'][k].ChapterID == data.data['level3'][j].ParentChapterID) {
                                                data.data['level4'][i].primaryChapterId = data.data['level2'][k].ParentChapterID
                                                break
                                            }
                                        }
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level4'])
                            }

                            for (var i = 0; i < data.data['level2'].length; i++) {
                                data.data['level2'][i].isHighlight = false
                                data.data['level2'][i].DocumentName = ''
                                data.data['level2'][i].DocumentType = ''
                                data.data['level2'][i].DocumentFile = ''
                                data.data['level2'][i].DocumentPath = ''
                                data.data['level2'][i].DocDeleted = true
                            }
                            for (var i = 0; i < data.data['level3'].length; i++) {
                                // data.data['level4'][i].isHighlight = false
                                data.data['level3'][i].DocumentName = ''
                                data.data['level3'][i].DocumentType = ''
                                data.data['level3'][i].DocumentFile = ''
                                data.data['level3'][i].DocumentPath = ''
                                data.data['level3'][i].DocDeleted = true
                            }
                            for (var i = 0; i < data.data['level4'].length; i++) {
                                // data.data['level4'][i].isHighlight = false
                                data.data['level4'][i].DocumentName = ''
                                data.data['level4'][i].DocumentType = ''
                                data.data['level4'][i].DocumentFile = ''
                                data.data['level4'][i].DocumentPath = ''
                                data.data['level4'][i].DocDeleted = true
                            }
                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                // data.data['primaryChapter'][i].isHighlight = false
                                data.data['primaryChapter'][i].DocumentName = ''
                                data.data['primaryChapter'][i].DocumentType = ''
                                data.data['primaryChapter'][i].DocumentFile = ''
                                data.data['primaryChapter'][i].DocumentPath = ''
                                data.data['primaryChapter'][i].DocDeleted = true
                            }
                            data.data['primaryChapter'].sort((a, b) => a.seqno.localeCompare(b.seqno, undefined, { numeric: true }));
                            data.data['level2'].sort((a, b) => a.seqno.localeCompare(b.seqno, undefined, { numeric: true }));
                            data.data['level3'].sort((a, b) => a.seqno.localeCompare(b.seqno, undefined, { numeric: true }));
                            data.data['level4'].sort((a, b) => a.seqno.localeCompare(b.seqno, undefined, { numeric: true }));
                            data.data['primaryChapter'].sort((a, b) =>
                                a.ChapterName.toLowerCase().localeCompare(b.ChapterName.toLowerCase())
                            );
                            this.setState({
                                primaryChapterListData: data.data['primaryChapter'],
                                level0: data.data['level0'],
                                level2: data.data['level2'],
                                level3: data.data['level3'],
                                level4: data.data['level4'],
                                // isLoading: false,
                            })
                            if (is_update) {

                                // this.setState({
                                //     primaryChapterRadio: primaryChapterRadio
                                //     // primaryChapterRadio : data.data[0]['PrimaryChapter']
                                // })

                                if (primaryChapterRadio != '') {
                                    for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                        if (selectedPrimaryChapterIdList.length > 0) {
                                            for (var j = 0; j < selectedPrimaryChapterIdList.length; j++) {
                                                console.log('selectedPrimaryChapterIdListselectedPrimaryChapterIdList', data.data['primaryChapter'][i].ChapterID, selectedPrimaryChapterIdList)
                                                if (data.data['primaryChapter'][i].ChapterID == parseInt(selectedPrimaryChapterIdList[j])) {
                                                    data.data['primaryChapter'][i].isChecked = true;
                                                }
                                            }
                                        } else {
                                            if (data.data['primaryChapter'][i].ChapterID == primaryChapterRadio) {
                                                data.data['primaryChapter'][i].isChecked = true;
                                            } else {
                                                data.data['primaryChapter'][i].isChecked = false;
                                            }
                                        }
                                    }
                                    data.data['primaryChapter'].filter(item => item.isChecked).length > 1 &&
                                        this.setState({
                                            isOpenAgree: true,
                                        })
                                    console.log('data.data]', data.data['primaryChapter'], data.data['primaryChapter'].filter(item => item.isChecked).length > 1)
                                    data.data['primaryChapter'].sort((a, b) =>
                                        a.ChapterName.toLowerCase().localeCompare(b.ChapterName.toLowerCase())
                                    );
                                    this.setState({
                                        primaryChapterListData: data.data['primaryChapter'],
                                    })
                                }

                                setTimeout(() => {
                                    var lev2List = [...data.data['level2']]
                                    // var highLightId = primaryChapterRadio == 2033 ? 2046 : primaryChapterRadio
                                    var highLightId = []
                                    if (selectedPrimaryChapterIdList.length > 0) {
                                        for (var j = 0; j < selectedPrimaryChapterIdList.length; j++) {
                                            highLightId.push(selectedPrimaryChapterIdList[j] == 2033 ? 2046 : selectedPrimaryChapterIdList[j])
                                        }
                                    } else {
                                        var highLightId = primaryChapterRadio == 2033 ? 2046 : primaryChapterRadio
                                    }
                                    console.log(selectedPrimaryChapterIdList, 'primaryChapterRadio===>', lev2List, isShowHighlightChapters)
                                    if (isShowHighlightChapters) {
                                        for (var i = 0; i < lev2List.length; i++) {
                                            if (lev2List[i].ParentChapterIDs != null) {
                                                var ParentChapterIDs = lev2List[i].ParentChapterIDs.split(',')
                                                for (var j = 0; j < ParentChapterIDs.length; j++) {
                                                    ParentChapterIDs[j] = parseInt(ParentChapterIDs[j])
                                                }
                                                // console.log(ParentChapterIDs, primaryChapterRadio, ParentChapterIDs.includes(primaryChapterRadio), 'ParentChapterIDs.includes(primaryChapterRadio)')
                                                if (selectedPrimaryChapterIdList.length > 0) {
                                                    for (var j = 0; j < selectedPrimaryChapterIdList.length; j++) {
                                                        if (ParentChapterIDs.includes(parseInt(selectedPrimaryChapterIdList[j]))) {
                                                            console.log(ParentChapterIDs)
                                                            lev2List[i]['isHighlight'] = true;
                                                        }
                                                    }
                                                } else {
                                                    if (ParentChapterIDs.includes(parseInt(primaryChapterRadio))) {
                                                        console.log(ParentChapterIDs)
                                                        lev2List[i]['isHighlight'] = true;
                                                    }
                                                }
                                            } else {
                                                if (selectedPrimaryChapterIdList.length > 0) {
                                                    for (var j = 0; j < highLightId.length; j++) {
                                                        if (lev2List[i].ParentChapterID == parseInt(highLightId[j])) {
                                                            lev2List[i]['isHighlight'] = true;
                                                        }
                                                    }
                                                } else {
                                                    if (lev2List[i].ParentChapterID == parseInt(highLightId)) {
                                                        lev2List[i]['isHighlight'] = true;
                                                    }
                                                }
                                            }
                                        }
                                        // for (var i = 0; i < lev2List.length; i++) {
                                        //     if (lev2List[i].ParentChapterID == primaryChapterRadio) {
                                        //         lev2List[i]['isHighlight'] = true;
                                        //     } else {
                                        //         lev2List[i]['isHighlight'] = false;
                                        //     }
                                        // }
                                    }
                                    this.setState({
                                        level2: lev2List,
                                    })
                                }, 100);


                                var list = []
                                // console.log("level2 get", level2)
                                data.data['level2'].length > 0 && data.data['level2'].map(level2Data => {
                                    if (level2Data.IsSelect && level2Data.IsCheckbox) {
                                        // console.log("level2Data get", level2Data)
                                        level2Data.Area = parseFloat(level2Data.Length || 0) * parseFloat(level2Data.Breadth || 0)
                                        var temppath = level2Data.isMachine || level2Data.IsAccessory ? level2Data.Document : ''
                                        var temparr = temppath != null &&
                                            temppath != "" ? temppath.split("/") : []
                                        var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                                        level2Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
                                        level2Data.DocumentType = ''
                                        level2Data.DocumentFile = ''
                                        level2Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
                                        level2Data.DocDeleted = temppath != '' && temppath != null ? false : true
                                        list.push(level2Data)
                                    }
                                })
                                data.data['level3'].length > 0 && data.data['level3'].map(level3Data => {
                                    if (level3Data.IsSelect && level3Data.IsCheckbox) {
                                        level3Data.Area = parseFloat(level3Data.Length || 0) * parseFloat(level3Data.Breadth || 0)
                                        var temppath = level3Data.isMachine || level3Data.IsAccessory ? level3Data.Document : ''
                                        var temparr = temppath != null &&
                                            temppath != "" ? temppath.split("/") : []
                                        var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                                        level3Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
                                        level3Data.DocumentType = ''
                                        level3Data.DocumentFile = ''
                                        level3Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
                                        level3Data.DocDeleted = temppath != '' && temppath != null ? false : true
                                        list.push(level3Data)
                                    }
                                })
                                data.data['level4'].length > 0 && data.data['level4'].map(level4Data => {
                                    if (level4Data.IsSelect && level4Data.IsCheckbox) {
                                        level4Data.Area = parseFloat(level4Data.Length || 0) * parseFloat(level4Data.Breadth || 0)
                                        var temppath = level4Data.isMachine || level4Data.IsAccessory ? level4Data.Document : ''
                                        var temparr = temppath != null &&
                                            temppath != "" ? temppath.split("/") : []
                                        var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                                        level4Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
                                        level4Data.DocumentType = ''
                                        level4Data.DocumentFile = ''
                                        level4Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
                                        level4Data.DocDeleted = temppath != '' && temppath != null ? false : true
                                        list.push(level4Data)
                                    }
                                })
                                list.sort((a, b) => (a.ChapterID > b.ChapterID) ? 1 : -1);
                                data.data['level0'].length > 0 && data.data['level0'].map(level0Data => {
                                    if (level0Data.IsSelect) {
                                        // console.log("level2Data get", level2Data)
                                        level0Data.Area = parseFloat(level0Data.Length || 0) * parseFloat(level0Data.Breadth || 0)
                                        var temppath = level0Data.isMachine || level0Data.IsAccessory ? level0Data.Document : ''
                                        var temparr = temppath != null &&
                                            temppath != "" ? temppath.split("/") : []
                                        var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                                        level0Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
                                        level0Data.DocumentType = ''
                                        level0Data.DocumentFile = ''
                                        level0Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
                                        level0Data.DocDeleted = temppath != '' && temppath != null ? false : true
                                        list.push(level0Data)
                                    }
                                })
                                const totalArea = list.reduce((sum, obj) => sum + obj.Area, 0)
                                if (area < totalArea) {
                                    this.setState({ lengthWidthErr: (JSON.parse(sessionStorage.getItem("isOpenedForInternationalForm")) == true && sessionStorage.getItem("fillInternationalForm-description") != 1) ? '' : 'Total sum of area  cannot be greater than stall area' })
                                } else {
                                    this.setState({ lengthWidthErr: '' })
                                }
                                const filterArray = list.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                                // const filterArrayBroSome = list.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                                // const total = filterArray.reduce((sum, obj) => sum + obj.Area, 0)
                                // const flag = list.every(item => item.ManufacturingCountry == sessionStorage.getItem("sessionContryName"))
                                // if (flag) {
                                //     this.setState({ InternationalArea: 0 })
                                // } else {
                                //     this.setState({ InternationalArea: total })
                                // }
                                // sessionStorage.setItem("fillInternationalForm-description", 1)
                                // console.log(JSON.parse(sessionStorage.getItem("isOpenedForInternationalForm")), sessionStorage.getItem("fillInternationalForm-description") != 1)
                                if ((sessionStorage.getItem("fillInternationalForm") == 1 && sessionStorage.getItem("fillInternationalForm-description") != 1) || (JSON.parse(sessionStorage.getItem("isOpenedForInternationalForm")) == true && sessionStorage.getItem("fillInternationalForm-description") != 1)) {
                                    list.map((item => {
                                        item.Area = 0
                                        item.Breadth = 0
                                        item.FloorCapacity = ''
                                        item.HSNCode = ''
                                        item.Height = 0
                                        item.Length = 0
                                        item.MachineDetails = ''
                                        item.MachineWeight = 0
                                        item.ManufacturerName = ''
                                        item.ManufacturingCountry = ''
                                        item.isBrochure = false
                                        item.isMachine = false
                                        item.IsAccessory = false
                                        item.DocumentName = ''
                                        item.DocumentType = ''
                                        item.DocumentFile = ''
                                        item.DocumentPath = ''
                                        item.DocDeleted = true
                                        item.SinglePhasePower = 0
                                        item.ThreePhasePower = 0
                                        item.WaterConsumption = 0
                                        item.InletQuantity = 0
                                        item.OutletQuantity = 0
                                        item.BarQuantity = 0
                                        item.CFMQuantity = 0
                                        item.MaxCompressedAir = 0
                                    }))
                                }
                                var isAllBrochure = true
                                if (filterArray.length > 0) {
                                    for (var i = 0; i < filterArray.length; i++) {
                                        if (filterArray[i].IsAccessory || filterArray[i].isMachine) {
                                            isAllBrochure = false
                                        }
                                    }
                                }
                                var totalBare = 0
                                var totalShell = 0
                                list.length > 0 && list.map(item => {
                                    if (item.SinglePhasePower == '' || item.SinglePhasePower == null) {
                                        item.SinglePhasePower = 0
                                    }
                                    if (item.ThreePhasePower == '' || item.ThreePhasePower == null) {
                                        item.ThreePhasePower = 0
                                    }
                                    if (item.WaterConsumption == '' || item.WaterConsumption == null) {
                                        item.WaterConsumption = 0
                                    }
                                    if (item.InletQuantity == '' || item.InletQuantity == null) {
                                        item.InletQuantity = 0
                                    }
                                    if (item.OutletQuantity == '' || item.OutletQuantity == null) {
                                        item.OutletQuantity = 0
                                    }
                                    if (item.MaxCompressedAir == '' || item.MaxCompressedAir == null) {
                                        item.MaxCompressedAir = 0
                                    }
                                    if (sessionStorage.getItem("countryId") != 91) {
                                        item.CalculatedArea = 0
                                        item.ShellScheme = ''
                                    }
                                    item.errArr = []
                                    if (item.ShellScheme == 1) {
                                        totalBare = totalBare + item.CalculatedArea
                                    }
                                    if (item.ShellScheme == 2) {
                                        totalShell = totalShell + item.CalculatedArea
                                    }
                                })

                                this.setState({ exhibitDetailsList: list, IAbare: totalBare, IAshell: totalShell, isShowInternationalArea: filterArray.length > 0, isAllBro: filterArray.length > 0 ? isAllBrochure : false })
                            }
                            setTimeout(() => {
                                // this.filterLevelData().then(() => {
                                resolve(true)
                                // })
                            }, 300);
                        }
                        // scheme Type
                        if (actionID === stallTypeActionId) {
                            // console.log("country data", data.data)
                            this.setState({
                                schemeTypeList: data.data,
                            })
                            if (data.data.length == 1) {
                                this.onSchemeTypeChange(null, data.data[0].Code)
                            }
                            resolve(true)
                        }
                        if (actionID === internationalAreaSlabActionId) {
                            // console.log("country data", data.data)
                            this.setState({
                                internationalAreaSlabList: data.data,
                            })
                            resolve(true)
                        }
                        if (actionID === openSideListActionId) {
                            // console.log("country data", data.data)
                            this.setState({
                                openSideList: data.data,
                            })
                            resolve(true)
                        }
                        // stall Size
                        if (actionID === stallSizeActionId) {
                            // console.log("country data", data.data)
                            this.setState({
                                stallAreaList: data.data,
                            })
                            if (stallAreaId != '') {
                                for (var i = 0; i < data.data.length; i++) {
                                    if (data.data[i].Code == stallAreaId) {
                                        console.log('Description : ', data.data[i].Description);
                                        this.setState({ stallAreaName: data.data[i].Description })
                                    }
                                }
                            }
                            resolve(data.data)
                        }
                        if (actionID === fullStallAreaActionId) {
                            // console.log("country data", data.data)
                            this.setState({
                                referenceStallAreaArr: data.data,
                            })
                            resolve(true)
                        }
                        if (actionID === countryActionId) {
                            // console.log("country data", data.data)
                            this.setState({
                                countryList: data.data,
                                tempCountryList: data.data,
                            }, () => {
                                if (this.state.isOpenForInternationalForm) {
                                    for (var i = 0; i < data.data.length; i++) {
                                        if (parseInt(data.data[i].Code) == parseInt(this.state.InternationalFormCountryId)) {
                                            console.log("wwwwwwwwwwwwww", data.data[i].Description)
                                            this.setState({
                                                countryId: data.data[i].Code,
                                                // invoicecountryid: data.data[i].Code,
                                                countryName: data.data[i].Description,
                                                // invoicecountryName: data.data[i].Description,
                                                countryNamePreRegisterMobileNo: `+${data.data[i].CountryCode}`,
                                                countryNamePreRegisterAlternateMobileNo: `+${data.data[i].CountryCode}`,
                                                countryNamePreOwnerMobileNo: `+${data.data[i].CountryCode}`,

                                                // countryNamePreInvoiceregisterMobileNo: isCorrespondenceDetails ? `+${data.data[i].CountryCode}` : countryNamePreInvoiceregisterMobileNo,
                                                // countryNamePreInvoiceregisterAlternateMobileNo: isCorrespondenceDetails ? `+${data.data[i].CountryCode}` : countryNamePreInvoiceregisterAlternateMobileNo,
                                                // invoicecountryid: isCorrespondenceDetails ? data.data[i].Code : invoicecountryid,
                                                // invoicecountryName: isCorrespondenceDetails ? data.data[i].Description : invoicecountryName,
                                            })
                                            sessionStorage.setItem("sessionContryName", data.data[i].Description)
                                            console.log(data.data[i].Description)
                                        }
                                    }
                                }
                            })
                            resolve(true)
                        }
                        if (actionID === lengthActionId) {
                            const array = data.data.length > 0 ? data.data.sort((a, b) => parseInt(a.Code) - parseInt(b.Code)) : []
                            // console.log("array-->", array)
                            this.setState({
                                lengthList: array,
                            });
                            resolve(true)
                        }
                        if (actionID === breadthActionId) {
                            const array = data.data.length > 0 ? data.data.sort((a, b) => parseInt(a.Code) - parseInt(b.Code)) : []
                            this.setState({
                                breadthList: array,
                            });

                            resolve(true)
                        }
                        if (actionID === BarActionId) {
                            // const array = data.data.length > 0 ? data.data.sort((a, b) => parseInt(a.Code) - parseInt(b.Code)) : []
                            this.setState({
                                barQuantityList: data.data,
                            });

                            resolve(true)
                        }
                        if (actionID === CFMActionId) {
                            // const array = data.data.length > 0 ? data.data.sort((a, b) => parseInt(a.Code) - parseInt(b.Code)) : []
                            this.setState({
                                CFMQuantityList: data.data,
                            });

                            resolve(true)
                        }
                        setTimeout(() => {
                            this.setState({ isLoading: false })
                        }, 5000);
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }
    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
        // object.target.value.length == maxLength &&
        //   setTimeout(() => {
        //     this.contactAadhaarValidation()
        //   }, 200);
    }

    onEnterProductName(e, index) {
        const { level4, exhibitDetailsList } = this.state

        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                console.log("e.target.value", e.target.value)
                data.ChapterName = e.target.value
            }
        })

        exhibitDetailsList.map((data, i) => {

        })

        // for (var i = 0; i < exhibitDetailsList.length; i++) {
        //     console.log("onEnterProductName validate : ", index, ' ', i, ' ', exhibitDetailsList[i].ChapterName.toString().trim().toLowerCase(), ' ', e.target.value.toString().trim().toLowerCase())
        //     if (index != i && exhibitDetailsList[i].ChapterName.toString().trim().toLowerCase() == e.target.value.toString().trim().toLowerCase()) {
        //         this.setState({ lengthWidthErr: 'Product name must be unique.' })
        //         return;
        //     } else {
        //         this.setState({ lengthWidthErr: '' })
        //     }
        // }


        setTimeout(() => {
            console.log("exhibitDetailsList", exhibitDetailsList)
            this.setState({ exhibitDetailsList: exhibitDetailsList })

        }, 200);
    }

    onMachineDetailsChange(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                data.MachineDetails = e.target.value
            }
        })
        setTimeout(() => {
            this.setState({ exhibitDetailsList: exhibitDetailsList })
        }, 100);
    }

    onEnterHSNCode(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        console.log("id", id)

        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.HSNCode = e.target.value
            }
        })
        setTimeout(() => {
            console.log("exhibitDetailsList", exhibitDetailsList)
            this.setState({ exhibitDetailsList: exhibitDetailsList })

        }, 200);
    }

    onEntersinglePhase(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        console.log("id", id)
        var total = e.target.value
        for (var i = 0; i < exhibitDetailsList.length; i++) {
            if (exhibitDetailsList[i].SinglePhasePower != '' && exhibitDetailsList[i].SinglePhasePower != null) {
                total = parseInt(exhibitDetailsList[i].SinglePhasePower) + parseInt(total)
            }
        }
        console.log(total)
        if (total > 3 && e.target.value != '') {
            toastError("Maximum 3 quantities allowed for single phase. Apply for three phase for more")

            return
        }
        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                this.removeIfExists(i, 'SinglePhasePower')
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.SinglePhasePower = e.target.value
            }
        })
        setTimeout(() => {
            console.log(total)
            console.log("exhibitDetailsList", exhibitDetailsList)
            setTimeout(() => {
                this.setState({ exhibitDetailsList: exhibitDetailsList })
            }, 100);

        }, 200);
    }

    onEnterThreePhase(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        console.log("id", id)

        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                this.removeIfExists(i, 'ThreePhasePower')
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.ThreePhasePower = e.target.value
            }
        })
        setTimeout(() => {
            console.log("exhibitDetailsList", exhibitDetailsList)
            this.setState({ exhibitDetailsList: exhibitDetailsList })

        }, 200);
    }
    onEnterWaterConsumption(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        console.log("id", id)

        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                this.removeIfExists(i, 'WaterConsumption')
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.WaterConsumption = e.target.value
            }
        })
        setTimeout(() => {
            console.log("exhibitDetailsList", exhibitDetailsList)
            this.setState({ exhibitDetailsList: exhibitDetailsList })

        }, 200);
    }
    onEnterInletQuantity(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        console.log("id", id)

        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                this.removeIfExists(i, 'InletQuantity')
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.InletQuantity = e.target.value
            }
        })
        setTimeout(() => {
            console.log("exhibitDetailsList", exhibitDetailsList)
            this.setState({ exhibitDetailsList: exhibitDetailsList })

        }, 200);
    }
    onEnterOutletQuantity(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        console.log("id", id)

        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.OutletQuantity = e.target.value
            }
        })
        setTimeout(() => {
            console.log("exhibitDetailsList", exhibitDetailsList)
            this.setState({ exhibitDetailsList: exhibitDetailsList })

        }, 200);
    }
    onEnterBar(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        console.log("id", id)

        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.BarQuantity = e.target.value
            }
        })
        setTimeout(() => {
            console.log("exhibitDetailsList", exhibitDetailsList)
            this.setState({ exhibitDetailsList: exhibitDetailsList })
            if (e.target.value != '') {
                this.getFillList(CFMActionId, sessionStorage.getItem("sessionExhibitionID"), e.target.value <= 6 ? 13 : e.target.value === 7 ? 14 : 17, "", e.target.value)
            }

        }, 200);
    }
    onEnterCFM(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        console.log("id", id)

        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.CFMQuantity = e.target.value
            }
        })

        setTimeout(() => {
            console.log("exhibitDetailsList", exhibitDetailsList)
            this.setState({ exhibitDetailsList: exhibitDetailsList })

        }, 200);
    }
    onEnterMaxCompressed(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        console.log("id", id)

        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                this.removeIfExists(i, 'MaxCompressedAir')
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.MaxCompressedAir = e.target.value
            }
        })
        setTimeout(() => {
            console.log("exhibitDetailsList", exhibitDetailsList)
            this.setState({ exhibitDetailsList: exhibitDetailsList })

        }, 200);
    }

    onEnterCompanyEmail(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        console.log("id", id)

        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                this.removeIfExists(i, 'CompanyEmail')
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.CompanyEmail = e.target.value
            }
        })
        // setTimeout(() => {
        console.log("exhibitDetailsList", exhibitDetailsList)
        this.setState({ exhibitDetailsList: exhibitDetailsList })

        // }, 200);
    }

    onEnterHQaddress(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        console.log("id", id)

        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                this.removeIfExists(i, 'registrationHQaddress')
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.registrationHQaddress = e.target.value
            }
        })
        // setTimeout(() => {
        console.log("exhibitDetailsList", exhibitDetailsList)
        this.setState({ exhibitDetailsList: exhibitDetailsList })

        // }, 200);/
    }

    onMBclick(mode, id, index) {
        const { level4, exhibitDetailsList, internationalAreaSlabList, area } = this.state
        console.log("id", id)

        exhibitDetailsList.map((data, i) => {
            if (i == index) {
                this.removeIfExists(i, 'isAllMB')
                if (mode == 0) {
                    if (data.isMachine) {
                        data.isMachine = false
                    } else {
                        data.isMachine = true
                    }
                } else if (mode == 1) {
                    this.removeIfExists(i, 'Height')
                    this.removeIfExists(i, 'Breadth')
                    this.removeIfExists(i, 'Length')
                    if (data.isBrochure) {
                        data.isBrochure = false
                    } else {
                        data.isBrochure = true
                    }
                } else if (mode == 2) {
                    this.removeIfExists(i, 'Height')
                    this.removeIfExists(i, 'Breadth')
                    this.removeIfExists(i, 'Length')
                    if (data.IsAccessory) {
                        data.IsAccessory = false
                    } else {
                        data.IsAccessory = true
                    }
                }
            }
        })
        setTimeout(() => {
            console.log("exhibitDetailsList", exhibitDetailsList)
            this.setState({ exhibitDetailsList: exhibitDetailsList }
                , () => {
                    // const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                    // const filterArrayBroSome = exhibitDetailsList.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                    // const filterArrayNational = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
                    // var tempTotal = exhibitDetailsList.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    // var total = 0
                    // if (tempTotal == 0) {
                    //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
                    //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
                    //             total = internationalAreaSlabList[i].MinArea
                    //         }
                    //     }
                    // } else {
                    //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    //     if (totalInternational == 0) {
                    //         if ((area - totalNational) > 0) {
                    //             total = area - totalNational
                    //         } else {
                    //             total = 0
                    //         }
                    //     } else {
                    //         if (area >= totalInternational) {
                    //             total = totalInternational
                    //         } else {
                    //             total = 0
                    //         }
                    //     }
                    // }
                    // setTimeout(() => {
                    //     if (filterArrayBroSome) {
                    //         this.setState({ InternationalArea: total })
                    //     } else {
                    //         this.setState({ InternationalArea: 0 })
                    //     }
                    //     this.setState({ exhibitDetailsList: exhibitDetailsList })
                    //     this.adjustInternationalArea(area)
                    // }, 100);
                    setTimeout(() => {
                        this.adjustCalculatedArea(area)
                    }, 100);
                }
            )

        }, 200);


    }

    onLengthChange(e, id, index) {
        const { level4, exhibitDetailsList, stallAreaName, area, internationalAreaSlabList } = this.state

        // if(exhibitDetailsList[index])
        var breadth = 0;
        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                this.removeIfExists(i, 'Length')
                data.Length = e.target.value.replace(/[^0-9]/g, '')
                breadth = data.Breadth;
                data.Area = parseFloat(data.Length || 0) * parseFloat(data.Breadth || 0)
            }
        })
        // if (stallAreaName != null && stallAreaName != '' && e.target.value != null && e.target.value != '' && e.target.value != 0 &&
        //     breadth != null && breadth != 0) {
        //     var totalSpace;
        //     var totalEnterSpace;
        //     var lengthWidthList
        //     if (stallAreaName.includes('x')) {
        //         lengthWidthList = stallAreaName.split('x');
        //     } else if (stallAreaName.includes('X')) {
        //         lengthWidthList = stallAreaName.split('X');
        //     }
        //     totalSpace = parseFloat(lengthWidthList[0]) * parseFloat(lengthWidthList[1]);
        //     totalEnterSpace = parseFloat(e.target.value) * parseFloat(breadth);
        //     if (totalEnterSpace > totalSpace) {
        //         this.setState({ lengthWidthErr: 'Length and breadth must be below or equal to stall area.' })
        //     } else {
        //         this.setState({ lengthWidthErr: '' })
        //     }
        // }
        // const totalArea = exhibitDetailsList.reduce((sum, obj) => sum + obj.Area, 0)
        // if (area < totalArea) {
        //     this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
        // } else {
        //     this.setState({ lengthWidthErr: '' })
        // }
        // const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayBroSome = exhibitDetailsList.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayNational = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
        // var tempTotal = exhibitDetailsList.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        // var total = 0
        // if (tempTotal == 0) {
        //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
        //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
        //             total = internationalAreaSlabList[i].MinArea
        //         }
        //     }
        // } else {
        //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     if (totalInternational == 0) {
        //         if ((area - totalNational) > 0) {
        //             total = area - totalNational
        //         } else {
        //             total = 0
        //         }
        //     } else {
        //         if (area >= totalInternational) {
        //             total = totalInternational
        //         } else {
        //             total = 0
        //         }
        //     }
        // }
        // setTimeout(() => {
        //     if (filterArrayBroSome) {
        //         this.setState({ InternationalArea: total })
        //     } else {
        //         this.setState({ InternationalArea: 0 })
        //     }
        //     this.setState({ exhibitDetailsList: exhibitDetailsList })
        //     this.adjustInternationalArea(area)
        // }, 100);
        setTimeout(() => {
            this.adjustCalculatedArea(area)
        }, 100);
    }

    onBreadthChange(e, id, index) {
        const { level4, exhibitDetailsList, stallAreaName, area, internationalAreaSlabList } = this.state
        var length = 0;
        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                this.removeIfExists(i, 'Breadth')
                data.Breadth = e.target.value.replace(/[^0-9]/g, '')
                length = data.Length;
                data.Area = parseFloat(data.Length || 0) * parseFloat(data.Breadth || 0)
            }
        })


        // if (stallAreaName != null && stallAreaName != '' && e.target.value != null && e.target.value != '' && e.target.value != 0 &&
        //     length != null && length != 0) {
        //     var totalSpace;
        //     var totalEnterSpace;
        //     var lengthWidthList
        //     if (stallAreaName.includes('x')) {
        //         lengthWidthList = stallAreaName.split('x');
        //     } else if (stallAreaName.includes('X')) {
        //         lengthWidthList = stallAreaName.split('X');
        //     }

        //     totalSpace = parseFloat(lengthWidthList[0]) * parseFloat(lengthWidthList[1]);
        //     console.log('totalSpace : ', totalSpace);
        //     totalEnterSpace = parseFloat(e.target.value) * parseFloat(length);
        //     if (totalEnterSpace > totalSpace) {
        //         exhibitDetailsList.map((data, i) => {
        //             if (index == i) {
        //                 data.isLengthValidate = true;
        //             }
        //         })
        //         this.setState({ lengthWidthErr: 'Length and breadth must be below or equal to stall area.' })
        //     } else {
        //         exhibitDetailsList.map((data, i) => {
        //             if (index == i) {
        //                 data.isLengthValidate = false;
        //             }
        //         })
        //         this.setState({ lengthWidthErr: '' })
        //     }
        // }
        // const totalArea = exhibitDetailsList.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        // if (area < totalArea) {
        //     this.setState({ lengthWidthErr: 'Total sum of area cannot be greater than stall area' })
        // } else {
        //     this.setState({ lengthWidthErr: '' })
        // }
        // const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayBroSome = exhibitDetailsList.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayNational = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
        // var tempTotal = exhibitDetailsList.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        // var total = 0
        // if (tempTotal == 0) {
        //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
        //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
        //             total = internationalAreaSlabList[i].MinArea
        //         }
        //     }
        // } else {
        //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     if (totalInternational == 0) {
        //         if ((area - totalNational) > 0) {
        //             total = area - totalNational
        //         } else {
        //             total = 0
        //         }
        //     } else {
        //         if (area >= totalInternational) {
        //             total = totalInternational
        //         } else {
        //             total = 0
        //         }
        //     }
        // }
        // setTimeout(() => {
        //     if (filterArrayBroSome) {
        //         this.setState({ InternationalArea: total })
        //     } else {
        //         this.setState({ InternationalArea: 0 })
        //     }
        //     this.setState({ exhibitDetailsList: exhibitDetailsList })
        //     this.adjustInternationalArea(area)
        // }, 100);
        setTimeout(() => {
            this.adjustCalculatedArea(area)
        }, 100);
    }

    onHeightChange(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                this.removeIfExists(i, 'Height')
                data.Height = e.target.value
            }
        })
        this.setState({ exhibitDetailsList: exhibitDetailsList })

        // if (e.target.value != null && e.target.value != '' && e.target.value != 0 && e.target.value > 3) {
        //     this.setState({ lengthWidthErr: 'Height must be less than or equal to 3.' })
        // } else {
        //     this.setState({ lengthWidthErr: '' })
        // }
    }

    onFloorCapacityChange(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                data.FloorCapacity = e.target.value
            }
        })
        this.setState({ exhibitDetailsList: exhibitDetailsList })
    }

    onMachineWeightChange(e, id, index) {
        const { level4, exhibitDetailsList } = this.state
        exhibitDetailsList.map((data, i) => {
            if (index == i) {
                data.MachineWeight = e.target.value
            }
        })
        this.setState({ exhibitDetailsList: exhibitDetailsList })
    }

    onManufacturerNameChange(e, id, index) {
        const { level4, exhibitDetailsList, area } = this.state
        for (var i = 0; i < exhibitDetailsList.length; i++) {
            if (index == i) {
                this.removeIfExists(i, 'ManufacturerName')
                exhibitDetailsList[i].ManufacturerName = e.target.value
            }
        }
        this.setState({ exhibitDetailsList: exhibitDetailsList }, () => {
            this.adjustCalculatedArea(area)
        })
    }

    // onManufacturingCountryChange(e, id, index) {
    //     const { level4, exhibitDetailsList } = this.state
    //     exhibitDetailsList.map((data, i) => {
    //         if (index == i) {
    //             data.ManufacturingCountry = e.target.value
    //         }
    //     })
    //     setTimeout(() => {
    //         this.setState({ exhibitDetailsList: exhibitDetailsList })
    //     }, 100);
    // }

    onAddManualChapter(e) {
        e.preventDefault();
        const { exhibitDetailsList, area } = this.state
        var map = {
            Breadth: 0,
            ChapterID: 0,
            ChapterName: "",
            CssClass: null,
            ExhRegistrationID: sessionStorage.getItem("sessionExhRegistrationID"),
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            FloorCapacity: 0,
            HSNCode: "",
            CompanyEmail: "",
            registrationHQaddress: "",
            Height: 0,
            IsCheckbox: false,
            IsSelect: false,
            Length: 0,
            Level: 4,
            MachineDetails: "",
            MachineWeight: 0,
            ManufacturerName: "",
            ManufacturingCountry: "",
            ParentChapterID: 0,
            isLengthValidate: false,
            isMachine: false,
            isBrochure: false,
            IsAccessory: false,
            DocumentName: '',
            DocumentType: '',
            DocumentFile: '',
            DocumentPath: '',
            DocDeleted: true,
            SinglePhasePower: 0,
            ThreePhasePower: 0,
            WaterConsumption: 0,
            InletQuantity: 0,
            OutletQuantity: 0,
            BarQuantity: 0,
            CFMQuantity: 0,
            MaxCompressedAir: 0,
            errArr: [],
            CalculatedArea: 0,
            ShellScheme: '',
        }
        exhibitDetailsList.push(map)
        this.setState({ exhibitDetailsList: exhibitDetailsList, exhibitDetailsTableErr: '', isDoubleStorey: false, doubleStoreyArea: '', doubleStoreyAreaErr: '', schemeType: '', schemeTypeErr: '', stallAreaId: '', stallAreaIdErr: '', stallAreaList: [], stallAreaName: '', area: '', InternationalArea: '' }, () => {
            // this.adjustInternationalArea(area)
            setTimeout(() => {
                this.adjustCalculatedArea(null)
            }, 100);
        })
    }

    // on check level 4
    onSelectLevel4(e, id) {
        const { level4, exhibitDetailsList, area } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!exhibitDetailsList.includes(level4[i])) {
                        level4[i].errArr = [];
                        level4[i].isLengthValidate = false;
                        exhibitDetailsList.push(level4[i])
                        this.setState({ exhibitDetailsList: exhibitDetailsList })
                    }
                }
                else {
                    this.setState({ exhibitDetailsList: exhibitDetailsList.filter(item => item.ChapterID != level4[i]['ChapterID']) })
                }

                level4[i]['IsSelect'] = !level4[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ level4: level4, exhibitDetailsTableErr: '', isDoubleStorey: false, doubleStoreyArea: '', doubleStoreyAreaErr: '', schemeType: '', schemeTypeErr: '', stallAreaId: '', stallAreaIdErr: '', stallAreaList: [], stallAreaName: '', area: '', InternationalArea: '' }, () => {
                // this.adjustInternationalArea(area)
                setTimeout(() => {
                    this.adjustCalculatedArea(null)
                }, 100);
            })
        }, 200);
    }

    // on check level 2
    onCheckLevel2(e, id) {
        const { level2, exhibitDetailsList, isDoubleStorey, doubleStoreyArea, schemeType, area, schemeTypeErr, stallAreaId, stallAreaIdErr, stallAreaList } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level2.length; i++) {
            if (level2[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!exhibitDetailsList.includes(level2[i])) {
                        level2[i].errArr = [];
                        level2[i].isLengthValidate = false;
                        exhibitDetailsList.push(level2[i])
                        this.setState({ exhibitDetailsList: exhibitDetailsList })
                    }

                }
                else {
                    this.setState({ exhibitDetailsList: exhibitDetailsList.filter(item => item.ChapterID != level2[i]['ChapterID']) })
                }

                level2[i]['IsSelect'] = !level2[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ level2: level2, isDoubleStorey: false, doubleStoreyArea: '', doubleStoreyAreaErr: '', schemeType: '', schemeTypeErr: '', stallAreaId: '', stallAreaIdErr: '', stallAreaList: [], stallAreaName: '', area: '', InternationalArea: '' }, () => {
                // this.adjustInternationalArea(area)
                setTimeout(() => {
                    this.adjustCalculatedArea(null)
                }, 100);
            })
        }, 200);
    }

    // on check level 3
    onCheckLevel3(e, id) {
        const { level3, exhibitDetailsList, area } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!exhibitDetailsList.includes(level3[i])) {
                        level3[i].errArr = [];
                        level3[i].isLengthValidate = false;
                        exhibitDetailsList.push(level3[i])
                        this.setState({ exhibitDetailsList: exhibitDetailsList })
                    }
                }
                else {
                    this.setState({ exhibitDetailsList: exhibitDetailsList.filter(item => item.ChapterID != level3[i]['ChapterID']) })
                }

                level3[i]['IsSelect'] = !level3[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ level3: level3, isDoubleStorey: false, doubleStoreyArea: '', doubleStoreyAreaErr: '', schemeType: '', schemeTypeErr: '', stallAreaId: '', stallAreaIdErr: '', stallAreaList: [], stallAreaName: '', area: '', InternationalArea: '' }, () => {
                // this.adjustInternationalArea(area)
                setTimeout(() => {
                    this.adjustCalculatedArea(null)
                }, 100);
            })
        }, 200);
    }

    // to call level third list 
    record(level2, level3, level4) {
        // var newdata = JSON.stringify(data);
        var tempLevel3 = [];
        for (var j = 0; j < level3.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} data-bs-parent="#accordionExample">
                    {
                        tempLevel3 && tempLevel3.map(level3data => {
                            return (
                                <div class="accordion-body">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={'#collapse_l2_' + level3data.ChapterID} aria-expanded="false" aria-controls={'collapse_l2_' + level3data.ChapterID}>
                                                {/* // checkbox for level3 */}
                                                {
                                                    level3data.IsCheckbox && <input type="checkbox" className="from-left-sp"
                                                        name="" key={level3data.ChapterID} checked={level3data.IsSelect}
                                                        onClick={e => this.onCheckLevel3(e, level3data.ChapterID)} />
                                                }

                                                {level3data.ChapterName} </button>
                                        </h2>
                                        {this.recordFour(level3data, level4)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        );
    }

    // to call level four list
    recordFour(level3data, level4) {
        var tempLevel4 = [];
        for (var j = 0; j < level4.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {
                    tempLevel4 && tempLevel4.map(level4data => {
                        return (
                            <div class="accordion-body third-step">
                                {/* level4data.IsCheckbox && */}
                                <input type="checkbox" name="" key={level4data.ChapterID} checked={level4data.IsSelect}
                                    onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID)} />
                                {level4data.ChapterName}
                            </div>
                        )
                    })
                }
            </div>
        </>);
    }

    onSchemeTypeChange(e, id, flag) {
        const { countryId, exhibitDetailsList, stallAreaList, schemeTypeList, area, InternationalArea, stallAreaId } = this.state
        console.log('id :', id, schemeTypeList);
        if (e) {
            e.preventDefault();
        }
        var minAreaAsModule = 0
        this.getFillList(lengthActionId, sessionStorage.getItem("sessionExhibitionID"), '', id, sessionStorage.getItem("countryId"), '')
        this.getFillList(breadthActionId, sessionStorage.getItem("sessionExhibitionID"), '', id, sessionStorage.getItem("countryId"), '')
        this.setState({ schemeType: id, schemeTypeErr: '', isDoubleStorey: false, doubleStoreyArea: '', stallAreaId: '' })
        for (var i = 0; i < exhibitDetailsList.length; i++) {
            if (id == 1) {
                if (exhibitDetailsList[i].MinBareArea != '' && exhibitDetailsList[i].MinBareArea != null) {
                    if (minAreaAsModule < exhibitDetailsList[i].MinBareArea) {
                        minAreaAsModule = exhibitDetailsList[i].MinBareArea
                    }
                }
            } else if (id == 2) {
                if (exhibitDetailsList[i].MinShellArea != '' && exhibitDetailsList[i].MinShellArea != null) {
                    if (minAreaAsModule < exhibitDetailsList[i].MinShellArea) {
                        minAreaAsModule = exhibitDetailsList[i].MinShellArea
                    }
                }
            }
        }
        this.getFillList(stallSizeActionId, sessionStorage.getItem("sessionExhibitionID"), minAreaAsModule == 0 ? '' : minAreaAsModule, id, countryId, '').then((res) => {
            this.getFillList(fullStallAreaActionId, sessionStorage.getItem("sessionExhibitionID"), '', 1, countryId, '').then(() => {
                this.setState({ isLoading: false, InternationalArea: '' }, () => {
                    // this.adjustInternationalArea(area)
                    setTimeout(() => {
                        if (flag == 1 && area != '' && area != null) {
                            for (var i = 0; i < res.length; i++) {
                                console.log(' stallAreaList[i].Code', res[i])
                                if (res[i].StallArea == area) {
                                    this.setState({ stallAreaId: res[i].Code }, () => {
                                        this.adjustCalculatedArea(area)
                                    })
                                }
                            }
                        } else {
                            setTimeout(() => {
                                this.adjustCalculatedArea(null)
                            }, 100);
                        }
                    }, 200);
                })
            })
        })
    }

    onLengthTypeChange(e) {
        this.setState({ stallAreaId: e.target.value, stallAreaIdErr: '' })
        console.log(e.target.value)
        const { stallAreaList, exhibitDetailsList, internationalAreaSlabList, area } = this.state
        for (var i = 0; i < stallAreaList.length; i++) {
            if (stallAreaList[i].Code == e.target.value) {
                if (sessionStorage.getItem("minIntArea") == null || (sessionStorage.getItem("minIntArea") <= stallAreaList[i].StallArea)) {
                    var isForeginCountry = exhibitDetailsList.some(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                    if (isForeginCountry && stallAreaList[i].StallArea == 9 && sessionStorage.getItem("countryId") == 91) {
                        this.setState({ minAreaPop1: true, InternationalArea: 0, IAbare: 0, IAshell: 0, isShowInternationalArea: false })
                        return
                    }
                    if (isForeginCountry && stallAreaList[i].StallArea == 18 && sessionStorage.getItem("countryId") == 91) {
                        this.setState({ minAreaPop2: true })
                        return
                    }
                    // const totalArea = exhibitDetailsList.reduce((sum, obj) => sum + obj.Area, 0)
                    // console.log('stallAreaList[i].StallArea  : ', stallAreaList[i].StallArea);
                    // console.log('totalArea  : ', totalArea);
                    // if (stallAreaList[i].StallArea < totalArea) {
                    //     this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
                    // } else {
                    //     this.setState({ lengthWidthErr: '' })
                    // }
                    this.setState({ stallAreaName: stallAreaList[i].Description, area: stallAreaList[i].StallArea, openSlides: '', lengthWidthErr: '', isDoubleStorey: false, isSSIandTMMAITAMMMA: false })
                    this.setState({
                        isSSIandTMMAITAMMMA: false, TMMAITAMMA: (this.state.isTMMAITAMMAdeleted) ? '' : this.state.TMMAITAMMA, isSSi: false,
                    })
                    if (this.state.isSSIdeleted) {
                        this.setState({ isSSifile: '', isSSifilePath: '', isSSifileType: '' })
                    }
                    if (this.state.isTMMAITAMMAdeleted) {
                        this.setState({ TMMAITAMMAfile: '', TMMAITAMMAfilePath: '', TMMAITAMMAfileType: '' })
                    }
                    // const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                    // const filterArrayBroSome = exhibitDetailsList.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                    // const filterArrayNational = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
                    // var tempTotal = exhibitDetailsList.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    // var total = 0
                    // if (tempTotal == 0) {
                    //     for (var j = 0; j < internationalAreaSlabList.length; j++) {
                    //         if (internationalAreaSlabList[j].FromRange - 1 < stallAreaList[i].StallArea && stallAreaList[i].StallArea <= internationalAreaSlabList[j].ToRange) {
                    //             total = internationalAreaSlabList[j].MinArea
                    //         }
                    //     }
                    // } else {
                    //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    //     if (totalInternational == 0) {
                    //         if ((stallAreaList[i].StallArea - totalNational) > 0) {
                    //             total = stallAreaList[i].StallArea - totalNational
                    //         } else {
                    //             total = 0
                    //         }
                    //     } else {
                    //         if (stallAreaList[i].StallArea >= totalInternational) {
                    //             total = totalInternational
                    //         } else {
                    //             total = 0
                    //         }
                    //     }
                    // }
                    // // setTimeout(() => {
                    // if (filterArrayBroSome) {
                    //     this.setState({ InternationalArea: total })
                    // } else {
                    //     this.setState({ InternationalArea: 0 })
                    // }
                    // this.adjustInternationalArea(stallAreaList[i].StallArea)
                    console.log(stallAreaList[i])
                    this.adjustCalculatedArea(stallAreaList[i].StallArea)
                    // this.adjustIntAreaNew(stallAreaList[i].StallArea)
                    // setTimeout(() => {
                    // }, 100);
                } else {
                    this.setState({ stallAreaId: '' })
                    toastError(`Mininum Area should be ${sessionStorage.getItem("minIntArea")}`)
                }
            }
        }
    }

    onCheckdoubleStorey(e) {
        const { area, minArea, minAreaPercent, isDoubleStorey, doubleStoreyArea } = this.state
        console.log(area, minArea,)
        if (area < minArea) {
            toastError(`Please select Area that is more than or equal to ${minArea} to enable Double Storey`)
        }
        else {
            var tempArea = (area * (minAreaPercent / 100))
            this.setState({ isDoubleStorey: !isDoubleStorey, doubleStoreyArea: tempArea })
        }
    }

    onSSITMMAITAMMAClick() {
        const { isSSIandTMMAITAMMMA, TMMAITAMMA, isSSi, SSIMaxArea, area, isSSIdeleted, isTMMAITAMMAdeleted, isSSifile, isSSifilePath, isSSifileType, TMMAITAMMAfile, TMMAITAMMAfilePath, TMMAITAMMAfileType, is_update } = this.state
        console.log(area)
        if (area != '' && area != null) {

            // if (area <= SSIMaxArea) {
            if (isSSIandTMMAITAMMMA == false) {
                this.setState({ isSSIandTMMAITAMMMA: true, isSSi: true, TMMAITAMMA: (isTMMAITAMMAdeleted) ? '1' : TMMAITAMMA })
            }
            else {
                this.setState({
                    isSSIandTMMAITAMMMA: false, TMMAITAMMA: (isTMMAITAMMAdeleted) ? '' : TMMAITAMMA, isSSi: false,
                })
                if (isSSIdeleted) {
                    this.setState({ isSSifile: '', isSSifilePath: '', isSSifileType: '' })
                }
                if (isTMMAITAMMAdeleted) {
                    this.setState({ TMMAITAMMAfile: '', TMMAITAMMAfilePath: '', TMMAITAMMAfileType: '' })
                }
                // this.onCrossClickSSI()
                // this.onCrossClickITMATAMMA()
            }
            // } else {
            //     toastError(`Maximum area allowed for SSI Discount is ${SSIMaxArea}sqm`)
            // }
        } else {
            toastError('please select Area')
        }
    }

    onFilePickSSI = async (e, file) => {
        e.preventDefault()
        const { } = this.state
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFileSSI(file[0]);
                        this.setState({ isSSifile: image })
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelectSSI(file[0]);
                        this.setState({ isSSifile: image })
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ isSSifileType: fileTypeList.length > 0 ? fileTypeList[1] : "", isSSifileErr: '', })
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                }
            }
        }
    }
    resizeFileSSI = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });
    onPdfSelectSSI = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });
    onCrossClickSSI() {
        this.setState({ isSSifile: "" })
        document.getElementById("path").value = ""
    }

    onChangeDoubleStorey(e) {
        const { area, minAreaPercent, doubleStoreyArea } = this.state
        var newArea = e.target.value
        var maxArea = (area * (minAreaPercent / 100))
        if (area != '' && area != null) {
            if (newArea > maxArea) {
                this.setState({ doubleStoreyArea: '' })
                toastError(`Double storey area cannot be more than ${minAreaPercent}% of selected Area`)
            }
            else {
                this.setState({ doubleStoreyArea: newArea, doubleStoreyAreaErr: '' })
            }
        }
        else {
            toastError("please select area")
        }
    }


    onFilePickITMATAMMA = async (e, file) => {
        e.preventDefault()
        const { } = this.state
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFileITMATAMMA(file[0]);
                        this.setState({ TMMAITAMMAfile: image })
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelectITMATAMMA(file[0]);
                        this.setState({ TMMAITAMMAfile: image })
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ TMMAITAMMAfileType: fileTypeList.length > 0 ? fileTypeList[1] : "", TMMAITAMMAfileErr: '' })
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                }
            }
        }
    }
    resizeFileITMATAMMA = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });
    onPdfSelectITMATAMMA = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });
    onCrossClickITMATAMMA() {
        this.setState({ TMMAITAMMAfile: "" })
        document.getElementById("path").value = ""
    }

    adjustInternationalArea(area) {
        const { isLoading, newPopCountry, exhRegistrationID, primaryChapterListData, primaryChapterRadio,
            level2, level3, level4, schemeType, schemeTypeList, countryId,
            stallAreaId, stallAreaList, openSlideRadio, openSlides, exhibitDetailsList, undertakingNote,
            openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, internationalAreaSlabList, } = this.state
        if (area != '' && area != null) {
            this.setState({
                isShowInternationalArea: true
            })

            const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
            const filterArrayBroSome = exhibitDetailsList.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
            console.log()
            const filterArrayNational = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
            var tempTotal = exhibitDetailsList.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            var total = 0
            var isErr = false
            var Err = ''
            console.log('tempTotaltempTotal', tempTotal, internationalAreaSlabList)

            // if (tempTotal == 0) {
            for (var i = 0; i < internationalAreaSlabList.length; i++) {
                // console.log('internationalAreaSlabList[i].FromRange', internationalAreaSlabList[i].FromRange, area)
                if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
                    total = internationalAreaSlabList[i].MinArea
                }
            }
            // } else {
            //     var isIntBrochure = filterArray.some((item) => !item.isMachine && item.isBrochure)
            //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            //     if (isIntBrochure) {
            //         if (totalInternational != 0) {
            //             if (area >= totalInternational) {
            //                 total = totalInternational
            //             } else {
            //                 total = 0
            //             }
            //         } else {
            //             var remArea = 0
            //             for (var i = 0; i < internationalAreaSlabList.length; i++) {
            //                 // console.log('internationalAreaSlabList[i].FromRange', internationalAreaSlabList[i].FromRange, area)
            //                 if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
            //                     remArea = area - internationalAreaSlabList[i].MinArea
            //                     total = internationalAreaSlabList[i].MinArea
            //                 }
            //             }
            //             if (remArea < (totalInternational + totalNational)) {
            //                 isErr = true
            //             }
            //         }
            //     } else {
            //         if (totalInternational == 0) {
            //             if ((area - totalNational) > 0) {
            //                 total = area - totalNational
            //             } else {
            //                 total = 0
            //             }
            //         } else {
            //             if (area >= totalInternational) {
            //                 total = totalInternational
            //             } else {
            //                 total = 0
            //             }
            //         }
            //     }
            // }

            // var minArea = 0
            // for (var i = 0; i < internationalAreaSlabList.length; i++) {
            //     console.log(area, total)
            //     if (internationalAreaSlabList[i].FromRange < area && area <= internationalAreaSlabList[i].ToRange) {
            //         if (total >= internationalAreaSlabList[i].MinArea) {
            //             total = total
            //             minArea = total
            //         } else {
            //             total = internationalAreaSlabList[i].MinArea
            //             minArea = internationalAreaSlabList[i].MinArea
            //         }
            //     }
            // }
            // setTimeout(() => {
            //     if (filterArray.length > 0) {
            //         // if (minArea == 0) {
            //         //     const filterArrayNational = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
            //         //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            //         //     if ((parseFloat(area) / 2) < totalNational) {
            //         //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
            //         //     } else {
            //         //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
            //         //     }
            //         // } else {
            //         this.setState({ InternationalArea: total })
            //         // }
            //         // if (minArea != 0) {
            //         //     this.setState({ InternationalArea: total })
            //         // }
            //     } else {
            //         this.setState({ InternationalArea: 0 })
            //     }
            //     this.setState({ exhibitDetailsList: exhibitDetailsList })
            //     this.adjustInternationalArea(area)
            // }, 100);


            // const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
            // var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            // var minArea = 0
            // for (var j = 0; j < internationalAreaSlabList.length; j++) {
            //     if (internationalAreaSlabList[j].FromRange < area && area <= internationalAreaSlabList[j].ToRange) {
            //         if (total >= internationalAreaSlabList[j].MinArea) {
            //             total = total
            //             minArea = total
            //         } else {
            //             total = internationalAreaSlabList[j].MinArea
            //             minArea = internationalAreaSlabList[j].MinArea
            //         }
            //     }
            // }
            if (filterArrayBroSome) {
                // if (minArea == 0) {
                //     const filterArrayNational = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
                //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                //     if ((parseFloat(area) / 2) < totalNational) {
                //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) }, () => {
                //             console.log('here 1', parseFloat(area), parseFloat(totalNational))
                //         })
                //     } else {
                //         this.setState({ InternationalArea: (parseFloat(area) / 2) }, () => {
                //             console.log('here 2', (parseFloat(area) / 2))
                //         })
                //     }
                // } else {
                this.setState({
                    InternationalArea: total,
                    //  lengthWidthErr: isErr ? "Total sum of area cannot be greater than remaining stall area" : ''
                }, () => {
                    console.log('here 3', total)
                })
                // }
            } else {
                this.setState({ InternationalArea: 0, isShowInternationalArea: false }, () => {
                    console.log('here 4', 0)
                })
            }
        } else {
            this.setState({ InternationalArea: 0, isShowInternationalArea: false }, () => {
                console.log('here 4', 0)
            })
        }

    }


    adjustIntAreaNew(area) {
        const { isLoading, newPopCountry, exhRegistrationID, primaryChapterListData, primaryChapterRadio,
            level2, level3, level4, schemeType, schemeTypeList, countryId, referenceStallAreaArr,
            stallAreaId, stallAreaList, openSlideRadio, openSlides, exhibitDetailsList, undertakingNote,
            openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, internationalAreaSlabList, } = this.state
        if (area != '' && area != null) {
            var total = 0
            var psuedoList = []
            var isAllBrochure = true
            const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '' && (item.isMachine || item.IsAccessory || item.isBrochure))
            console.log('filterArrayfilterArray', filterArray)
            if (filterArray.length > 0) {
                //check 18 or 9z
                for (var i = 0; i < filterArray.length; i++) {
                    var tempJSON = {}
                    if (filterArray[i].isBrochure) {
                        tempJSON = JSON.parse(JSON.stringify(filterArray[i]))
                        tempJSON.IsAccessory = false
                        tempJSON.isMachine = false
                        psuedoList.push(tempJSON)
                    }
                    if (filterArray[i].IsAccessory) {
                        tempJSON = JSON.parse(JSON.stringify(filterArray[i]))
                        isAllBrochure = false
                        tempJSON.isBrochure = false
                        tempJSON.isMachine = false
                        psuedoList.push(tempJSON)
                    }
                    if (filterArray[i].isMachine) {
                        tempJSON = JSON.parse(JSON.stringify(filterArray[i]))
                        isAllBrochure = false
                        tempJSON.IsAccessory = false
                        tempJSON.isBrochure = false
                        psuedoList.push(tempJSON)
                    }
                }
                // for (var i = 0; i < psuedoList.length; i++) {
                var brochureArea = 0
                // if (containsBrochure) {
                // for (var i = 0; i < internationalAreaSlabList.length; i++) {
                //     if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
                //         brochureArea = internationalAreaSlabList[i].MinArea
                //     }
                // }
                // }
                var accNew = true
                var uniqueManuNameAcc = []
                var uniqueManuNameManuCountry = []
                var uniqueManuNameBro = []
                var uniqueManuNameMachine = []
                if (isAllBrochure) {
                    this.setState({ isAllBro: true })
                    const isAllManuCountry = exhibitDetailsList.every(item => item.ManufacturingCountry != null && item.ManufacturingCountry != '')
                    const isAllMB = exhibitDetailsList.every(item => item.isMachine != undefined && item.isBrochure != undefined && item.IsAccessory != undefined ? item.isMachine || item.isBrochure || item.IsAccessory : false)
                    console.log('14785', isAllManuCountry && isAllMB && stallAreaId != '' && stallAreaId != null, isAllManuCountry, isAllMB, stallAreaId)
                    if (isAllManuCountry && isAllMB && schemeType == 1 && area <= 72) {
                        if (!this.state.prefferedPopAsk) {
                            this.setState({ prefferedPop: true })
                            return
                        }
                    }
                    var manuList = []
                    for (var i = 0; i < psuedoList.length; i++) {
                        if (psuedoList[i].ManufacturerName != '' && psuedoList[i].ManufacturerName != null) {
                            if (!manuList.includes(psuedoList[i].ManufacturerName.toLowerCase().trim())) {
                                manuList.push(psuedoList[i].ManufacturerName.toLowerCase().trim())
                            }
                        }
                    }
                    var criteriaBArea = manuList.length * 3
                    var criteriaAArea = 0
                    // if (containsBrochure) {
                    for (var i = 0; i < internationalAreaSlabList.length; i++) {
                        if (area < internationalAreaSlabList[0].FromRange) {
                            criteriaAArea = internationalAreaSlabList[0].MinArea
                        }
                        else if (internationalAreaSlabList[i].FromRange <= area && area <= internationalAreaSlabList[i].ToRange) {
                            criteriaAArea = internationalAreaSlabList[i].MinArea
                        }
                    }
                    if (criteriaBArea > criteriaAArea) {
                        for (var i = 0; i < referenceStallAreaArr.length; i++) {
                            if (criteriaBArea <= referenceStallAreaArr[i].StallArea) {
                                criteriaBArea = referenceStallAreaArr[i].StallArea
                                break
                            }

                        }
                        total = criteriaBArea
                    } else {
                        total = criteriaAArea
                    }
                } else {
                    this.setState({ isAllBro: false })
                    var machineAccArea = 0
                    for (var i = 0; i < psuedoList.length; i++) {
                        if (psuedoList[i].isMachine) {
                            // total = psuedoList[i].Area ? total + psuedoList[i].Area : total
                            if (!uniqueManuNameMachine.includes(psuedoList[i].ManufacturerName.toLowerCase().trim())) {
                                uniqueManuNameMachine.push(psuedoList[i].ManufacturerName.toLowerCase().trim())
                            }
                            // uniqueManuNameManuCountry.push({ ManufacturerName: psuedoList[i].ManufacturerName.trim(), ManufacturingCountry: psuedoList[i].ManufacturingCountry.trim() })
                        }
                    }
                    var machineArea = 0
                    for (var i = 0; i < uniqueManuNameMachine.length; i++) {
                        var tempMchineArea = 0
                        for (var j = 0; j < psuedoList.length; j++) {
                            if (psuedoList[j].isMachine) {
                                // if (psuedoList[j].Length != '' && psuedoList[j].Length != null && psuedoList[j].Length != 0 && psuedoList[j].Breadth != '' && psuedoList[j].Breadth != null && psuedoList[j].Breadth != 0) {
                                if (psuedoList[j].ManufacturerName.toLowerCase().trim() == uniqueManuNameMachine[i].toLowerCase().trim()) {
                                    tempMchineArea = tempMchineArea + (psuedoList[j].Length * psuedoList[j].Breadth)
                                    // }
                                }
                            }
                        }
                        if (tempMchineArea != 0) {
                            for (var j = 0; j < referenceStallAreaArr.length; j++) {
                                if (tempMchineArea <= referenceStallAreaArr[j].StallArea && referenceStallAreaArr[j].StallArea >= 18) {
                                    tempMchineArea = referenceStallAreaArr[j].StallArea
                                    break
                                }
                            }
                        }
                        machineArea = machineArea + tempMchineArea
                    }
                    console.log('total', total)
                    var accArea = 0
                    for (var i = 0; i < psuedoList.length; i++) {
                        if (psuedoList[i].IsAccessory) {
                            if (psuedoList[i].ManufacturerName != null && psuedoList[i].ManufacturerName != '') {
                                // console.log(uniqueManuNameManuCountry, psuedoList[i].ManufacturerName.toLowerCase().trim())
                                var isSameAcc = false
                                for (var a = 0; a < uniqueManuNameManuCountry.length; a++) {
                                    if (uniqueManuNameManuCountry[a].ManufacturerName == psuedoList[i].ManufacturerName.toLowerCase().trim() && uniqueManuNameManuCountry[a].ManufacturingCountry == psuedoList[i].ManufacturingCountry.toLowerCase().trim()) {
                                        isSameAcc = true
                                    }
                                }
                                if (uniqueManuNameMachine.includes(psuedoList[i].ManufacturerName.toLowerCase().trim())) {
                                    isSameAcc = true
                                }
                                // console.log('uniqueManuNameMachine', uniqueManuNameMachine, psuedoList)
                                if (!isSameAcc) {
                                    uniqueManuNameManuCountry.push({ ManufacturerName: psuedoList[i].ManufacturerName.toLowerCase().trim(), ManufacturingCountry: psuedoList[i].ManufacturingCountry.toLowerCase().trim() })
                                    accArea = accArea + 18
                                }
                                if (!uniqueManuNameAcc.includes(psuedoList[i].ManufacturerName.toLowerCase().trim())) {
                                    uniqueManuNameAcc.push(psuedoList[i].ManufacturerName.toLowerCase().trim())
                                }
                            }
                        }
                    }
                    console.log('total', total)
                    var manuList = []
                    for (var i = 0; i < psuedoList.length; i++) {
                        if (psuedoList[i].isBrochure) {
                            if (psuedoList[i].ManufacturerName != null && psuedoList[i].ManufacturerName != '') {
                                var isSameBro = false
                                // console.log(uniqueManuNameBro, psuedoList[i].ManufacturerName.toLowerCase().trim(), '111')
                                // if (!uniqueManuNameBro.includes(psuedoList[i].ManufacturerName.toLowerCase().trim()) && !uniqueManuNameAcc.includes(psuedoList[i].ManufacturerName.toLowerCase().trim()) && !uniqueManuNameMachine.includes(psuedoList[i].ManufacturerName.toLowerCase().trim())) {
                                //     console.log(psuedoList[i].ManufacturerName.toLowerCase().trim(), '222')
                                //     uniqueManuNameBro.push(psuedoList[i].ManufacturerName.toLowerCase().trim())
                                //     total = total + 9
                                // }
                                if (uniqueManuNameMachine.includes(psuedoList[i].ManufacturerName.toLowerCase().trim())) {
                                    isSameBro = true
                                }
                                if (uniqueManuNameAcc.includes(psuedoList[i].ManufacturerName.toLowerCase().trim())) {
                                    isSameBro = true
                                }
                                if (!isSameBro) {
                                    manuList.push(psuedoList[i].ManufacturerName.toLowerCase().trim())
                                }
                            }
                        }
                    }
                    var broArea = 0
                    if (manuList.length != 0) {
                        if ((accArea + machineArea) >= area) {
                            var criteriaBArea = manuList.length * 3
                            for (var i = 0; i < referenceStallAreaArr.length; i++) {
                                if (criteriaBArea <= referenceStallAreaArr[i].StallArea) {
                                    criteriaBArea = referenceStallAreaArr[i].StallArea
                                    break
                                }

                            }
                            broArea = criteriaBArea
                        } else {
                            var rem = area - (accArea + machineArea)
                            var criteriaAArea = 0

                            for (var i = 0; i < internationalAreaSlabList.length; i++) {
                                if (rem < internationalAreaSlabList[0].FromRange) {
                                    criteriaAArea = internationalAreaSlabList[0].MinArea
                                }
                                else if (internationalAreaSlabList[i].FromRange <= rem && rem <= internationalAreaSlabList[i].ToRange) {
                                    console.log(rem, internationalAreaSlabList[i])
                                    criteriaAArea = internationalAreaSlabList[i].MinArea
                                }
                            }
                            broArea = criteriaAArea
                        }
                    }
                    console.log('machineArea + accArea + broArea', machineArea, accArea, broArea, criteriaBArea)
                    total = machineArea + accArea + broArea
                }
                console.log('000000000000000000000000', uniqueManuNameAcc,
                    uniqueManuNameBro,
                    uniqueManuNameMachine)
                console.log('total', total)
                var newArea = total
                // if (!isAllBrochure) {
                //     for (var i = 0; i < referenceStallAreaArr.length; i++) {
                //         if (total <= referenceStallAreaArr[i].StallArea) {
                //             newArea = referenceStallAreaArr[i].StallArea
                //             break
                //         }
                //     }
                // } else {

                // }

                // setTimeout(() => {
                this.setState({ InternationalArea: newArea, isShowInternationalArea: newArea == 0 ? false : true }, () => {
                    console.log('here 4', 0)
                })
                // }, 10);
            } else {
                this.setState({ InternationalArea: 0, isShowInternationalArea: false }, () => {
                    console.log('here 4', 0)
                })
            }
        } else {
            this.setState({ InternationalArea: 0, isShowInternationalArea: false }, () => {
                console.log('here 4', 0)
            })
        }
        setTimeout(() => {
            this.setState({ InternationalAreaErr: '', lengthWidthErr: '' }, () => {
                this.adjustCalculatedArea(area)
            })
        }, 10);
    }

    fillInternationalForm() {
        const { isLoading, newPopCountry, exhRegistrationID, internationalAreaSlabList, primaryChapterListData, primaryChapterRadio,
            level2, level3, level4, schemeType, schemeTypeList, countryId, isShowInternationalArea,
            stallAreaId, stallAreaList, openSlideRadio, openSlides, exhibitDetailsList, undertakingNote,
            openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, area, minAreaPercent, doubleStoreyArea, isDoubleStorey, minArea } = this.state
        var tempStallArea = parseFloat(area) - parseFloat(InternationalArea)
        var minIntArea = 0
        const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        for (var i = 0; i < filterArray.length; i++) {
            if (filterArray[i].isMachine) {
                minIntArea = minIntArea + filterArray[i].Area
            }
        }
        var tempInternationalArea = InternationalArea
        var tempInternationalId = ''
        // var newArea = 0
        var total = 0

        console.log(tempStallArea, tempInternationalArea)
        for (var i = 0; i < stallAreaList.length; i++) {

            if (stallAreaList[i].StallArea >= tempStallArea) {
                if (isDoubleStorey) {
                    if (stallAreaList[i].StallArea < minArea) {
                        this.setState({ isDoubleStorey: false, doubleStoreyArea: '' })
                    } else {
                        var maxArea = (stallAreaList[i].StallArea * (minAreaPercent / 100))
                        if (doubleStoreyArea > maxArea) {
                            this.setState({ doubleStoreyArea: maxArea })
                            // toastError(`Double storey area cannot be more than ${minAreaPercent}% of selected Area`)
                        }
                    }
                }
                // var newArea = e.target.value
                // newArea = stallAreaList[i].StallArea
                for (var j = 0; j < exhibitDetailsList.length; j++) {
                    if (exhibitDetailsList[j].ManufacturingCountry != '' && exhibitDetailsList[j].ManufacturingCountry != null) {
                        if (exhibitDetailsList[j].ManufacturingCountry.toLowerCase().trim() != 'india' && (exhibitDetailsList[j].isBrochure || exhibitDetailsList[j].IsAccessory) && !exhibitDetailsList[j].isMachine) {
                            for (var k = 0; k < internationalAreaSlabList.length; k++) {
                                // console.log('internationalAreaSlabList[i].FromRange', internationalAreaSlabList[i].FromRange, area)
                                if (internationalAreaSlabList[k].FromRange - 1 < stallAreaList[i].StallArea && stallAreaList[i].StallArea <= internationalAreaSlabList[k].ToRange) {
                                    // remArea = stallAreaList[i].StallArea - internationalAreaSlabList[k].MinArea
                                    total = internationalAreaSlabList[k].MinArea
                                }
                            }
                        }
                    }
                }
                this.setState({ stallAreaName: stallAreaList[i].Description, area: stallAreaList[i].StallArea, stallAreaId: stallAreaList[i].Code, InternationalArea: total, isShowInternationalArea: total != 0 ? true : false })
                break
            }
        }
        for (var i = 0; i < this.state.stallAreaList.length; i++) {
            console.log(' this.state.InternationalFormAreaNew', this.state.stallAreaList[i].StallArea, this.state.InternationalFormAreaNew)
            if (this.state.stallAreaList[i].StallArea >= tempInternationalArea) {
                tempInternationalArea = this.state.stallAreaList[i].StallArea
                tempInternationalId = this.state.stallAreaList[i].Code
                // this.setState({
                //     stallAreaId: this.state.stallAreaList[i].Code,
                //     area: this.state.stallAreaList[i].StallArea,
                // })
                break
            }
            // else if (this.state.stallAreaList[i].StallArea > this.state.InternationalFormAreaNew) {
            //     this.setState({
            //         stallAreaId: this.state.stallAreaList[i].Code,
            //         area: this.state.stallAreaList[i].StallArea,
            //     })
            //     break
            // }
        }
        for (var i = 0; i < exhibitDetailsList.length; i++) {
            if (exhibitDetailsList[i].ManufacturingCountry != '' && exhibitDetailsList[i].ManufacturingCountry != null) {
                if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].isMachine) {
                    for (var j = 0; j < level2.length; j++) {
                        if (exhibitDetailsList[i].ChapterID == level2[j].ChapterID) {
                            level2[j].IsSelect = false
                        }
                    }
                    for (var j = 0; j < level3.length; j++) {
                        if (exhibitDetailsList[i].ChapterID == level3[j].ChapterID) {
                            level3[j].IsSelect = false
                        }
                    }
                    for (var j = 0; j < level4.length; j++) {
                        if (exhibitDetailsList[i].ChapterID == level4[j].ChapterID) {
                            level4[j].IsSelect = false
                        }
                    }
                }
            }
        }

        this.setState({
            level2: level2, level3: level3, level4: level4
        }, () => {
            var newExhibitDetailsList = exhibitDetailsList.filter(data => data.ManufacturingCountry != '' && data.ManufacturingCountry != null ? data.ManufacturingCountry.toLowerCase().trim() == 'india' ? data.ManufacturingCountry.toLowerCase().trim() == 'india' : !data.isMachine : '');
            this.setState({ exhibitDetailsList: newExhibitDetailsList })
            setTimeout(() => {
                if (newExhibitDetailsList.length > 0) {
                    this.handleStep2Insert(1).then(() => {
                        var url = `${link_BASE_URL}registration/${this.state.UUID}#&${exhRegistrationID}#&${newPopCountry}#&${minIntArea}#&${tempInternationalId}`;
                        // var url = `${link_BASE_URL}primary_chapter/${this.state.UUID}#&${exhRegistrationID}#&${newPopCountry}#&${tempInternationalArea}`;
                        const win = window.open(url, '_blank', 'noopener,noreferrer');
                        if (win != null) {
                            win.focus();
                        }
                    })
                } else {
                    var url = `${link_BASE_URL}registration/${this.state.UUID}#&${exhRegistrationID}#&${newPopCountry}#&${minIntArea}#&${tempInternationalId}`;
                    // var url = `${link_BASE_URL}primary_chapter/${this.state.UUID}#&${exhRegistrationID}#&${newPopCountry}#&${tempInternationalArea}`;
                    const win = window.open(url, '_blank', 'noopener,noreferrer');
                    if (win != null) {
                        win.focus();
                    }
                }
            }, 500);
        })

    }

    onFilePick = async (e, file, i) => {
        e.preventDefault()
        const { exhibitDetailsList, tempFilePath } = this.state
        // console.log("File01010101------", file, key)
        const { } = this.state
        console.log(file, document.getElementById(`file${i}`), tempFilePath)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {

                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                        exhibitDetailsList[i].DocumentFile = image
                        exhibitDetailsList[i].DocumentName = file[0]['name'].toString()
                        //     visitorGroupList[i].passportFileErr = ''
                        this.setState({ exhibitDetailsList: exhibitDetailsList })
                        // } else {
                        // this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString() })
                        // }

                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        // if (key == 1) {
                        // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                        exhibitDetailsList[i].DocumentFile = image
                        exhibitDetailsList[i].DocumentName = file[0]['name'].toString()
                        this.setState({ exhibitDetailsList: exhibitDetailsList })
                        // } else {
                        // this.setState({ passportFile: image, passportFileErr: "" })
                        // }
                        // this.setState({ passportFile: image, passportFileErr: "" })

                    }

                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")
                    }
                    // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                    //     visitorGroupList[i].passportFileType = fileTypeList.length > 0 ? fileTypeList[1] : ""
                    //     this.setState({ visitorGroupList: visitorGroupList })
                    // } else {
                    exhibitDetailsList[i].DocumentType = fileTypeList.length > 0 ? fileTypeList[1] : ""
                    // document.getElementById(`file${i}`).value = document.getElementById(`file${i}`).value

                    // this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                    // }
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')

                    // if (key == 1) {
                    //     this.setState({ passportFile: "" })
                    //     document.getElementById("passportFile").value = ""
                    // } else if (key == 2) {
                    //     this.setState({ visitorLetterFile: "" })
                    //     document.getElementById("visitorLetter").value = ""
                    // }
                }
            }
        } else {
            //     exhibitDetailsList[i].DocumentType = ''
            //     exhibitDetailsList[i].DocumentFile = ''
            //     exhibitDetailsList[i].DocumentName = ''
            //     this.setState({ exhibitDetailsList: exhibitDetailsList })
        }
    }

    // If Pdf is selected in file
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    // File resize
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    onCrossClick(i) {
        const { exhibitDetailsList } = this.state
        // i = i - 1
        // console.log(isPassportFilePresent, i + 1)
        // if (sessionStorage.getItem('VisitorTypeID') == 1) {
        // console.log('isPassportFilePresent', isPassportFilePresent)
        if (exhibitDetailsList[i].isFilePresent) {
            // const { isOpen3 } = this.state
            // this.setState({ isOpen3: !isOpen3 })
            // exhibitDetailsList[i].DocumentType = ''
            // exhibitDetailsList[i].DocumentFile = ''
            // exhibitDetailsList[i].DocumentName = ''
            // this.setState({ exhibitDetailsList: exhibitDetailsList })
            console.log("condition------------1111111111")
        } else {
            console.log("condition------------2222222222")
            // if (key == 1) {
            // if (mode == 1) {
            //     this.setState({ passportFile: "", isVisaApplied: false })
            // } else {
            exhibitDetailsList[i].DocumentType = ''
            exhibitDetailsList[i].DocumentFile = ''
            exhibitDetailsList[i].DocumentName = ''
            this.setState({ exhibitDetailsList: exhibitDetailsList })
            document.getElementById(`file${i}`).value = ""
            // }
            // } else if (key == 2) {
            //     this.setState({ visitorLetterFile: "" })
            //     document.getElementById("visitorLetter").value = ""
            // }
        }
    }


    renderNewImage = (img, type) => {
        const { imageBase64 } = this.state;
        if (type == 'pdf') {
            // window.open(img, "_blank")

            const base64 = img;
            const pdfData = atob(base64.split(",")[1]); // decode Base64

            const len = pdfData.length;
            const uintArray = new Uint8Array(new ArrayBuffer(len));
            for (let i = 0; i < len; i++) {
                uintArray[i] = pdfData.charCodeAt(i);
            }

            const blob = new Blob([uintArray], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);

            window.open(url, "_blank"); // open in new tab

        } else {
            const newWindow = window.open();
            if (newWindow) {
                newWindow.document.write(
                    `<img src="${img}" style="width:100%;height:auto;" />`
                );
            } else {
                alert("Please allow popups for this website");
            }
        }
    };

    getExhibitionSSRCountryMappingData(exhCode) {
        this.setState({ isLoading: true });
        return new Promise((resolve, reject) => {
            this.props
                .getExhibitionSSRCountryMappingData_action(exhCode)
                .then((data) => {
                    if (data.error != 1 && data.data != null && data.data.length > 0) {
                        // console.log(data.data, 'agent')
                        // var chapterIDArr = data.data[0]["ChapterID"] != '' && data.data[0]["ChapterID"] != null ? data.data[0]["ChapterID"].split(',') : []
                        // console.log(chapterIDArr, 'chapterIDArr')
                        // for (var i = 0; i < chapterIDArr.length; i++) {
                        //     chapterIDArr[i] = chapterIDArr[i].trim()
                        //     chapterIDArr[i] = parseInt(chapterIDArr[i])
                        // }
                        this.setState({ SSRCountryList: data.data });
                        // resolve(true)
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.msg);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    changetoExpArea() {
        const { isLoading, newPopCountry, internationalAreaSlabList, exhRegistrationID, primaryChapterListData, primaryChapterRadio,
            level2, level3, isOpen2, level4, schemeType, schemeTypeList, countryId, selectedPrimaryChapterId, selectedPrimaryChapterIdList,
            stallAreaId, stallAreaList, isOpen4,
            expectedArea, openSlideRadio, openSlides, exhibitDetailsList, undertakingNote,
            openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, area, isOpenConfirmationModal, stallAreaName } = this.state
        console.log(this.state.expectedAreaId, stallAreaList, expectedArea)
        return new Promise((resolve, reject) => {
            stallAreaList.map(item => {
                if (item.Code == this.state.expectedAreaId) {
                    this.setState({ area: expectedArea, stallAreaId: this.state.expectedAreaId, isOpen4: false, isOpen10: false, lengthWidthErr: '' })
                    toastSuccess(`Stall Area updated to ${expectedArea}`)
                }
            })
            setTimeout(() => {
                // this.adjustIntAreaNew(expectedArea)
                resolve(true)
            }, 200);
        })
    }

    checksameMFandCountry() {
        const { exhibitDetailsList, countryId } = this.state;
        return new Promise((resolve, reject) => {
            console.log(exhibitDetailsList, 'check')
            if (sessionStorage.getItem("sessionContryName").toLowerCase().trim() == 'india') {
                var returnvalue = true
                // var isCheckAll = true
                // for (var i = 0; i < exhibitDetailsList.length; i++) {
                //     if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india') {
                //         isCheckAll = false
                //         break
                //     }
                // }
                // if (isCheckAll) {
                for (var i = 0; i < exhibitDetailsList.length; i++) {
                    if (exhibitDetailsList[i].ManufacturingCountry != '' && exhibitDetailsList[i].ManufacturerName != '') {
                        if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() == 'india') {
                            if (exhibitDetailsList[i].ManufacturerName.toLowerCase().trim() != sessionStorage.getItem("companyName").toLowerCase().trim()) {
                                exhibitDetailsList[i].ManufacturerName = ''
                                returnvalue = false
                                this.setState({ OpensameCountryManuErr: true })
                                // break
                            }
                        }
                    }
                }
                this.setState({ exhibitDetailsList: exhibitDetailsList })
                // }
                resolve(returnvalue)
            } else {
                var returnvalue = true
                for (var i = 0; i < exhibitDetailsList.length; i++) {
                    if (exhibitDetailsList[i].ManufacturingCountry != '' && exhibitDetailsList[i].ManufacturerName != '') {
                        // if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() == 'india') {
                        if (exhibitDetailsList[i].ManufacturerName.toLowerCase().trim() != sessionStorage.getItem("companyName").toLowerCase().trim()) {
                            exhibitDetailsList[i].ManufacturerName = ''
                            returnvalue = false
                            this.setState({ OpensameCountryManuErr: true })
                            // break
                        }
                    }
                    // }
                }
                this.setState({ exhibitDetailsList: exhibitDetailsList })
                resolve(returnvalue)
            }
        })
    }

    // checksameMFandCountry() {
    //     const { exhibitDetailsList } = this.state;
    //     if (sessionStorage.getItem("sessionContryName").toLowerCase().trim() == 'india') {
    //         var manName = ''
    //         for (var i = 0; i < exhibitDetailsList.length; i++) {
    //             if (exhibitDetailsList[i].ManufacturingCountry != '' && exhibitDetailsList[i].ManufacturerName != '') {
    //                 if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() == 'india') {
    //                     if (exhibitDetailsList[i].ManufacturerName.toLowerCase().trim() != sessionStorage.getItem("companyName").toLowerCase().trim()) {
    //                         exhibitDetailsList[i].ManufacturerName = ''
    //                         this.setState({ OpensameCountryManuErr: true })
    //                         break
    //                     }
    //                 }
    //             }
    //         }
    //         this.setState({ exhibitDetailsList: exhibitDetailsList })
    //     }
    // }
    adjustCalculatedArea(area) {
        const { isLoading, newPopCountry, exhRegistrationID, primaryChapterListData, primaryChapterRadio,
            level2, level3, level4, schemeType, schemeTypeList, countryId, referenceStallAreaArr,
            stallAreaId, stallAreaList, openSlideRadio, openSlides, exhibitDetailsList, undertakingNote,
            openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, internationalAreaSlabList, } = this.state
        console.log('areaaaaaaaaaaaaaaaaa', area)
        var machineArea = 0
        var accArea = 0
        var broArea = 0
        if (area != '' && area != null) {
            var total = 0
            var totalBare = 0
            var totalShell = 0
            var psuedoList = []
            var isAllBrochure = true
            const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '' && (item.isMachine || item.IsAccessory || item.isBrochure))
            console.log('filterArrayfilterArray', filterArray)
            if (filterArray.length > 0 && sessionStorage.getItem("countryId") == 91) {
                const check1 = exhibitDetailsList.every(item => !item.isMachine)
                const check2 = exhibitDetailsList.every(item => !item.IsAccessory)
                const check3 = exhibitDetailsList.some(item => item.isBrochure)
                if (check1 && check2 && check3) {
                    var uniqueManuNameBro = []
                    this.setState({ isAllBro: true })
                    const isAllManuCountry = exhibitDetailsList.every(item => item.ManufacturingCountry != null && item.ManufacturingCountry != '')
                    const isAllMB = exhibitDetailsList.every(item => item.isMachine != undefined && item.isBrochure != undefined && item.IsAccessory != undefined ? item.isMachine || item.isBrochure || item.IsAccessory : false)
                    // console.log('14785', isAllManuCountry && isAllMB && stallAreaId != '' && stallAreaId != null, isAllManuCountry, isAllMB, stallAreaId)
                    if (isAllManuCountry && isAllMB && schemeType == 1 && area <= 72) {
                        if (!this.state.prefferedPopAsk && sessionStorage.getItem("sessionContryName").toLowerCase().trim() == 'india') {
                            this.setState({ prefferedPop: true })
                            return
                        }
                    }
                    for (var i = 0; i < exhibitDetailsList.length; i++) {
                        if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '') {
                            // if (!exhibitDetailsList[i].isMachine && !exhibitDetailsList[i].IsAccessory && exhibitDetailsList[i].isBrochure) {
                            if (exhibitDetailsList[i].ManufacturerName != null && exhibitDetailsList[i].ManufacturerName != '') {
                                var isSameBro = false
                                if (uniqueManuNameBro.includes(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())) {
                                    isSameBro = true
                                }
                                if (!isSameBro) {
                                    uniqueManuNameBro.push(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())
                                }
                            } else {
                                exhibitDetailsList[i].CalculatedArea = 0
                                exhibitDetailsList[i].ShellScheme = ''
                            }
                            // }
                        } else {
                            exhibitDetailsList[i].CalculatedArea = 0
                            exhibitDetailsList[i].ShellScheme = ''
                        }
                    }
                    var manuList = []
                    for (var i = 0; i < uniqueManuNameBro.length; i++) {
                        manuList.push({ 'ManufacturerName': uniqueManuNameBro[i].toLowerCase().trim(), isShow: 0, isRepeat: 0 })
                    }
                    if (uniqueManuNameBro.length != 0) {
                        var criteriaBArea = uniqueManuNameBro.length * 3
                        for (var i = 0; i < referenceStallAreaArr.length; i++) {
                            if (criteriaBArea <= referenceStallAreaArr[i].StallArea) {
                                criteriaBArea = referenceStallAreaArr[i].StallArea
                                break
                            }
                        }

                        var criteriaAArea = 0
                        for (var i = 0; i < internationalAreaSlabList.length; i++) {
                            if (area < internationalAreaSlabList[0].FromRange) {
                                criteriaAArea = internationalAreaSlabList[0].MinArea
                            }
                            else if (internationalAreaSlabList[i].FromRange <= area && area <= internationalAreaSlabList[i].ToRange) {
                                console.log(area, internationalAreaSlabList[i])
                                criteriaAArea = internationalAreaSlabList[i].MinArea
                            }
                        }
                        console.log(criteriaBArea, criteriaAArea, 'criteriaBArea > criteriaAArea', uniqueManuNameBro)
                        if (criteriaBArea >= criteriaAArea) {
                            var noBro = criteriaBArea / 9
                            var calculatedAreaAssigned = 0
                            console.log('noBronoBronoBro', manuList, uniqueManuNameBro, noBro)
                            var gap = 0
                            for (var i = 0; i < exhibitDetailsList.length; i++) {
                                if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '') {
                                    if (uniqueManuNameBro.includes(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())) {
                                        if (calculatedAreaAssigned < noBro) {
                                            for (var j = 0; j < manuList.length; j++) {
                                                if (manuList[j].ManufacturerName.toLowerCase().trim() == exhibitDetailsList[i].ManufacturerName.toLowerCase().trim()) {
                                                    if (manuList[j].isRepeat == 0) {
                                                        if (gap == 0) {
                                                            exhibitDetailsList[i].CalculatedArea = 9
                                                            exhibitDetailsList[i].ShellScheme = 2
                                                            calculatedAreaAssigned = calculatedAreaAssigned + 1
                                                            manuList[j].isRepeat = 1
                                                            gap = 2
                                                        } else {
                                                            exhibitDetailsList[i].CalculatedArea = 0
                                                            exhibitDetailsList[i].ShellScheme = ''
                                                            gap = gap - 1
                                                            manuList[j].isRepeat = 1
                                                        }
                                                    } else {
                                                        exhibitDetailsList[i].CalculatedArea = 0
                                                        exhibitDetailsList[i].ShellScheme = ''
                                                    }
                                                }
                                            }
                                        } else {
                                            for (var j = 0; j < uniqueManuNameBro.length; j++) {
                                                if (uniqueManuNameBro[j].toLowerCase().trim() == exhibitDetailsList[i].ManufacturerName.toLowerCase().trim()) {
                                                    exhibitDetailsList[i].CalculatedArea = 0
                                                    exhibitDetailsList[i].ShellScheme = ''
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    exhibitDetailsList[i].CalculatedArea = 0
                                    exhibitDetailsList[i].ShellScheme = ''
                                }
                            }
                            total = criteriaBArea
                        } else {
                            var areainsert = false
                            for (var i = 0; i < exhibitDetailsList.length; i++) {
                                if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '') {
                                    for (var j = 0; j < uniqueManuNameBro.length; j++) {
                                        if (uniqueManuNameBro[j].toLowerCase().trim() == exhibitDetailsList[i].ManufacturerName.toLowerCase().trim()) {
                                            if (!areainsert) {
                                                exhibitDetailsList[i].CalculatedArea = criteriaAArea
                                                exhibitDetailsList[i].ShellScheme = 2
                                                areainsert = true
                                            } else {
                                                exhibitDetailsList[i].CalculatedArea = 0
                                                exhibitDetailsList[i].ShellScheme = ''
                                            }
                                        }
                                    }
                                } else {
                                    exhibitDetailsList[i].CalculatedArea = 0
                                    exhibitDetailsList[i].ShellScheme = ''
                                }
                            }
                            total = criteriaAArea
                        }
                    }

                } else {
                    var uniqueManuNameMachine = []
                    var uniqueManuNameAcc = []
                    var uniqueManuNameManuCountry = []
                    var uniqueManuNameBro = []
                    for (var i = 0; i < exhibitDetailsList.length; i++) {
                        if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '' && !exhibitDetailsList[i].isMachine && !exhibitDetailsList[i].IsAccessory && !exhibitDetailsList[i].isBrochure) {
                            exhibitDetailsList[i].CalculatedArea = 0
                            exhibitDetailsList[i].ShellScheme = ''
                        }
                    }

                    for (var i = 0; i < exhibitDetailsList.length; i++) {
                        // console.log('++++++++++++++++++', exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '' && (exhibitDetailsList[i].isMachine || exhibitDetailsList[i].IsAccessory || exhibitDetailsList[i].isBrochure), exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '', exhibitDetailsList[i].isMachine, exhibitDetailsList[i].IsAccessory, exhibitDetailsList[i].isBrochure)
                        if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '') {
                            if (exhibitDetailsList[i].isMachine) {
                                if (exhibitDetailsList[i].ManufacturerName != null && exhibitDetailsList[i].ManufacturerName != '') {
                                    exhibitDetailsList[i].tempArea = (exhibitDetailsList[i].Length * exhibitDetailsList[i].Breadth)
                                    if (!uniqueManuNameMachine.includes(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())) {
                                        for (var j = 0; j < referenceStallAreaArr.length; j++) {
                                            if (exhibitDetailsList[i].tempArea <= referenceStallAreaArr[j].StallArea && referenceStallAreaArr[j].StallArea >= 18) {
                                                exhibitDetailsList[i].CalculatedArea = referenceStallAreaArr[j].StallArea
                                                exhibitDetailsList[i].ShellScheme = referenceStallAreaArr[j].StallArea > 18 ? 1 : 2
                                                break
                                            }
                                        }
                                        uniqueManuNameMachine.push(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())
                                    } else {
                                        for (var j = 0; j < exhibitDetailsList.length; j++) {
                                            if (exhibitDetailsList[j].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[j].ManufacturingCountry != '' && (exhibitDetailsList[j].isMachine || exhibitDetailsList[j].IsAccessory || exhibitDetailsList[j].isBrochure)) {
                                                if (exhibitDetailsList[j].isMachine) {
                                                    if (exhibitDetailsList[i].ManufacturerName.toLowerCase().trim() == exhibitDetailsList[j].ManufacturerName.toLowerCase().trim()) {
                                                        exhibitDetailsList[j].tempArea = exhibitDetailsList[j].tempArea + (exhibitDetailsList[i].Length * exhibitDetailsList[i].Breadth)
                                                        for (var k = 0; k < referenceStallAreaArr.length; k++) {
                                                            if (exhibitDetailsList[j].tempArea <= referenceStallAreaArr[k].StallArea && referenceStallAreaArr[k].StallArea >= 18) {
                                                                exhibitDetailsList[j].CalculatedArea = referenceStallAreaArr[k].StallArea
                                                                exhibitDetailsList[j].ShellScheme = referenceStallAreaArr[k].StallArea > 18 ? 1 : 2
                                                                break
                                                            }
                                                        }
                                                        break
                                                    }
                                                }
                                            }
                                        }
                                        exhibitDetailsList[i].CalculatedArea = 0
                                        exhibitDetailsList[i].ShellScheme = ''
                                    }
                                } else {
                                    exhibitDetailsList[i].CalculatedArea = 0
                                    exhibitDetailsList[i].ShellScheme = ''
                                }
                            }
                        } else {
                            exhibitDetailsList[i].CalculatedArea = 0
                            exhibitDetailsList[i].ShellScheme = ''
                        }
                    }
                    for (var i = 0; i < exhibitDetailsList.length; i++) {
                        if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '') {

                            var isSameAcc = false
                            if (!exhibitDetailsList[i].isMachine && exhibitDetailsList[i].IsAccessory) {
                                if (exhibitDetailsList[i].ManufacturerName.toLowerCase().trim() != '' && exhibitDetailsList[i].ManufacturerName.toLowerCase().trim() != null) {
                                    if (uniqueManuNameMachine.includes(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())) {
                                        exhibitDetailsList[i].CalculatedArea = 0
                                        exhibitDetailsList[i].ShellScheme = ''
                                        isSameAcc = true
                                    }
                                    for (var a = 0; a < uniqueManuNameManuCountry.length; a++) {
                                        if (uniqueManuNameManuCountry[a].ManufacturerName == exhibitDetailsList[i].ManufacturerName.toLowerCase().trim() && uniqueManuNameManuCountry[a].ManufacturingCountry == exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim()) {
                                            exhibitDetailsList[i].CalculatedArea = 0
                                            exhibitDetailsList[i].ShellScheme = ''
                                            isSameAcc = true
                                        }
                                    }
                                    console.log('isSameAcc', isSameAcc, uniqueManuNameMachine, exhibitDetailsList[i])
                                    if (!isSameAcc) {
                                        uniqueManuNameManuCountry.push({ ManufacturerName: exhibitDetailsList[i].ManufacturerName.toLowerCase().trim(), ManufacturingCountry: exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() })
                                        exhibitDetailsList[i].CalculatedArea = 18
                                        exhibitDetailsList[i].ShellScheme = 2
                                        accArea = accArea + 18
                                    } else {
                                        exhibitDetailsList[i].CalculatedArea = 0
                                        exhibitDetailsList[i].ShellScheme = ''
                                    }
                                    if (!uniqueManuNameAcc.includes(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())) {
                                        uniqueManuNameAcc.push(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())
                                    }
                                } else {
                                    exhibitDetailsList[i].CalculatedArea = 0
                                    exhibitDetailsList[i].ShellScheme = ''
                                }
                            }
                        } else {
                            exhibitDetailsList[i].CalculatedArea = 0
                            exhibitDetailsList[i].ShellScheme = ''
                        }
                    }
                    for (var i = 0; i < exhibitDetailsList.length; i++) {
                        if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '') {
                            if (!exhibitDetailsList[i].isMachine && !exhibitDetailsList[i].IsAccessory && exhibitDetailsList[i].isBrochure) {
                                if (exhibitDetailsList[i].ManufacturerName != null && exhibitDetailsList[i].ManufacturerName != '') {
                                    var isSameBro = false
                                    if (uniqueManuNameMachine.includes(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())) {
                                        exhibitDetailsList[i].CalculatedArea = 0
                                        exhibitDetailsList[i].ShellScheme = ''
                                        isSameBro = true
                                    }
                                    if (uniqueManuNameAcc.includes(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())) {
                                        exhibitDetailsList[i].CalculatedArea = 0
                                        exhibitDetailsList[i].ShellScheme = ''
                                        isSameBro = true
                                    }
                                    if (uniqueManuNameBro.includes(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())) {
                                        exhibitDetailsList[i].CalculatedArea = 0
                                        exhibitDetailsList[i].ShellScheme = ''
                                        isSameBro = true
                                    }
                                    if (!isSameBro) {
                                        uniqueManuNameBro.push(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())
                                    }
                                } else {
                                    exhibitDetailsList[i].CalculatedArea = 0
                                    exhibitDetailsList[i].ShellScheme = ''
                                }
                            }
                        } else {
                            exhibitDetailsList[i].CalculatedArea = 0
                            exhibitDetailsList[i].ShellScheme = ''
                        }
                    }
                    for (var i = 0; i < exhibitDetailsList.length; i++) {
                        if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '') {
                            if (exhibitDetailsList[i].isMachine) {
                                machineArea = machineArea + exhibitDetailsList[i].CalculatedArea
                            }
                        }
                    }
                    var manuList = []
                    for (var i = 0; i < uniqueManuNameBro.length; i++) {
                        manuList.push({ 'ManufacturerName': uniqueManuNameBro[i].toLowerCase().trim(), isShow: 0, isRepeat: 0 })
                    }
                    console.log('uniqueManuNameBro', uniqueManuNameBro)
                    if (uniqueManuNameBro.length != 0) {
                        if ((accArea + machineArea) >= area) {
                            var criteriaBArea = uniqueManuNameBro.length * 3
                            for (var i = 0; i < referenceStallAreaArr.length; i++) {
                                if (criteriaBArea <= referenceStallAreaArr[i].StallArea) {
                                    criteriaBArea = referenceStallAreaArr[i].StallArea
                                    break
                                }

                            }
                            var noBro = criteriaBArea / 9
                            var calculatedAreaAssigned = 0
                            console.log('noBronoBronoBro', noBro)
                            var gap = 0
                            for (var i = 0; i < exhibitDetailsList.length; i++) {
                                if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '') {
                                    if (uniqueManuNameBro.includes(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())) {
                                        if (calculatedAreaAssigned < noBro) {
                                            for (var j = 0; j < manuList.length; j++) {
                                                if (manuList[j].ManufacturerName.toLowerCase().trim() == exhibitDetailsList[i].ManufacturerName.toLowerCase().trim()) {
                                                    if (manuList[j].isRepeat == 0) {
                                                        if (gap == 0) {
                                                            exhibitDetailsList[i].CalculatedArea = 9
                                                            exhibitDetailsList[i].ShellScheme = 2
                                                            calculatedAreaAssigned = calculatedAreaAssigned + 1
                                                            manuList[j].isRepeat = 1
                                                            gap = 2
                                                        } else {
                                                            exhibitDetailsList[i].CalculatedArea = 0
                                                            exhibitDetailsList[i].ShellScheme = ''
                                                            gap = gap - 1
                                                            manuList[j].isRepeat = 1
                                                        }
                                                    } else {
                                                        exhibitDetailsList[i].CalculatedArea = 0
                                                        exhibitDetailsList[i].ShellScheme = ''
                                                    }
                                                }
                                            }
                                        } else {
                                            for (var j = 0; j < uniqueManuNameBro.length; j++) {
                                                if (uniqueManuNameBro[j].toLowerCase().trim() == exhibitDetailsList[i].ManufacturerName.toLowerCase().trim()) {
                                                    exhibitDetailsList[i].CalculatedArea = 0
                                                    exhibitDetailsList[i].ShellScheme = ''
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    exhibitDetailsList[i].CalculatedArea = 0
                                    exhibitDetailsList[i].ShellScheme = ''
                                }
                            }
                            broArea = criteriaBArea
                        } else {
                            var rem = area - (accArea + machineArea)
                            var criteriaBArea = uniqueManuNameBro.length * 3
                            for (var i = 0; i < referenceStallAreaArr.length; i++) {
                                if (criteriaBArea <= referenceStallAreaArr[i].StallArea) {
                                    criteriaBArea = referenceStallAreaArr[i].StallArea
                                    break
                                }

                            }
                            var criteriaAArea = 0
                            for (var i = 0; i < internationalAreaSlabList.length; i++) {
                                if (rem < internationalAreaSlabList[0].FromRange) {
                                    criteriaAArea = internationalAreaSlabList[0].MinArea
                                }
                                else if (internationalAreaSlabList[i].FromRange <= rem && rem <= internationalAreaSlabList[i].ToRange) {
                                    console.log(rem, internationalAreaSlabList[i])
                                    criteriaAArea = internationalAreaSlabList[i].MinArea
                                }
                            }
                            console.log('noBronoBronoBro', criteriaBArea, criteriaAArea)

                            if (criteriaBArea >= criteriaAArea) {
                                var noBro = criteriaBArea / 9
                                var calculatedAreaAssigned = 0
                                var gap = 0
                                for (var i = 0; i < exhibitDetailsList.length; i++) {
                                    if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '') {
                                        if (uniqueManuNameBro.includes(exhibitDetailsList[i].ManufacturerName.toLowerCase().trim())) {
                                            if (calculatedAreaAssigned < noBro) {
                                                for (var j = 0; j < manuList.length; j++) {
                                                    if (manuList[j].ManufacturerName.toLowerCase().trim() == exhibitDetailsList[i].ManufacturerName.toLowerCase().trim()) {
                                                        if (manuList[j].isRepeat == 0) {
                                                            if (gap == 0) {
                                                                console.log(manuList[j], gap, exhibitDetailsList[i].ManufacturerName)
                                                                exhibitDetailsList[i].CalculatedArea = 9
                                                                exhibitDetailsList[i].ShellScheme = 2
                                                                calculatedAreaAssigned = calculatedAreaAssigned + 1
                                                                manuList[j].isRepeat = 1
                                                                gap = 2
                                                            } else {
                                                                exhibitDetailsList[i].CalculatedArea = 0
                                                                exhibitDetailsList[i].ShellScheme = ''
                                                                gap = gap - 1
                                                                manuList[j].isRepeat = 1
                                                            }
                                                        } else {
                                                            exhibitDetailsList[i].CalculatedArea = 0
                                                            exhibitDetailsList[i].ShellScheme = ''
                                                        }
                                                    }
                                                }
                                            } else {
                                                for (var j = 0; j < uniqueManuNameBro.length; j++) {
                                                    if (uniqueManuNameBro[j].toLowerCase().trim() == exhibitDetailsList[i].ManufacturerName.toLowerCase().trim()) {
                                                        exhibitDetailsList[i].CalculatedArea = 0
                                                        exhibitDetailsList[i].ShellScheme = ''
                                                    }
                                                }
                                            }
                                        }
                                    } else {
                                        exhibitDetailsList[i].CalculatedArea = 0
                                        exhibitDetailsList[i].ShellScheme = ''
                                    }
                                }
                                broArea = criteriaBArea
                            } else {
                                var areainsert = false
                                for (var i = 0; i < exhibitDetailsList.length; i++) {
                                    if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '') {
                                        for (var j = 0; j < uniqueManuNameBro.length; j++) {
                                            if (uniqueManuNameBro[j].toLowerCase().trim() == exhibitDetailsList[i].ManufacturerName.toLowerCase().trim()) {
                                                if (!areainsert) {
                                                    exhibitDetailsList[i].CalculatedArea = criteriaAArea
                                                    exhibitDetailsList[i].ShellScheme = 2
                                                    areainsert = true
                                                } else {
                                                    exhibitDetailsList[i].CalculatedArea = 0
                                                    exhibitDetailsList[i].ShellScheme = ''
                                                }
                                            }
                                        }
                                    } else {
                                        exhibitDetailsList[i].CalculatedArea = 0
                                        exhibitDetailsList[i].ShellScheme = ''
                                    }
                                }
                                broArea = criteriaAArea
                            }

                            // for (var i = 0; i < exhibitDetailsList.length; i++) {
                            //     if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india' && exhibitDetailsList[i].ManufacturingCountry != '') {
                            //         for (var j = 0; j < uniqueManuNameBro.length; j++) {
                            //             if (uniqueManuNameBro[j].toLowerCase().trim() == exhibitDetailsList[i].ManufacturerName.toLowerCase().trim()) {
                            //                 if (j == 0) {
                            //                     exhibitDetailsList[i].CalculatedArea = criteriaAArea
                            //                     exhibitDetailsList[i].ShellScheme = 2
                            //                 } else {
                            //                     exhibitDetailsList[i].CalculatedArea = 0
                            //                     exhibitDetailsList[i].ShellScheme = ''
                            //                 }
                            //             }
                            //         }
                            //     }
                            // }

                        }
                    }

                    total = machineArea + accArea + broArea


                }
                this.setState({ InternationalArea: total, isShowInternationalArea: total == 0 ? false : true }, () => {
                    console.log('here 4', 0)
                })
            } else {
                this.setState({ InternationalArea: 0, IAbare: 0, IAshell: 0, isShowInternationalArea: false }, () => {
                    console.log('here 4', 0)
                })
                for (var i = 0; i < exhibitDetailsList.length; i++) {
                    exhibitDetailsList[i].CalculatedArea = 0
                    exhibitDetailsList[i].ShellScheme = ''
                }
                this.setState({ exhibitDetailsList: exhibitDetailsList })
            }
        } else {
            this.setState({ InternationalArea: 0, IAbare: 0, IAshell: 0, isShowInternationalArea: false }, () => {
                console.log('here 4', 0)
            })
            for (var i = 0; i < exhibitDetailsList.length; i++) {
                exhibitDetailsList[i].CalculatedArea = 0
                exhibitDetailsList[i].ShellScheme = ''
                this.setState({ exhibitDetailsList: exhibitDetailsList })
            }
        }
        setTimeout(() => {
            this.setState({ exhibitDetailsList: exhibitDetailsList }, () => {
                for (var i = 0; i < exhibitDetailsList.length; i++) {
                    if (exhibitDetailsList[i].ShellScheme == 1) {
                        totalBare = totalBare + exhibitDetailsList[i].CalculatedArea
                    } else if (exhibitDetailsList[i].ShellScheme == 2) {
                        totalShell = totalShell + exhibitDetailsList[i].CalculatedArea
                    }
                }
                this.setState({ IAbare: totalBare, IAshell: totalShell, })
            })
        }, 20);
    }

    render() {
        const { isLoading, newPopCountry, internationalAreaSlabList, exhRegistrationID, primaryChapterListData, primaryChapterRadio,
            level2, level3, isOpen2, level4, schemeType, schemeTypeList, countryId, selectedPrimaryChapterId, selectedPrimaryChapterIdList,
            stallAreaId, stallAreaList, isOpen4, intAreaRulesPop, OpenMixExhibitorRule, isMixRuleAgree, isShowInternationalArea,
            expectedArea, openSlideRadio, openSlides, exhibitDetailsList, undertakingNote, OpensameCountryManuErr,
            openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, minAreaPop1, minAreaPop2, isOpen10, ExhibitDetailsNote, area, isOpenConfirmationModal, stallAreaName, CurrencyName, powerPriceList, waterPriceList, airPriceList } = this.state
        var newExhibitDetailsList = exhibitDetailsList.filter(data => data.ManufacturingCountry != '' && data.ManufacturingCountry != null ? data.ManufacturingCountry.toLowerCase().trim() == 'india' : '');
        var temp = '3.1.1 Creels @1231//2 1234 <ppop pp opp '
        temp = temp.replace(/[\\\/:\*\?"<>\|]/g, '-').replace(/ /g, "-")
        const filterArraytemp = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')

        console.log('///////////////dueDate', stallAreaId)
        console.log(this.state.InternationalArea, filterArraytemp, ',.,.,.,.,.,.,.,')

        var mandatorymix = false
        exhibitDetailsList.map(item => {
            if (item.ManufacturingCountry.toLowerCase().trim() != 'india' && sessionStorage.getItem("countryId") == 91) {
                mandatorymix = true
            }
        })

        var showMandatoryMark = false
        // showMandatoryMark = exhibitDetailsList.length > 0 && exhibitDetailsList.some(item => item.isMachine)
        var isAllBrochure = false
        const filterArray = exhibitDetailsList.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india')
        if (filterArray.length > 0) {
            for (var i = 0; i < filterArray.length; i++) {
                if (!filterArray[i].isBrochure && !filterArray[i].IsAccessory && !filterArray[i].IsAccessory) {
                    isAllBrochure = false
                    break
                }
                if (filterArray[i].ManufacturingCountry.trim() == '' || filterArray[i].ManufacturingCountry.trim() == null) {
                    isAllBrochure = false
                    break
                }
                if (filterArray[i].isBrochure) {
                    isAllBrochure = true
                }
                if (filterArray[i].IsAccessory || filterArray[i].isMachine) {
                    isAllBrochure = false
                    break
                }
            }
        } else {
            isAllBrochure = false
        }
        const ExhibitionEmail = sessionStorage.getItem('sessionExhibitionEmail') != '' && sessionStorage.getItem('sessionExhibitionEmail') != null ? JSON.parse(sessionStorage.getItem('sessionExhibitionEmail')) : []
        const ExhibitionMobileNo = sessionStorage.getItem('sessionExhibitionMobileNo') != '' && sessionStorage.getItem('sessionExhibitionMobileNo') != null ? JSON.parse(sessionStorage.getItem('sessionExhibitionMobileNo')) : []
        console.log(filterArray)
        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {/* PAGE */}
                <div className="page">
                    <div className="page-main">
                        {isDataLoad ? <Header /> : null}
                        {/*app-content open*/}
                        {false ? < div
                            className="main-content app-content mt-0"
                            style={{ backgroundColor: "#ececec", height: '100vh' }}
                        >
                            <div className="side-app">
                                <div className="main-container container-fluid top-form-name">
                                    <div className="row ">
                                        <form className="needs-validation " noValidate="">
                                            <div className="form-row mt-4">
                                                <div className="form-group col-md-7 p-4 thank-box">
                                                    <div className="form-group mb-2">
                                                        <h4
                                                            className="mb-0 pt-2 pb-4 thank-top-mes"
                                                            style={{ color: "#318958" }}
                                                        >
                                                            <strong>Important Note</strong>
                                                        </h4>
                                                        <p className="mb-1 mt-1 text-center com-font">
                                                            Currently, the application and website data are undergoing reconciliation and verification.<br></br>
                                                            The new application forms will be available shortly.
                                                        </p>
                                                    </div>
                                                    <div classname="">
                                                        <div classname="mt-1 mb-4">


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div> : <div className="main-content app-content mt-0">
                            <div className="side-app">
                                <div className="row m-0">
                                    {/* <div className="breadcrumb-scroll-fixed px-2"><h6 className="mb-0 p-2 text-white px-2">Primary Chapter</h6></div> */}
                                </div>
                                {/* <div className="main-container form-start container-fluid p-0">
<div className="row ">
<div className="tab-scroll-fixed">
<p>Exhibitor Registration</p>
</div>
</div>
<StepHeader />
</div> */}
                                <StepHeader />

                                <div className="page-height">
                                    <div className="main-container container-fluid pt-2 pb-2 p-3 second-form">

                                        <div className="asc" style={{ border: "1px solid #ddd" }}>
                                            <div
                                                className="card-header p-2 mb-2"
                                                style={{ padding: "9px!important" }}
                                            >
                                                <h3 className="card-title" style={{ fontSize: 14 }}>
                                                    Select Primary Chapter <span className="text-red" style={{ marginLeft: '5px', marginTop: '-0px', fontSize: '15px' }}>(Select at least one primary chapter)*</span>
                                                </h3>
                                                {/* {<span className='text-danger text-start text-left d-block mt-1' style={{ marginLeft: '10px' }}>{primaryChapterIdErr}</span>} */}
                                            </div>

                                            <div
                                                className=""
                                                style={{ paddingLeft: 10, paddingRight: 10 }}
                                            >

                                                {
                                                    primaryChapterListData.length > 0 && primaryChapterListData.map((data, i) => (
                                                        <>
                                                            {/* {data.ChapterName.trim() != 'ANY OTHER' && */}
                                                            <div className="form-row" key={i}>
                                                                <label key={i}>
                                                                    <input type="checkbox" key={data.ChapterID}
                                                                        name={i}
                                                                        // select= {data.IsSelect}
                                                                        checked={data.isChecked}
                                                                        // value={data.isChecked}
                                                                        onClick={e => this.handleClickSelectPrimaryChapter(data, data.ChapterID)}
                                                                    />
                                                                    {data.ChapterName}
                                                                </label>
                                                            </div>
                                                            {/* }  */}
                                                        </>
                                                    ))
                                                }

                                            </div>
                                            {primaryChapterListData.filter(item => item.isChecked).length > 1 && <>

                                                <div
                                                    className=""
                                                    style={{ paddingLeft: 10, paddingRight: 10, marginTop: 20 }}
                                                >
                                                    <div className="col-3 mb-2" style={{ marginBottom: '25px' }}>
                                                        <label>Please select Chapter for Hall preference <span style={{ color: 'red' }}>*</span></label>
                                                        <select
                                                            className="form-control"
                                                            id="roledb"
                                                            style={{ textAlign: "left" }}
                                                            value={this.state.selectedPrimaryChapterId}
                                                            disabled={this.state.selectedPrimaryChapterIdList.includes(1382)}
                                                            onChange={(e) => this.setState({
                                                                selectedPrimaryChapterId: e.target.value,
                                                                primaryChapterRadio: e.target.value,
                                                                defaultprimaryChapterIdErr: ''
                                                            })}
                                                        >
                                                            <option>Select</option>
                                                            {primaryChapterListData.length > 0 && primaryChapterListData.map((data) => (
                                                                data.IsSelect && <option key={data.ChapterID} value={data.ChapterID}
                                                                >{data.ChapterName}</option>
                                                            ))}
                                                        </select>
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{this.state.defaultprimaryChapterIdErr}</span>}
                                                    </div>
                                                    {MultiSelectNotes.length > 0 && <strong>Note<br /></strong>}
                                                    {
                                                        MultiSelectNotes.length > 0 && MultiSelectNotes.map((data, i) => (
                                                            <div className='mb-1'>
                                                                <strong>({i + 1})</strong>  {data.Description}
                                                                < br />
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                                <div style={{ textAlign: 'left', marginTop: '20px' }} className="col-md-12 ">

                                                    <label>Remark/Comment <span className="text-red" style={{ marginLeft: '5px', marginTop: '-0px', fontSize: '15px' }}>(please provide deatils as per the notes above in the comment box)*</span></label>
                                                    <textarea maxLength={500} value={this.state.ExhPrimaryChapterComment} className="form-control" onChange={(e) => this.setState({ ExhPrimaryChapterComment: e.target.value, ExhPrimaryChapterCommentErr: '' })}>
                                                    </textarea>
                                                    {
                                                        <span className="text-danger text-start text-left d-block mt-1">
                                                            {ExhPrimaryChapterCommentErr}
                                                        </span>
                                                    }
                                                </div>
                                                {/* <>
                                                    <div className="form-row"
                                                        style={{ paddingLeft: 10, paddingRight: 10, marginTop: 20 }}>
                                                        <h6 className='mb-3'><strong>Exhibitor Undertaking for {sessionStorage.getItem("sessionExhibitionName")}</strong></h6>
                                                        {this.state.undertakingNote.length>0&&this.state.undertakingNote.map((data) => (
                                                            <p className='m-1 p-0'>{data}</p>
                                                        ))}
                                                    </div>
                                                    <div className="form-row mt-2"
                                                        style={{ paddingLeft: 10, paddingRight: 10, marginTop: 20 }}
                                                    >
                                                        <div className="col-xl-4 mb-1">
                                                            <label htmlFor="validationCustom01">
                                                                Authorized Person Name<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                maxLength={100}
                                                                className="form-control"
                                                                value={this.state.ExhPrimaryUndertakingPersonName}
                                                                onChange={(e) =>
                                                                    this.setState({
                                                                        ExhPrimaryUndertakingPersonName: e.target.value,
                                                                        ExhPrimaryUndertakingPersonNameErr: "",
                                                                    })
                                                                }
                                                            />
                                                            {
                                                                <span className="text-danger text-start text-left d-block mt-1">
                                                                    {ExhPrimaryUndertakingPersonNameErr}
                                                                </span>
                                                            }
                                                        </div>
                                                        <div className="col-xl-4 mb-1">
                                                            <label htmlFor="validationCustom01">
                                                                Designation of the Authorized person<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                maxLength={100}
                                                                className="form-control"
                                                                value={this.state.ExhPrimaryUndertakingDesignation}
                                                                onChange={(e) =>
                                                                    this.setState({
                                                                        ExhPrimaryUndertakingDesignation: e.target.value,
                                                                        ExhPrimaryUndertakingDesignationErr: "",
                                                                    })
                                                                }
                                                            />
                                                            {
                                                                <span className="text-danger text-start text-left d-block mt-1">
                                                                    {ExhPrimaryUndertakingDesignationErr}
                                                                </span>
                                                            }
                                                        </div>
                                                        <div className="col-xl-4 mb-1">
                                                            <label htmlFor="validationCustom01">
                                                                Exhibitor company Name<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                maxLength={100}
                                                                className="form-control"
                                                                value={this.state.ExhPrimaryUndertakingCompanyName}
                                                                onChange={(e) =>
                                                                    this.setState({
                                                                        ExhPrimaryUndertakingCompanyName: e.target.value,
                                                                        ExhPrimaryUndertakingCompanyNameErr: "",
                                                                    })
                                                                }
                                                            />
                                                            {
                                                                <span className="text-danger text-start text-left d-block mt-1">
                                                                    {ExhPrimaryUndertakingCompanyNameErr}
                                                                </span>
                                                            }
                                                        </div>
                                                        <div className="col-xl-4 mb-1">
                                                            <label htmlFor="validationCustom01">
                                                                Email of the Authorized person<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                maxLength={100}
                                                                className="form-control"
                                                                value={this.state.ExhPrimaryUndertakingEmail}
                                                                onChange={(e) =>
                                                                    this.setState({
                                                                        ExhPrimaryUndertakingEmail: e.target.value,
                                                                        ExhPrimaryUndertakingEmailErr: "",
                                                                    })
                                                                }
                                                            />
                                                            {
                                                                <span className="text-danger text-start text-left d-block mt-1">
                                                                    {ExhPrimaryUndertakingEmailErr}
                                                                </span>
                                                            }
                                                        </div>
                                                        <div className="col-xl-4 mb-1">
                                                            <div
                                                                // className="col-xl-3 mb-1"
                                                                style={{ position: "relative" }}
                                                            >
                                                                <label htmlFor="validationCustom01">
                                                                    Mobile No. of the Authorized person<span className="text-red">*</span>
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    maxLength={
                                                                        sessionStorage.getItem("countryId") === "43"
                                                                            ? 11
                                                                            : 10
                                                                    }
                                                                    value={this.state.ExhPrimaryUndertakingMobileNo}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            ExhPrimaryUndertakingMobileNo: e.target.value,
                                                                            ExhPrimaryUndertakingMobileNoErr: "",
                                                                        })
                                                                    }
                                                                    onInput={(e) => sessionStorage.getItem("countryId") == 91 ? this.maxLengthCheck(e, 10) : null}
                                                                    size={"10"}
                                                                    onKeyDown={(e) =>
                                                                        (e.keyCode === 69 || e.keyCode === 190) &&
                                                                        e.preventDefault()
                                                                    }
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onKeyPress={(e) => this.preventMinus(e)}
                                                                    style={{ paddingLeft: "50px" }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control-1"
                                                                    placeholder="ISD"
                                                                    value={this.state.PreExhPrimaryUndertakingMobileNo}
                                                                    // disabled={isCorrespondenceDetails}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            PreExhPrimaryUndertakingMobileNo:
                                                                                e.target.value,
                                                                        })
                                                                    }
                                                                    // placeholder={+91}
                                                                    style={{
                                                                        width: "45px",
                                                                        position: "absolute",
                                                                        top: "25px",
                                                                        paddingLeft: "5px",
                                                                    }}
                                                                />
                                                                {
                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                        {ExhPrimaryUndertakingMobileNoErr}
                                                                    </span>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <hr></hr>
                                                </> */}
                                            </>}
                                        </div>
                                        <div className="row ">
                                            <div className="col-lg-12 col-md-12 mt-4">
                                                <div className="asc" style={{ border: "1px solid #ddd" }}>
                                                    <div
                                                        className="card-header p-2 mb-2"
                                                        style={{ padding: "9px!important" }}
                                                    >
                                                        <h3 className="card-title" style={{ fontSize: 14 }}>
                                                            Select Below Product <span className="text-red" style={{ marginLeft: '5px', marginTop: '-0px', fontSize: '15px' }}>{this.state.isOpenAgree ? '(In case of selecting multiple segments kindly select at least one sub chapter below for each main segment selected)*' : '(Select at least one product from the below highlighted sub-chapters)*'}</span>
                                                        </h3>
                                                    </div>
                                                    <div className="" style={{ paddingLeft: 10 }}>
                                                        <form className="needs-validation pb-2" noValidate="">
                                                            <div className="form-row">

                                                                <div class="accordion" id="accordionExample">
                                                                    {
                                                                        level2.length > 0 && level2.map(level2Data => (
                                                                            <>
                                                                                {
                                                                                    // level2Data.ParentChapterID == primaryChapterRadio &&
                                                                                    <div class="accordion-item">
                                                                                        <h2 class="accordion-header" id={'heading_l1_' + level2Data.ChapterID}>
                                                                                            <button class={level2Data.isHighlight ? "accordion-button collapsed selected-chapter" : "accordion-button collapsed"}
                                                                                                type="button" data-bs-toggle="collapse"
                                                                                                data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                                                                                aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                                                                                {/* // checkbox for level2 */}
                                                                                                {
                                                                                                    level2Data.IsCheckbox &&
                                                                                                    <input type="checkbox" className="from-left-sp" name="" key={level2Data.ChapterID}
                                                                                                        checked={level2Data.IsSelect}
                                                                                                        onClick={e => this.onCheckLevel2(e, level2Data.ChapterID)} />
                                                                                                }
                                                                                                {level2Data.ChapterName} </button>
                                                                                        </h2>
                                                                                        {this.record(level2Data, level3, level4)}
                                                                                    </div>
                                                                                }

                                                                            </>
                                                                        ))
                                                                    }
                                                                </div>

                                                                <div className="card card-cus card-cus-2 mt-2 mb-2 cus-width">
                                                                    <div
                                                                        className="card-header cus-hed"

                                                                    >
                                                                        <strong>Scheme Type <span className="text-red">*</span></strong>
                                                                    </div>
                                                                    <div className="form-row mt-1 p-2">

                                                                        {
                                                                            schemeTypeList.length > 0 && schemeTypeList.map((schemeTypeListData) => (
                                                                                <div className="col-xl-2">
                                                                                    <label>
                                                                                        <input type="radio"
                                                                                            id={'schemeType'}
                                                                                            name={'schemeType'}
                                                                                            radioGroup={schemeType == schemeTypeListData.Code && true}
                                                                                            select={schemeType == schemeTypeListData.Code && true}
                                                                                            checked={schemeType == schemeTypeListData.Code && true}
                                                                                            value={schemeType}
                                                                                            onChange={e => this.onSchemeTypeChange(e, schemeTypeListData.Code)}
                                                                                        />
                                                                                        {schemeTypeListData.Description}
                                                                                    </label>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                        {<span className='text-danger '>{schemeTypeErr}</span>}

                                                                    </div>
                                                                    <div
                                                                        className="card-header cus-hed"
                                                                        style={{

                                                                            borderTop: "1px solid #eee"
                                                                        }}
                                                                    >
                                                                        <strong>Stall Area <span className="text-red">*</span></strong>
                                                                    </div>
                                                                    <div className="form-row mt-1 p-2">
                                                                        <div className="col-xl-3">
                                                                            <label>Length * width in Meters</label>
                                                                            <select
                                                                                className="form-control select2 select-hidden-accessible pl-0"
                                                                                id="roledb"
                                                                                value={stallAreaId}
                                                                                onChange={e => this.onLengthTypeChange(e)}
                                                                            >
                                                                                <option value="">Select</option>
                                                                                {
                                                                                    stallAreaList.length > 0 && stallAreaList.map(stallAreaData => (
                                                                                        <option value={stallAreaData.Code} key={stallAreaData.Code}>{stallAreaData.Description}</option>
                                                                                    ))
                                                                                }


                                                                            </select>
                                                                            {<span className='text-danger text-start text-left d-block mt-1'>{stallAreaIdErr}</span>}
                                                                        </div>
                                                                        {stallAreaId != '' && stallAreaId != 'Select' &&
                                                                            <div className="">
                                                                                <label className='mt-4'></label>
                                                                                <span>{this.state.area} sqm.</span>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div
                                                                        className="card-header  cus-hed mt-2"
                                                                        style={{

                                                                            borderTop: "1px solid #eee",
                                                                            position: "relative"
                                                                        }}
                                                                    >
                                                                        <strong>
                                                                            Open Sides (Please Tick the no required) <span className="text-red">*</span>
                                                                        </strong>
                                                                        {this.state.isChargesforOpenSides && <p>
                                                                            <a
                                                                                // href={`files/${sessionStorage.getItem("sessionExhibitionID")}/Open-side-Charges.pdf`}
                                                                                href={url + OpenSidePath}
                                                                                target="_blank"
                                                                                rel="noreferrer"><span class="tool" style={{ color: '#0056ff' }}>Please Refer Rule </span>
                                                                            </a></p>}
                                                                    </div>
                                                                    <div className="form-row mt-1 p-2">
                                                                        {this.state.openSideList.length > 0 && this.state.openSideList.map(item => (
                                                                            <>
                                                                                {item.OpenSidesID == 4 ? this.state.area >= this.state.minAreafor4OpenSide ? <div className="col-xl-2">
                                                                                    <label>
                                                                                        <input type="radio" name="openSlides" value={openSlides}
                                                                                            checked={openSlides == item.OpenSidesID}
                                                                                            onClick={e => this.setState({ openSlides: item.OpenSidesID, openSlidesErr: '' })} /> {
                                                                                            item.OpenSideName
                                                                                        }
                                                                                    </label>
                                                                                </div> : '' : <div className="col-xl-2">
                                                                                    <label>
                                                                                        <input type="radio" name="openSlides" value={openSlides}
                                                                                            checked={openSlides == item.OpenSidesID}
                                                                                            onClick={e => this.setState({ openSlides: item.OpenSidesID, openSlidesErr: '' })} /> {
                                                                                            item.OpenSideName
                                                                                        }
                                                                                    </label>
                                                                                </div>}
                                                                            </>
                                                                        ))}
                                                                        {/* <div className="col-xl-2">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '1'}
                                                                                    onClick={e => this.setState({ openSlides: '1', openSlidesErr: '' })} /> 1 Open Side
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-xl-2">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '2'}
                                                                                    onClick={e => this.setState({ openSlides: '2', openSlidesErr: '' })}
                                                                                /> 2 Open Side
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-xl-2 mb-3">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '3'}
                                                                                    onClick={e => this.setState({ openSlides: '3', openSlidesErr: '' })} /> 3 Open Side
                                                                            </label>
                                                                        </div> */}
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{openSlidesErr}</span>}

                                                                    </div>
                                                                    {schemeType != 2 && this.state.isDoubleStoreyExhibition && <>
                                                                        <div
                                                                            className="card-header  cus-hed mt-2"
                                                                            style={{

                                                                                borderTop: "1px solid #eee",
                                                                                position: "relative"
                                                                            }}
                                                                        >
                                                                            <div className="d-flex">
                                                                                <input
                                                                                    className="toggle-box mt-1"
                                                                                    id="identifier-2"
                                                                                    type="checkbox"
                                                                                    style={{ float: "left" }}
                                                                                    checked={this.state.isDoubleStorey}
                                                                                    onClick={(e) => this.onCheckdoubleStorey(e)}
                                                                                />
                                                                                <div >
                                                                                    <label htmlFor="identifier-2" style={{ fontSize: 16 }}>
                                                                                        <strong> Double storey </strong>

                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            {this.state.isDoubleStorey &&
                                                                                <p><a
                                                                                    // href={`files/${sessionStorage.getItem("sessionExhibitionID")}/Double-Storey-Charges.pdf`}
                                                                                    href={url + DoubleStoreyPath}
                                                                                    target="_blank"
                                                                                    rel="noreferrer"><span class="tool" style={{ color: '#0056ff' }}>Please Refer Rule</span></a> </p>}
                                                                        </div>
                                                                        {this.state.isDoubleStorey &&
                                                                            <div className="form-row mt-1 p-2">
                                                                                <div className="col-xl-3">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        // disabled={!this.state.isDoubleStorey}
                                                                                        // maxLength={'10'}
                                                                                        // disabled
                                                                                        value={this.state.doubleStoreyArea}
                                                                                        // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                        onChange={e => this.onChangeDoubleStorey(e)}
                                                                                    />
                                                                                </div>
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.doubleStoreyAreaErr}</span>}

                                                                            </div>}
                                                                    </>}
                                                                    {/* this.state.isSSIExhibition */}
                                                                    {sessionStorage.getItem("countryId") == 91 && !isShowInternationalArea &&
                                                                        this.state.isSSIExhibition && <>  <div
                                                                            className="card-header  cus-hed mt-2"
                                                                            // style={{ }}
                                                                            style={{
                                                                                justifyContent: 'left',
                                                                                fontSize: 16,
                                                                                borderTop: "1px solid #eee",
                                                                                position: "relative"
                                                                            }}
                                                                        >
                                                                            <input
                                                                                className="toggle-box mt-1"
                                                                                id="identifier-2"
                                                                                type="checkbox"
                                                                                style={{ float: "left" }}
                                                                                checked={this.state.isSSIandTMMAITAMMMA}
                                                                                onClick={(e) => this.onSSITMMAITAMMAClick()}
                                                                            />
                                                                            <strong >
                                                                                {/* SSI certificate and membership certificate of TMMA/ITAMMA */}
                                                                                Registration of Small Scale Industrial Units (SSI) certificate and membership certificate of TMMA/ITAMMA
                                                                            </strong>
                                                                        </div>
                                                                            {this.state.isSSIandTMMAITAMMMA &&

                                                                                <div>

                                                                                    <div
                                                                                        className="card-header  cus-hed mt-2"
                                                                                        style={{

                                                                                            borderTop: "1px solid #eee",
                                                                                            position: "relative"
                                                                                        }}
                                                                                    >
                                                                                        <div className="col-xl-6">
                                                                                            <div className="d-flex">
                                                                                                <input
                                                                                                    className="toggle-box mt-1"
                                                                                                    id="identifier-2"
                                                                                                    type="checkbox"
                                                                                                    style={{ float: "left" }}
                                                                                                    checked={this.state.isSSi}
                                                                                                    onClick={(e) => this.onSSITMMAITAMMAClick()}
                                                                                                />
                                                                                                <div >
                                                                                                    <label htmlFor="identifier-2" style={{ fontSize: 16 }}>
                                                                                                        SSI certificate?

                                                                                                    </label>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="col-m-3">
                                                                                            {this.state.isSSIdeleted == false ?
                                                                                                <div style={{
                                                                                                    border: '1px solid #ccc',
                                                                                                    padding: '10px',
                                                                                                    display: 'inline-flex',
                                                                                                    alignItems: 'center',
                                                                                                    // marginTop: '10px'
                                                                                                }}>
                                                                                                    {console.log(this.state.isSSifile)}
                                                                                                    <a
                                                                                                        href={this.state.isSSifilePath}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                    >
                                                                                                        <span style={{ marginRight: '10px' }}
                                                                                                        >{this.state.isSSifile}</span>
                                                                                                    </a>
                                                                                                    <i className={`fa fa-times text-danger img-can`}
                                                                                                        onClick={(e) => this.onSSIDocDelete()}
                                                                                                    ></i>
                                                                                                </div> :
                                                                                                <div className="upload-options mt-1">
                                                                                                    <label>
                                                                                                        <input
                                                                                                            type="file"
                                                                                                            id="path"
                                                                                                            className="image-upload"
                                                                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                                                                            onChange={e => this.onFilePickSSI(e, e.target.files)}
                                                                                                        />
                                                                                                        <span className="text-danger" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                                                                                                            Max 5MB | Pdf,Jpeg,Jpg,Png only
                                                                                                        </span>
                                                                                                        {
                                                                                                            this.state.isSSifile != "" && this.state.isSSifile != null &&
                                                                                                            <i class="fa fa-times text-danger img-can"
                                                                                                                onClick={() => this.onCrossClickSSI()}
                                                                                                            ></i>
                                                                                                        }
                                                                                                    </label>
                                                                                                    <span className='text-danger ' style={{ marginLeft: '7px' }}> File size up to 5MB (.pdf , .jpeg, .png,) </span>
                                                                                                </div>}
                                                                                        </div>
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{this.state.isSSifileErr}</span>}

                                                                                    </div>
                                                                                    <div
                                                                                        className="card-header  cus-hed mt-2"
                                                                                        style={{

                                                                                            borderTop: "1px solid #eee",
                                                                                            position: "relative"
                                                                                        }}
                                                                                    >
                                                                                        <div className="col-xl-3">
                                                                                            <label>
                                                                                                <input type="radio" name="ITMATTAMA"
                                                                                                    value={this.state.TMMAITAMMA}
                                                                                                    checked={this.state.TMMAITAMMA == '1'}
                                                                                                    onClick={e => this.setState({ TMMAITAMMA: '1', })}
                                                                                                /> Membership certificate of TMMA
                                                                                            </label>

                                                                                        </div>
                                                                                        <div className="col-xl-3">
                                                                                            <label>
                                                                                                <input type="radio" name="ITMATTAMA"
                                                                                                    value={this.state.TMMAITAMMA}
                                                                                                    checked={this.state.TMMAITAMMA == '2'}
                                                                                                    onClick={e => this.setState({ TMMAITAMMA: '2', })}
                                                                                                /> Membership certificate of ITAMMA
                                                                                            </label>
                                                                                        </div>

                                                                                        <div className="upload-options mt-1">
                                                                                            {this.state.isTMMAITAMMAdeleted == false ?
                                                                                                <div style={{
                                                                                                    border: '1px solid #ccc',
                                                                                                    padding: '10px',
                                                                                                    display: 'inline-flex',
                                                                                                    alignItems: 'center',
                                                                                                    // marginTop: '10px'
                                                                                                }}>
                                                                                                    <a
                                                                                                        href={this.state.TMMAITAMMAfilePath}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                    >
                                                                                                        <span style={{ marginRight: '10px' }}
                                                                                                        >{this.state.TMMAITAMMAfile}</span>
                                                                                                    </a>
                                                                                                    <i className={`fa fa-times text-danger img-can`}
                                                                                                        onClick={(e) => this.onTMMAITAMMADocDelete()}
                                                                                                    ></i>
                                                                                                </div> : <>
                                                                                                    <label>
                                                                                                        <input
                                                                                                            type="file"
                                                                                                            id="path"
                                                                                                            className="image-upload"
                                                                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                                                                            onChange={e => this.onFilePickITMATAMMA(e, e.target.files)}
                                                                                                        // disabled={isView}
                                                                                                        />
                                                                                                        <span className="text-danger" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                                                                                                            Max 5MB | Pdf,Jpeg,Jpg,Png only
                                                                                                        </span>
                                                                                                        {
                                                                                                            this.state.TMMAITAMMAfile != "" && this.state.TMMAITAMMAfile != null &&
                                                                                                            <i class="fa fa-times text-danger img-can"
                                                                                                                onClick={() => this.onCrossClickITMATAMMA()}
                                                                                                            ></i>
                                                                                                        }
                                                                                                    </label>
                                                                                                    <span className='text-danger ' style={{ marginLeft: '7px' }}> File size up to 5MB (.pdf , .jpeg, .png,) </span>
                                                                                                </>
                                                                                            }
                                                                                        </div>
                                                                                        {/* </div> */}


                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{this.state.TMMAITAMMAfileErr}</span>}

                                                                                    </div>
                                                                                </div>}
                                                                        </>}
                                                                </div>
                                                                <br></br>
                                                                <div className="mt-2 ms-2" style={{ textAlign: 'left', fontSize: 'medium' }}>
                                                                    <span className="text-left" ><strong>Note: If your Floor Loading Requirement, Machine Weight, water, power, and compressed air requirements are not yet finalized, please enter “0” to proceed with the form.</strong>
                                                                    </span><br></br>
                                                                    <span><strong>(Kindly ensure that all mandatory utility details for your booth are completed in this form on or before 30th September 2026.)</strong>
                                                                    </span>
                                                                </div>
                                                                <br></br>
                                                                <div
                                                                    className="form-row col-md-12 mt-2" style={{ marginTop: '10px' }}>
                                                                    <div className="table-responsive m-2">
                                                                        <h6 style={{ float: 'left' }}>Exhibit Details</h6>{<span className='text-danger ml-2' style={{ float: 'left' }}>{lengthWidthErr}</span>}
                                                                        <button className="btn btn-aqua mb-2" style={{ float: 'right' }} onClick={e => this.onAddManualChapter(e)}>
                                                                            Add Exhibit
                                                                        </button>< br />
                                                                        <table
                                                                            className="table border table-bordered"
                                                                            style={{
                                                                                border: "1px solid #d8d8d8 !important"
                                                                            }}
                                                                        >
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Product</th>
                                                                                    <th>Manufacturer Name<span className="text-red">*</span></th>
                                                                                    <th>Manufacturing Country<span className="text-red">*</span></th>
                                                                                    <th style={{ paddingLeft: '40px', paddingRight: '40px' }}>Company Email{<span className="text-red">*</span>}</th>
                                                                                    <th>Registered  Headquarters Address{<span className="text-red">*</span>}</th>
                                                                                    <th>Machine/Brochure/Accessories<span className="text-red">*</span></th>
                                                                                    <th>Machine Details</th>
                                                                                    <th>HSN Code</th>
                                                                                    <th colspan="4">Machine Dimension (mtr)</th>
                                                                                    <th>Calculated Area</th>
                                                                                    <th>Scheme Type</th>
                                                                                    {/* <th>Length</th>
                                                                                    <th>Breadth</th>
                                                                                    <th>Height</th> */}
                                                                                    <th>Floor Loading Requirement (Kgs per sq mtr)</th>
                                                                                    <th>Machine Weight (Kg)</th>
                                                                                    <th colspan="2" classname="text-center" style={{ textAlign: 'center' }}>Power Requirement<span className="text-red">*</span> &nbsp;&nbsp;<i title='View Power Requirement Rates' class="bi bi-info-circle" onClick={() => this.setState({ isOpenUtility: true, UtilityName: 'Power' })}></i><br></br>
                                                                                    </th>
                                                                                    <th colspan="3" classname="text-center" style={{ textAlign: 'center' }}>Water Requirement<span className="text-red">*</span> &nbsp;&nbsp;<i title='View Water Requirement Rates' class="bi bi-info-circle" onClick={() => this.setState({ isOpenUtility: true, UtilityName: 'Water' })}></i><br></br>
                                                                                        {/* <span style={{ fontSize: 'smaller' }} className='text-danger'>(Please review the utility rates in the Manual Form)</span> */}
                                                                                    </th>
                                                                                    <th colspan="3" classname="text-center" style={{ textAlign: 'center' }}>Air Requirement<span className="text-red">*</span> &nbsp;&nbsp;<i title='View Air Requirement Rates' class="bi bi-info-circle" onClick={() => this.setState({ isOpenUtility: true, UtilityName: 'Air' })}></i><br></br>
                                                                                    </th>
                                                                                    <th>Upload Certificate of Origin{showMandatoryMark && <span className="text-red">*</span>}</th>
                                                                                    <th></th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td className="tbody-th-head">Length{showMandatoryMark && <span className="text-red">*</span>}</td>
                                                                                    <td className="tbody-th-head">Breadth{showMandatoryMark && <span className="text-red">*</span>}</td>
                                                                                    <td className="tbody-th-head" style={{ padding: '5px 30px' }}>Area{showMandatoryMark && <span className="text-red">*</span>}</td>
                                                                                    <td className="tbody-th-head">Height{showMandatoryMark && <span className="text-red">*</span>}</td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td className="tbody-th-head">Single Phase(K.W.)<span className="text-red">*</span></td>
                                                                                    <td className="tbody-th-head">Three Phase(K.W.)<span className="text-red">*</span></td>
                                                                                    <td className="tbody-th-head">Consumption of water(liters /Hr)<span className="text-red">*</span></td>
                                                                                    <td className="tbody-th-head">Inlet connection<span className="text-red">*</span></td>
                                                                                    <td className="tbody-th-head">Outlet connection<span className="text-red">*</span></td>
                                                                                    <td className="tbody-th-head">Bar Quantity<span className="text-red">*</span></td>
                                                                                    <td className="tbody-th-head">CFM Quantity<span className="text-red">*</span></td>
                                                                                    <td className="tbody-th-head">Max Compressed Air connection<span className="text-red">*</span></td>
                                                                                    <td className="tbody-th-head"></td>
                                                                                    <td></td>
                                                                                    {/* <td></td> */}
                                                                                </tr>
                                                                                {
                                                                                    exhibitDetailsList.length > 0 ? exhibitDetailsList.map((data, index) => (
                                                                                        <tr>
                                                                                            {data.ChapterID != 0 ? (
                                                                                                <td>{data.ChapterName}</td>
                                                                                            ) : (
                                                                                                <td><input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    // maxLength={'10'}
                                                                                                    value={data.ChapterName}
                                                                                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onEnterProductName(e, index)}
                                                                                                /></td>
                                                                                            )}
                                                                                            <td>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'200'}
                                                                                                    value={data.ManufacturerName}
                                                                                                    onBlur={e => this.checksameMFandCountry()}
                                                                                                    style={{ border: data.errArr.includes('ManufacturerName') && '2px solid red' }}
                                                                                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => {
                                                                                                        this.onManufacturerNameChange(e, data.ChapterID, index);
                                                                                                        // setTimeout(() => {

                                                                                                        // }, 500);
                                                                                                    }
                                                                                                    }
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                {/* <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'100'}
                                                                                                    value={data.ManufacturingCountry}
                                                                                                    onChange={e => this.onManufacturingCountryChange(e, data.ChapterID, index)}
                                                                                                /> */}
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    required=""
                                                                                                    value={data.ManufacturingCountry}
                                                                                                    style={{ border: data.errArr.includes('ManufacturingCountry') && '2px solid red' }}
                                                                                                    onBlur={(e) => this.onCountryBlur(e.target.value, index)}
                                                                                                    onChange={e => {
                                                                                                        this.onManufacturingCountryChange(e, data.ChapterID, index);
                                                                                                        setTimeout(() => {

                                                                                                        }, 500);
                                                                                                    }}
                                                                                                // onChange={(e) => this.onManufacturingCountryChange(e, data.ChapterID, index)}
                                                                                                />
                                                                                                {/* {console.log("this.state.tempCountryList--->", this.state.tempCountryList)} */}
                                                                                                {this.state.isDisplayCountryList && this.state.manufactureCountryIndex == index && this.renderCountryList()}
                                                                                            </td>
                                                                                            <td>
                                                                                                {/* <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'100'}
                                                                                                    value={data.ManufacturingCountry}
                                                                                                    onChange={e => this.onManufacturingCountryChange(e, data.ChapterID, index)}
                                                                                                /> */}
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    required=""
                                                                                                    style={{ border: data.errArr.includes('CompanyEmail') && '2px solid red' }}
                                                                                                    value={data.CompanyEmail}
                                                                                                    onBlur={(e) => {
                                                                                                        if (e.target.value != '' && emailValidator(e.target.value) != '') {
                                                                                                            if (!data.errArr.includes('CompanyEmail')) {
                                                                                                                data.errArr.push('CompanyEmail')
                                                                                                                this.setState({ exhibitDetailsList: exhibitDetailsList })
                                                                                                            }
                                                                                                            toastError("Please Enter proper Email")
                                                                                                        }
                                                                                                    }}
                                                                                                    onChange={(e) => this.onEnterCompanyEmail(e, data.ChapterID, index)}
                                                                                                />
                                                                                                {/* {console.log("this.state.tempCountryList--->", this.state.tempCountryList)} */}
                                                                                            </td>
                                                                                            <td>
                                                                                                {/* <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'100'}
                                                                                                    value={data.ManufacturingCountry}
                                                                                                    onChange={e => this.onManufacturingCountryChange(e, data.ChapterID, index)}
                                                                                                /> */}
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    required=""
                                                                                                    value={data.registrationHQaddress}
                                                                                                    style={{ border: data.errArr.includes('registrationHQaddress') && '2px solid red' }}
                                                                                                    // onBlur={(e) => this.onCountryBlur(e.target.value, index)}
                                                                                                    onChange={(e) => this.onEnterHQaddress(e, data.ChapterID, index)}
                                                                                                />
                                                                                                {/* {console.log("this.state.tempCountryList--->", this.state.tempCountryList)} */}
                                                                                            </td>
                                                                                            <td style={{ minWidth: '11rem', background: data.errArr.includes('isAllMB') && '#ff00002b' }}>
                                                                                                <div>
                                                                                                    <input
                                                                                                        className="toggle-box mt-1"
                                                                                                        id="identifier-2"
                                                                                                        type="checkbox"
                                                                                                        style={{ float: "left" }}
                                                                                                        checked={data.isMachine}
                                                                                                        onClick={(e) => this.onMBclick(0, data.ChapterID, index)}
                                                                                                    />
                                                                                                    Machine
                                                                                                </div>
                                                                                                <div>
                                                                                                    <input
                                                                                                        className="toggle-box mt-1"
                                                                                                        id="identifier-2"
                                                                                                        type="checkbox"
                                                                                                        style={{ float: "left" }}
                                                                                                        checked={data.IsAccessory}
                                                                                                        onClick={(e) => this.onMBclick(2, data.ChapterID, index)}
                                                                                                    />
                                                                                                    Accessories/Product
                                                                                                </div>
                                                                                                <div>
                                                                                                    <input
                                                                                                        className="toggle-box mt-1"
                                                                                                        id="identifier-2"
                                                                                                        type="checkbox"
                                                                                                        style={{ float: "left" }}
                                                                                                        checked={data.isBrochure}
                                                                                                        onClick={(e) => this.onMBclick(1, data.ChapterID, index)}
                                                                                                    />
                                                                                                    Only Brochure
                                                                                                </div>
                                                                                            </td>

                                                                                            <td>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'200'}
                                                                                                    value={data.MachineDetails}

                                                                                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onMachineDetailsChange(e, data.ChapterID, index)}
                                                                                                />
                                                                                            </td>

                                                                                            <td>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'10'}
                                                                                                    value={data.HSNCode}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onEnterHSNCode(e, data.ChapterID, index)}
                                                                                                />
                                                                                            </td>

                                                                                            <td style={{ width: '', position: 'relative' }}>
                                                                                                {data.isMachine && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>}
                                                                                                {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'9'}
                                                                                                    value={0}
                                                                                                    disabled={true}
                                                                                                // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                                /> : <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'9'}
                                                                                                    value={data.Length}
                                                                                                    style={{ border: data.errArr.includes('Length') && '2px solid red' }}
                                                                                                    disabled={!data.isBrochure && !data.isMachine && !data.IsAccessory ? false : !data.isMachine}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                                />}
                                                                                                {/* <select
                                                                                                    className="form-control select-hidden-accessible"
                                                                                                    id="roledb"
                                                                                                    value={data.Length}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                                >
                                                                                                    <option value="0">Select</option>
                                                                                                    {lengthList.length > 0 && lengthList.map((item) => (
                                                                                                        <option value={item.Code}>{item.Description}</option>
                                                                                                    ))}
                                                                                                </select> */}
                                                                                            </td>
                                                                                            <td style={{ width: '', position: 'relative' }}>
                                                                                                {data.isMachine && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>}
                                                                                                {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'9'}
                                                                                                    value={0}
                                                                                                    disabled={true}
                                                                                                // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                                /> : <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'9'}
                                                                                                    value={data.Breadth}
                                                                                                    style={{ border: data.errArr.includes('Breadth') && '2px solid red' }}
                                                                                                    disabled={!data.isBrochure && !data.isMachine && !data.IsAccessory ? false : !data.isMachine}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onBreadthChange(e, data.ChapterID, index)}
                                                                                                />}
                                                                                                {/* <select
                                                                                                    className="form-control select-hidden-accessible"
                                                                                                    id="roledb"
                                                                                                    value={data.Breadth}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onBreadthChange(e, data.ChapterID, index)}
                                                                                                >
                                                                                                    <option value="0">Select</option>
                                                                                                    {breadthList.length > 0 && breadthList.map((item) => (
                                                                                                        <option value={item.Code}>{item.Description}</option>
                                                                                                    ))}
                                                                                                </select> */}
                                                                                            </td>
                                                                                            <td style={{ width: '', position: 'relative' }}>
                                                                                                {data.isMachine && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>}
                                                                                                {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'9'}
                                                                                                    value={0}
                                                                                                    disabled={true}
                                                                                                // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                                /> : <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    value={data.Area}
                                                                                                    disabled
                                                                                                />}
                                                                                            </td>
                                                                                            <td style={{ width: '', position: 'relative' }}>
                                                                                                {data.isMachine && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>}
                                                                                                {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'9'}
                                                                                                    value={0}
                                                                                                    disabled={true}
                                                                                                // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                                /> : <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'9'}
                                                                                                    value={data.Height}
                                                                                                    style={{ border: data.errArr.includes('Height') && '2px solid red' }}
                                                                                                    disabled={!data.isBrochure && !data.isMachine && !data.IsAccessory ? false : !data.isMachine}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onHeightChange(e, data.ChapterID, index)}
                                                                                                />}
                                                                                            </td>

                                                                                            <td>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control text-center"
                                                                                                    maxLength={'10'}
                                                                                                    disabled
                                                                                                    value={data.CalculatedArea != 0 && data.CalculatedArea != null ? data.CalculatedArea : ''}
                                                                                                // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                // onChange={e => this.onEnterHSNCode(e, data.ChapterID, index)}
                                                                                                />
                                                                                            </td>

                                                                                            <td>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    disabled
                                                                                                    className="form-control text-center"
                                                                                                    maxLength={'10'}
                                                                                                    value={data.ShellScheme == 2 ? 'Shell' : data.ShellScheme == 1 ? 'Bare' : ''}
                                                                                                // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                // onChange={e => this.onEnterHSNCode(e, data.ChapterID, index)}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'9'}
                                                                                                    value={0}
                                                                                                    disabled={true}
                                                                                                // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                                /> : <input
                                                                                                    type="text"
                                                                                                    title=' Note :
                                                                                                    1- Very heavy-duty equipment and machinery are not allowed into the Hall and shall be allocated in the external exhibition space.
                                                                                                    2- If any exhibitor wants to show live machinery, please contact the organizer for special arrangements.'
                                                                                                    className="form-control"
                                                                                                    maxLength={'9'}
                                                                                                    value={data.FloorCapacity}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onFloorCapacityChange(e, data.ChapterID, index)}
                                                                                                />}
                                                                                            </td>
                                                                                            <td>
                                                                                                {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    maxLength={'9'}
                                                                                                    value={0}
                                                                                                    disabled={true}
                                                                                                // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                                /> : <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    maxLength={'9'}
                                                                                                    value={data.MachineWeight}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onMachineWeightChange(e, data.ChapterID, index)}
                                                                                                />}
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    maxLength={'10'}
                                                                                                    style={{ border: data.errArr.includes('SinglePhasePower') && '2px solid red' }}
                                                                                                    value={data.SinglePhasePower}
                                                                                                    onInput={e => {

                                                                                                        if ((e.target.value > 3 || e.target.value < 0) && e.target.value != '') {
                                                                                                            toastError("Maximum 3 quantities allowed for single phase. Apply for three phase for more")
                                                                                                        };
                                                                                                        (e.target.value > 3 || e.target.value < 0) && e.target.value != '' ? e.target.value = '' : e.target.value = e.target.value;
                                                                                                    }} onChange={e => this.onEntersinglePhase(e, data.ChapterID, index)}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    maxLength={'10'}
                                                                                                    style={{ border: data.errArr.includes('ThreePhasePower') && '2px solid red' }}
                                                                                                    value={data.ThreePhasePower}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onEnterThreePhase(e, data.ChapterID, index)}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    maxLength={'10'}
                                                                                                    style={{ border: data.errArr.includes('WaterConsumption') && '2px solid red' }}
                                                                                                    value={data.WaterConsumption}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onEnterWaterConsumption(e, data.ChapterID, index)}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    style={{ border: data.errArr.includes('InletQuantity') && '2px solid red' }}
                                                                                                    maxLength={'10'}
                                                                                                    value={data.InletQuantity}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onEnterInletQuantity(e, data.ChapterID, index)}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    maxLength={'10'}
                                                                                                    style={{ border: data.errArr.includes('OutletQuantity') && '2px solid red' }}
                                                                                                    value={data.OutletQuantity}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onEnterOutletQuantity(e, data.ChapterID, index)}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <select
                                                                                                    className="form-control select2 select-hidden-accessible pl-0"
                                                                                                    // id="roledb"
                                                                                                    value={data.BarQuantity}
                                                                                                    onChange={e => this.onEnterBar(e, data.ChapterID, index)}
                                                                                                >
                                                                                                    <option value="0">NA</option>
                                                                                                    {
                                                                                                        this.state.barQuantityList.length > 0 && this.state.barQuantityList.map(item => (
                                                                                                            <option value={item.BarQuantity} key={item.BarQuantity}>{item.BarQuantity}</option>
                                                                                                        ))
                                                                                                    }


                                                                                                </select>
                                                                                            </td>
                                                                                            <td>
                                                                                                <select
                                                                                                    className="form-control select2 select-hidden-accessible pl-0"
                                                                                                    // id="roledb"
                                                                                                    value={data.CFMQuantity}
                                                                                                    onFocus={() => data.BarQuantity != null && data.BarQuantity != '' ? this.getFillList(CFMActionId, "", data.BarQuantity <= 6 ? 13 : data.BarQuantity === 7 ? 14 : 17, "", data.BarQuantity) : null}
                                                                                                    onChange={e => this.onEnterCFM(e, data.ChapterID, index)}
                                                                                                >
                                                                                                    <option value='0'>NA</option>
                                                                                                    {
                                                                                                        this.state.CFMQuantityList.length > 0 && this.state.CFMQuantityList.map(item => (
                                                                                                            <option value={item.CFMID} key={item.CFMID}>{item.CFM}</option>
                                                                                                        ))
                                                                                                    }


                                                                                                </select>
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    maxLength={'10'}
                                                                                                    style={{ border: data.errArr.includes('MaxCompressedAir') && '2px solid red' }}
                                                                                                    value={data.MaxCompressedAir}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onEnterMaxCompressed(e, data.ChapterID, index)}
                                                                                                />
                                                                                            </td>
                                                                                            <td style={{ width: '', position: 'relative' }}>
                                                                                                {/* {(data.isMachine || data.IsAccessory) && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>} */}
                                                                                                {(data.isMachine || data.IsAccessory) ? data.DocDeleted == false || data.DocumentName != '' ? <div style={{
                                                                                                    border: '1px solid #ccc',
                                                                                                    padding: '10px',
                                                                                                    display: 'inline-flex',
                                                                                                    alignItems: 'center',
                                                                                                    // marginTop: '10px'
                                                                                                }}>
                                                                                                    {/* {console.log(this.state.isSSifile)} */}
                                                                                                    {data.DocDeleted == false ? <a
                                                                                                        href={data.DocumentPath}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                    >
                                                                                                        <span style={{ marginRight: '10px' }}
                                                                                                        >{data.DocumentName}</span>
                                                                                                    </a> : <span onClick={() => this.renderNewImage(data.DocumentFile, data.DocumentType)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                                                                    >{data.DocumentName}</span>}
                                                                                                    <i className={`fa fa-times text-danger img-can`}
                                                                                                        onClick={(e) => this.onChapterDocDelete(data.ChapterID, index)}
                                                                                                    ></i>
                                                                                                </div>
                                                                                                    : <div className="upload-options mt-1">
                                                                                                        <label style={{ display: 'flex' }}>
                                                                                                            <input
                                                                                                                type="file"
                                                                                                                id={`file${index}`}
                                                                                                                ref={this.fileInputRef}
                                                                                                                name={`file${index}`}
                                                                                                                className="image-upload"
                                                                                                                accept=".jpg, .jpeg, .png, .pdf"
                                                                                                                onChange={e => this.onFilePick(e, e.target.files, index)}
                                                                                                            // disabled={isView}
                                                                                                            />
                                                                                                            {
                                                                                                                data.DocumentFile != "" &&
                                                                                                                <i class="fa fa-times text-danger img-can"
                                                                                                                    onClick={() => this.onCrossClick(index)}
                                                                                                                ></i>
                                                                                                            }
                                                                                                        </label>
                                                                                                    </div> : <div className='text-center mt-2'>-</div>}
                                                                                            </td>
                                                                                            <td>  {data.ChapterID == 0 && <button
                                                                                                type="button"
                                                                                                className="btn btn-sm"
                                                                                                onClick={() => {
                                                                                                    exhibitDetailsList.splice(index, 1)
                                                                                                    this.setState({ exhibitDetailsList: exhibitDetailsList })
                                                                                                }
                                                                                                }
                                                                                            >
                                                                                                <i className="bi bi-trash text-danger" />
                                                                                            </button>}</td>
                                                                                        </tr>
                                                                                    )) : <tr >
                                                                                        <td colSpan={10} className="text-center">Record not available</td></tr>
                                                                                }

                                                                            </tbody>

                                                                        </table>
                                                                        {console.log("InternationalArea---->", exhibitDetailsList)}
                                                                        {
                                                                            false
                                                                            // true
                                                                            &&
                                                                            <div className="row mt-4" style={{ width: '100%' }}>
                                                                                <div className="col-md-5">
                                                                                    <div className="row mb-3">
                                                                                        <div className="d-flex justify-content-between mb-2">
                                                                                            <strong><span style={{ fontSize: '18px' }}>International Area</span>
                                                                                                <span className="text-red" style={{ marginLeft: '5px', marginTop: '-0px', fontSize: '15px' }} >(International Area Calculation Rules, <div className="text-primary" style={{ cursor: 'pointer', display: 'contents' }} onClick={(e) => this.setState({ intAreaRulesPop: true })}
                                                                                                >Click here</div> to view)</span>&emsp; </strong>
                                                                                        </div>
                                                                                    </div>

                                                                                    {
                                                                                        <div className="row mb-2">
                                                                                            <div className="d-flex justify-content-between mb-2">
                                                                                                <h5 className="mb-0 mt-1">Bare Area</h5>
                                                                                                <input
                                                                                                    style={{ width: '150px', textAlign: 'center' }}
                                                                                                    type="text"
                                                                                                    disabled={true}
                                                                                                    value={this.state.IAbare}
                                                                                                    className="form-control"
                                                                                                    required=""
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                    {
                                                                                        <div className="row mb-2">
                                                                                            <div className="d-flex justify-content-between mb-2">
                                                                                                <h5 className="mb-0 mt-1">Shell Area</h5>
                                                                                                <input
                                                                                                    style={{ width: '150px', textAlign: 'center' }}
                                                                                                    type="text"
                                                                                                    disabled={true}
                                                                                                    value={this.state.IAshell}
                                                                                                    className="form-control"
                                                                                                    required=""
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                    <hr></hr>
                                                                                    {
                                                                                        <div className="row mb-2">
                                                                                            <div className="d-flex justify-content-between mb-2">
                                                                                                <h5 className="mb-0 mt-1">Total International Area</h5>
                                                                                                <input
                                                                                                    style={{ width: '150px', textAlign: 'center' }}
                                                                                                    type="text"
                                                                                                    disabled
                                                                                                    value={InternationalArea}
                                                                                                    className="form-control"
                                                                                                    required=""
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    }

                                                                                </div>
                                                                            </div>}
                                                                        {((this.state.isShowInternationalArea) && sessionStorage.getItem("sessionContryName").toLowerCase().trim() == 'india') && <div className="area-card pt-2 mt-3">
                                                                            <div className="card-header bg-transparent px-0 border-0">


                                                                                <h2 className='mb-0 pb-2' style={{ fontSize: '21px' }}>International Area</h2>
                                                                                <div className="text-primary text-center" style={{ cursor: 'pointer', fontSize: '15px' }} onClick={(e) => this.setState({ intAreaRulesPop: true })}
                                                                                ><span className='text-danger'>International Area Calculation Rules</span><br></br> Click here <span className='text-danger'>to view</span></div>
                                                                            </div>

                                                                            <div className="info-box">
                                                                                <span>Bare Area</span>
                                                                                <strong>{this.state.IAbare}</strong>
                                                                            </div>

                                                                            <div className="info-box">
                                                                                <span>Shell Area</span>
                                                                                <strong>{this.state.IAshell}</strong>
                                                                            </div>

                                                                            <div className="total-box">
                                                                                <span>TOTAL INTERNATIONAL AREA</span>
                                                                                <strong>{InternationalArea} Sqm</strong>
                                                                            </div>

                                                                            {/* <p className="note">
        <strong>Note:</strong> Audit will take place prior to opening to verify exhibits.
        Discrepancies may lead to penalties or legal consequences.
    </p> */}
                                                                        </div>}
                                                                        < br />
                                                                        {
                                                                            ExhibitDetailsNote.length > 0 && ExhibitDetailsNote.map((data, i) => (
                                                                                <>{<>
                                                                                    <strong>Note: </strong>{data.Description}
                                                                                </>
                                                                                }
                                                                                    < br />< br />
                                                                                </>
                                                                            ))
                                                                        }
                                                                        < br />

                                                                        {this.state.isShowMachineryGuidelines &&
                                                                            <>
                                                                                {sessionStorage.getItem("countryId") == 91 ? (
                                                                                    <p className="m-0 mt-5">
                                                                                        <strong>Guideline for Machinery Display at {sessionStorage.getItem("exhibitionAddress")}</strong><br />
                                                                                        {this.state.guideLines.length > 0 && this.state.guideLines.map((data, i) => (
                                                                                            <>
                                                                                                {i + 1}- {data.Description}< br />
                                                                                            </>
                                                                                        ))}
                                                                                        {/* 1- Display of machinery is allowed only in static mode.<br />
                                                                                2- Very heavy-duty equipment and machinery are not allowed into the Hall and shall be allocated in the external exhibition space.<br />
                                                                                3- Floor load capacity: The floor space can hold 3 tons per sqm inside the hall.<br />
                                                                                4- Compressed Air and water supply are not available in the halls.<br />
                                                                                5- Loading door dimensions: The length is 9.56 mtr and height is 3.18 mtr.<br /> */}
                                                                                    </p>
                                                                                ) : (
                                                                                    <p className="m-0 mt-5">
                                                                                        <strong>Guideline for Machinery Display at {sessionStorage.getItem("exhibitionAddress")}</strong><br />
                                                                                        {this.state.guideLines.length > 0 && this.state.guideLines.map((data, i) => (
                                                                                            <>
                                                                                                {i + 1}- {data.Description}< br />
                                                                                            </>
                                                                                        ))}
                                                                                        {/* 1- Display of machinery is allowed only in static mode.<br />
                                                                                2- Very heavy-duty equipment and machinery are not allowed into the Hall and shall be allocated in the external exhibition space.<br />
                                                                                3- Floor load capacity: The floor space can hold 3 tons per sqm inside the hall.<br />
                                                                                4- Compressed Air and water supply are not available in the halls.<br />
                                                                                5- Loading door dimensions: The length is 9.56 mtr and height is 3.18 mtr.<br />
                                                                                <strong>Note: </strong>If any exhibitor wants to show live machinery, please contact the organizer for special arrangements.<br /> */}
                                                                                    </p>
                                                                                )}</>}

                                                                        {this.state.isShowChapterNotes && <>
                                                                            {sessionStorage.getItem("countryId") == 91 ? (
                                                                                <p className="m-0 mt-5">
                                                                                    <strong>Note: </strong><br />
                                                                                    {this.state.note.length > 0 && this.state.note.map((data, i) => (
                                                                                        <>
                                                                                            {i + 1}- {data.Description}< br />
                                                                                        </>
                                                                                    ))}
                                                                                </p>
                                                                            ) : (null)}
                                                                        </>}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <div className="mt-1 mb-4">
                                                <button className="btn btn-previous m-1" type="submit" onClick={e => this.onPreviousClick()}>
                                                    {" "}
                                                    Previous{" "}
                                                </button>
                                                <button className="btn btn-aqua"
                                                    onClick={e => this.handleStep2Insert()}
                                                // onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 0 }, popArg: [] })}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                        <div className="bottom-height"></div>
                                        <Footer />
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
                <Modal isOpen={this.state.isDel1Open} onRequestClose={() => this.setState({ isDel1Open: false })}>
                    <div className="modal-dialog custom_modal_dialog" style={{ left: '0px', top: '300px', }}>
                        <div className="modal-content" style={{ marginLeft: '-200px' }}>
                            <div className="modal-header" style={{ padding: "7px 10px", }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    Confirm Delete
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={(e) => this.setState({ isDel1Open: false })}
                                />
                            </div>
                            <div className="modal-body" >
                                <div className="form-row mt-3">

                                    <div className="col-md-10">
                                        <p class="pop_label">Do you really want to delete this Document?</p>

                                    </div>
                                    <div class="modal-footer p-1">
                                        <div class="form-group text-right mod-fot">
                                            <button type="button" class="btn btn-del-pop"
                                                onClick={(e) => this.handleSSIDelete(e)}
                                            >Yes</button>
                                            <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDel1Open: false })}>No</button>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={this.state.isDel2Open} onRequestClose={() => this.setState({ isDel2Open: false })}>
                    <div className="modal-dialog custom_modal_dialog" style={{ left: '0px', top: '300px', }}>
                        <div className="modal-content" style={{ marginLeft: '-200px' }}>
                            <div className="modal-header" style={{ padding: "7px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    Confirm Delete
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => this.setState({ isDel2Open: false })}

                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="form-row mt-3">

                                    <div className="col-md-10">
                                        <p class="pop_label">Do you really want to delete this Document?</p>

                                    </div>
                                    <div class="modal-footer p-1">
                                        <div class="form-group text-right mod-fot">
                                            <button type="button" class="btn btn-del-pop"
                                                onClick={(e) => this.handleTMMAITAMMADelete(e)}
                                            >Yes</button>
                                            <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDel2Open: false })}>No</button>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={this.state.isDel3Open} onRequestClose={() => this.setState({ isDel3Open: false })}>
                    <div className="modal-dialog custom_modal_dialog" style={{ left: '0px', top: '300px', }}>
                        <div className="modal-content" style={{ marginLeft: '-200px' }}>
                            <div className="modal-header" style={{ padding: "7px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    Confirm Delete
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => this.setState({ isDel3Open: false })}

                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="form-row mt-3">

                                    <div className="col-md-10">
                                        <p class="pop_label">Do you really want to delete this Document?</p>

                                    </div>
                                    <div class="modal-footer p-1">
                                        <div class="form-group text-right mod-fot">
                                            <button type="button" class="btn btn-del-pop"
                                                onClick={(e) => this.handleChapterDocDelete(e)}
                                            >Yes</button>
                                            <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDel3Open: false })}>No</button>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={this.state.isDel3Open} onRequestClose={() => this.setState({ isDel3Open: false })}>
                    <div className="modal-dialog custom_modal_dialog" style={{ left: '0px', top: '300px', }}>
                        <div className="modal-content" style={{ marginLeft: '-200px' }}>
                            <div className="modal-header" style={{ padding: "7px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    Confirm Delete
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => this.setState({ isDel3Open: false })}

                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="form-row mt-3">

                                    <div className="col-md-10">
                                        <p class="pop_label">Do you really want to delete this Document?</p>

                                    </div>
                                    <div class="modal-footer p-1">
                                        <div class="form-group text-right mod-fot">
                                            <button type="button" class="btn btn-del-pop"
                                                onClick={(e) => this.handleChapterDocDelete(e)}
                                            >Yes</button>
                                            <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDel3Open: false })}>No</button>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={open} >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '25%' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div
                                className=""
                                style={{ paddingLeft: 10, paddingRight: 10, marginTop: 20 }}
                            >
                                {
                                    MultiSelectNotes.length > 0 && MultiSelectNotes.map((data, i) => (
                                        <>
                                            <strong>{`Note ${i + 1}: `}</strong>{data.Description}
                                            < br />
                                            < br />

                                        </>
                                    ))
                                }
                            </div>
                            <div className="form-row m-3 mt-2 mb-0 border-bottom">

                                <div className="col-md-10">
                                    <p> I have read the Rules and Regulation for multiple Primary Chapter & agree to abide by them.</p>
                                </div>
                                <div className="col-md-2">
                                    <button
                                        type="button"
                                        className="btn btn-gray"
                                        data-bs-dismiss="modal"
                                        style={{ padding: '4px 15px', float: 'right' }}
                                        onClick={e => this.setState({
                                            open: false,
                                            isOpenAgree: true
                                        })}
                                    >
                                        Accept
                                    </button>
                                </div>


                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.toNewPop} >
                    <div
                        className="modal-dialog custom_modal_dialog modal-xxl"
                        style={{ left: '0px', top: '25%', maxWidth: '95%', width: '95%' }}
                    >
                        <div className="modal-content responsive-width w-auto">

                            <div className="modal-header py-2 bg-danger">
                                <h4 className="mb-0 py-1 text-center text-white fw-semibold w-100">
                                    Important Note
                                </h4>
                            </div>

                            <div className="modal-body">
                                <div className="row">
                                    <h5 className="text-center fw-normal">
                                        Indian companies showcasing foreign-manufactured machines or accessories must complete a separate International Space Booking form using the link below:
                                        <br />
                                        <span className="d-block mt-2 fw-normal">[
                                            <a
                                                className="text-primary mt-2"
                                                style={{ cursor: 'pointer' }}
                                            // onClick={this.fillInternationalForm}
                                            >
                                                Click here
                                            </a>  to fill out the International Form]
                                        </span>
                                    </h5>
                                </div>
                            </div>

                            <div className="modal-footer p-1">
                                <div className="form-group text-right mod-fot mx-3">
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger"
                                        data-dismiss="modal"
                                        onClick={() => this.setState({ toNewPop: false })}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* </div> */}
                </Modal>
                <Modal isOpen={this.state.slabpop} >
                    <div className="modal-dialog modal-xl" style={{ width: 'fit-content', top: '15%', zIndex: 10 }}>
                        <div className="modal-content responsive-width w-auto" style={{ marginTop: '70px' }}>
                            <div className="modal-header" style={{ padding: "16px 20px", fontSize: 'medium', backgroundColor: 'white' }}>
                                <div className="mb-0 pt-2 text-center fw-bold w-100">
                                    Below listed foreign area Slab applies only to companies that are showcasing foreign companies’ brochures under the booth of an Indian Company or an Indian Agent Company.
                                </div>
                                {/* <strong> */}
                                {/* </strong> */}
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => this.setState({ slabpop: false, intAreaRulesPop: true })}
                                    // style={{ scale: '' }}
                                    aria-label="Close"
                                >
                                    {/* <i class="fa fa-circle-xmark"></i> */}
                                </button>
                            </div>

                            <div className="modal-body pt-0 p-3" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="form-row mt-2" style={{ height: 'calc(100vh - 288px)', overflow: 'auto' }}>
                                    <table
                                        className="table table-bordered"
                                        style={{
                                            border: "1px solid #d8d8d8 !important",
                                            marginRight: '50px',
                                            marginLeft: '50px',
                                        }}
                                    >
                                        <thead>
                                            <tr>
                                                <th className='text-center'>Area Slab(SQM)</th>
                                                <th className='text-center'>USD Tariff to charge</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {internationalAreaSlabList.length > 0 && internationalAreaSlabList.map((item, i) => (
                                                <tr>
                                                    <td className='text-center'>{i == internationalAreaSlabList.length - 1 ? `${item.FromRange} sqm and above` : `${item.FromRange} sqm to ${item.ToRange} sqm`}</td>
                                                    <td className='text-center'>{item.MinArea} sqm</td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>


                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={(e) => this.setState({ slabpop: false, intAreaRulesPop: true })}
                                    >OK</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </Modal>
                <Modal isOpen={false} onRequestClose={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })} >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header" style={{ padding: "10px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    <b>International Area Calculation Rules</b>
                                </h5>
                                <button style={{ fontSize: '16px' }}
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })}
                                />
                            </div>

                            <div className="modal-body" style={{ overflowY: 'auto' }}>
                                <div >
                                    <ol>
                                        <li><p>
                                            If only Brochure is selected for all exhibit items, the international area will be calculated based on the brochure slab.
                                            (<div className="text-primary" style={{ cursor: 'pointer', display: 'contents' }} onClick={(e) => this.setState({ slabpop: true, intAreaRulesPop: false })}
                                            >Click here</div> to view slab.)
                                        </p></li>
                                        <li><p>
                                            If only Brochure is selected along with a combination of Machine or Accessories from different manufacturers, the applicable international area for each brochure will be 9 sqm per manufacturer.
                                        </p></li>
                                        <li><p>
                                            If Machine is selected, the international area will be calculated based on the dimensions specified for each exhibit item.
                                        </p></li>
                                        <li><p>
                                            If Accessories are selected then  the international area will be 18 sqm for each.
                                        </p></li>
                                        <li><p>
                                            If there is a combination of Machine, Accessories, and Brochure, the international area will be calculated as per the respective rules mentioned in Points 2, 3, and 4.
                                        </p></li>
                                    </ol>
                                    <br></br>
                                    <p>
                                        For any further queries or clarification, please contact the exhibition team at {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>{data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}</>)) : null} or  {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (<a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>)) : null}
                                    </p>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })}
                                    >OK</button>
                                </div>
                            </div>
                            {/* <div className="modal-footer" style={{ padding: 3 }}>
                                    
                                                                </div> */}
                        </div>
                    </div >

                </Modal >
                <Modal isOpen={isOpen2} onRequestClose={(e) => this.setState({ isOpen2: false })}>
                    <div
                        className="modal-dialog modal-dialog-centered bd-example-modal-lg"
                        id="detail"
                    // tabIndex={-1}
                    // aria-labelledby="detailLabel"
                    // aria-hidden="true"
                    >
                        <div className="modal-dialog modal-md" style={{ maxWidth: '660px', marginTop: '1rem', marginLeft: '-9.5rem' }}>
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '20px' }} className="mb-2">
                                        Kindly contact your country’s space selling representative to process space booking application.
                                    </p>
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        <strong>
                                            <a className='text-primary' href={sessionStorage.getItem('SSRLink')} >Click here to view Space Selling Representative</a>
                                        </strong>
                                    </p>
                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => this.setState({ isOpen2: false })}
                                    >
                                        {" "}
                                        <a
                                            className="text-center btn-next text-white"
                                            style={{ color: 'white' }}
                                        >
                                            OK
                                        </a>{" "}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={isOpen4} onRequestClose={(e) => this.setState({ isOpen4: false })}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    {/* <p style={{ textAlign: 'center', margin: '15px', fontSize: '20px' }} className="mb-2">
                                        Increase Stall Area
                                    </p> */}
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        {`Based on the exhibit dimensions entered, the overall booth area should be greater than the recalculated space area. Therefore, the booth area has been revised to ${expectedArea} sq.m.`}
                                    </p>
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Kindly confirm the revised area and proceed with the application.
                                    </p>

                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => this.changetoExpArea()}
                                    >
                                        {" "}
                                        {/* <a
                                            className="text-center btn-next text-white"
                                            style={{ color: 'white' }}
                                        > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={isOpen10} onRequestClose={(e) => this.setState({ isOpen10: false })}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    {/* <p style={{ textAlign: 'center', margin: '15px', fontSize: '20px' }} className="mb-2">
                                        Increase Stall Area
                                    </p> */}
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        {`Based on the exhibit dimensions entered, the overall booth area should be greater than the recalculated space area. Therefore, the booth area has been revised to ${expectedArea} sq.m.`}
                                    </p>
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Kindly confirm the revised area and proceed with the application.
                                    </p>
                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => this.changetoExpArea()}
                                    >
                                        {" "}
                                        {/* <a
                                            className="text-center btn-next text-white"
                                            style={{ color: 'white' }}
                                        > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={false} onRequestClose={(e) => this.setState({ OpenMixExhibitorRule: false })}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    {/* <p style={{ textAlign: 'center', margin: '15px', fontSize: '20px' }} className="mb-2">
                                        Increase Stall Area
                                    </p> */}
                                    <ol>
                                        <li><p>
                                            If only Brochure is selected for all exhibit items, the international area will be calculated based on the brochure slab.
                                            (<div className="text-primary" style={{ cursor: 'pointer', display: 'contents' }} onClick={(e) => this.setState({ slabpop: true, intAreaRulesPop: false })}
                                            >Click here</div> to view slab.)
                                        </p></li>
                                        <li><p>
                                            If only Brochure is selected along with a combination of Machine or Accessories from different manufacturers, the applicable international area for each brochure will be 9 sqm per manufacturer.
                                        </p></li>
                                        <li><p>
                                            If Machine is selected, the international area will be calculated based on the dimensions specified for each exhibit item.
                                        </p></li>
                                        <li><p>
                                            If Accessories are selected then  the international area will be 18 sqm for each.
                                        </p></li>
                                        <li><p>
                                            If there is a combination of Machine, Accessories, and Brochure, the international area will be calculated as per the respective rules mentioned in Points 2, 3, and 4.
                                        </p></li>
                                    </ol>
                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => this.setState({ OpenMixExhibitorRule: false, isMixRuleAgree: true })}
                                    >
                                        {" "}
                                        {/* <a
                                            className="text-center btn-next text-white"
                                            style={{ color: 'white' }}
                                        > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={OpensameCountryManuErr} onRequestClose={(e) => this.setState({ OpensameCountryManuErr: false })}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                    <strong>Rules and Guidelines</strong>
                                </p><br></br>
                                {sessionStorage.getItem("sessionContryName") != null && sessionStorage.getItem("sessionContryName").toLowerCase().trim() == 'india' ? <ul >
                                    <li>
                                        Any agent representing an Indian company have to submit individual application form for each company with minimum 18 sqm booth. Clubbing of multiple Indian companies within a single 18 sqm booth is not permitted
                                    </li>
                                    <li>
                                        For foreign participation, under Indian agent kindly refer to the rules of application & minimum area criteria.
                                    </li><br></br>
                                    <li><p>
                                        Kindly contact the ITME 2026 Exhibition Team for further clarification or assistance.
                                    </p></li>
                                </ul> : <ul >
                                    <li>
                                        Clubbing of multiple foreign companies within a single booth is not permitted. Please refer to the space booking application guidelines for detailed information on this rule
                                    </li><br></br>
                                    <li><p>
                                        Kindly contact the ITME 2026 Exhibition Team for further clarification or assistance.
                                    </p></li>
                                </ul>}
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => this.setState({ OpensameCountryManuErr: false })}
                                    >
                                        {" "}
                                        {/* <a
                                            className="text-center btn-next text-white"
                                            style={{ color: 'white' }}
                                        > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={this.state.SSIPop} >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        As your application includes the display of foreign exhibits, you are not eligible for SSI, TMMA, or ITAMMA discounts. These concessions are applicable only to exhibitors meeting the prescribed eligibility criteria for domestic manufacturing and association memberships.
                                        <br />

                                    </p>

                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => this.setState({
                                            SSIPop: false,
                                        }, () => {
                                            this.setState({
                                                isSSIandTMMAITAMMMA: false, TMMAITAMMA: (this.state.isTMMAITAMMAdeleted) ? '' : this.state.TMMAITAMMA, isSSi: false,
                                            })
                                            if (this.state.isSSIdeleted) {
                                                this.setState({ isSSifile: '', isSSifilePath: '', isSSifileType: '' })
                                            }
                                            if (this.state.isTMMAITAMMAdeleted) {
                                                this.setState({ TMMAITAMMAfile: '', TMMAITAMMAfilePath: '', TMMAITAMMAfileType: '' })
                                            }
                                        })}
                                    >
                                        {" "}
                                        {/* <a
                                                                         className="text-center btn-next text-white"
                                                                         style={{ color: 'white' }}
                                                                     > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* </div> */}
                </Modal>

                <Modal
                    isOpen={this.state.isOpenUtility}
                    onRequestClose={() => this.setState({ isOpenUtility: false })}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    ariaHideApp={false}
                >
                    <div className="modal-dialog modal-almost-fullscreen">
                        <div className="modal-content">
                            <div className="modal-header p-2">
                                <h6 className="modal-title">{this.state.UtilityName} Requirement Rates</h6>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() => this.setState({ isOpenUtility: false })}
                                />
                            </div>

                            <div className="modal-body">
                                {this.state.UtilityName == 'Power' ?
                                    <>
                                        <div class="table-responsive mt-3">
                                            <table class="table border text-nowrap text-md-nowrap table-bordered mb-0  w-50 air-connection-table">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center">
                                                            Sr.No
                                                        </th>
                                                        <th>
                                                            Description
                                                        </th>
                                                        {CurrencyName == 'INR' ? (
                                                            <>
                                                                <th className="text-center">
                                                                    Standard Rate <br></br>(INR)
                                                                </th>
                                                                <th className="text-center">Cut-off Date Rate<br />
                                                                    (INR)<br />
                                                                    (Up to 30-10-2026)</th>
                                                                <th className="text-center">Onsite Rate <br />
                                                                    (INR)<br />
                                                                    (From 28-11-2026)</th>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <th className="text-center">
                                                                    Standard Rate <br></br>(USD)
                                                                </th>
                                                                <th className="text-center">Cut-off Date Rate<br />
                                                                    (USD)<br />
                                                                    (Up to 30-10-2026)</th>
                                                                <th className="text-center">Onsite Rate<br />
                                                                    (USD)<br />
                                                                    (From 28-11-2026)</th>
                                                            </>
                                                        )}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {powerPriceList.length > 0 ?
                                                        powerPriceList.map((item, i) => (
                                                            <tr>
                                                                <td className="text-center">{i + 1}</td>
                                                                <td>{item.Description}</td>
                                                                <>
                                                                    {CurrencyName == 'INR' ?
                                                                        <>
                                                                            <td style={{ textAlign: "center" }}>
                                                                                {item.StandardRateInINR ? formatAmount(item.StandardRateInINR) : ""}
                                                                            </td>
                                                                            <td style={{ textAlign: "center" }}>
                                                                                {item.CutOffDateRateInINR ? formatAmount(item.CutOffDateRateInINR) : ""}
                                                                            </td>
                                                                            <td style={{ textAlign: "center" }}>
                                                                                {item.OnSiteRateInINR ? formatAmount(item.OnSiteRateInINR) : ""}
                                                                            </td>
                                                                        </> :
                                                                        <>
                                                                            <td style={{ textAlign: "center" }}>
                                                                                {item.StandardRateInUSD ? formatAmount(item.StandardRateInUSD) : ""}
                                                                            </td>
                                                                            <td style={{ textAlign: "center" }}>
                                                                                {item.CutOffDateRateInUSD ? formatAmount(item.CutOffDateRateInUSD) : ""}
                                                                            </td>
                                                                            <td style={{ textAlign: "center" }}>
                                                                                {item.OnSiteRateInUSD ? formatAmount(item.OnSiteRateInUSD) : ""}
                                                                            </td>
                                                                        </>
                                                                    }
                                                                </>
                                                            </tr>
                                                        )) :
                                                        <tr>
                                                            <td className="text-center" colSpan={10}>Record not found</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div >
                                    </> :
                                    this.state.UtilityName == 'Water' ?
                                        <>
                                            <div class="table-responsive mt-3">
                                                <table class="table border text-nowrap text-md-nowrap table-bordered mb-0  w-50 air-connection-table">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center">
                                                                Sr.No
                                                            </th>
                                                            <th>
                                                                Description
                                                            </th>
                                                            {CurrencyName == 'INR' ? (
                                                                <>
                                                                    <th className="text-center">
                                                                        Standard Rate <br></br>(INR)
                                                                    </th>
                                                                    <th className="text-center">Cut-off Date Rate<br />
                                                                        (INR)<br />
                                                                        (Up to 30-10-2026)</th>
                                                                    <th className="text-center">Onsite Rate <br />
                                                                        (INR)<br />
                                                                        (From 28-11-2026)</th>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <th className="text-center">
                                                                        Standard Rate <br></br>(USD)
                                                                    </th>
                                                                    <th className="text-center">Cut-off Date Rate<br />
                                                                        (USD)<br />
                                                                        (Up to 30-10-2026)</th>
                                                                    <th className="text-center">Onsite Rate<br />
                                                                        (USD)<br />
                                                                        (From 28-11-2026)</th>
                                                                </>
                                                            )}
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {waterPriceList.length > 0 ?
                                                            waterPriceList.map((item, i) => (
                                                                <tr>
                                                                    <td className="text-center">{i + 1}</td>
                                                                    <td>{item.connection}</td>
                                                                    <>
                                                                        {CurrencyName == 'INR' ?
                                                                            <>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {item.StandardRateInINR ? formatAmount(item.StandardRateInINR) : ""}
                                                                                </td>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {item.CutOffDateRateInINR ? formatAmount(item.CutOffDateRateInINR) : ""}
                                                                                </td>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {item.OnSiteRateInINR ? formatAmount(item.OnSiteRateInINR) : ""}
                                                                                </td>
                                                                            </> :
                                                                            <>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {item.StandardRateInUSD ? formatAmount(item.StandardRateInUSD) : ""}
                                                                                </td>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {item.CutOffDateRateInUSD ? formatAmount(item.CutOffDateRateInUSD) : ""}
                                                                                </td>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {item.OnSiteRateInUSD ? formatAmount(item.OnSiteRateInUSD) : ""}
                                                                                </td>
                                                                            </>
                                                                        }
                                                                    </>
                                                                </tr>
                                                            )) :
                                                            <tr>
                                                                <td className="text-center" colSpan={10}>Record not found</td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div >
                                        </> :
                                        this.state.UtilityName == 'Air' ?
                                            <>
                                                <div class="table-responsive mt-3">
                                                    <table class="table border text-nowrap text-md-nowrap table-bordered mb-0  w-50 air-connection-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center" style={{ width: "5%" }}>
                                                                    Sr No{" "}
                                                                </th>
                                                                <th className="text-left" style={{ width: "45%" }}>Description</th>
                                                                <th className="text-center">Bar</th>
                                                                <th className="text-center">CFM</th>
                                                                {CurrencyName == 'INR' ? (
                                                                    <>
                                                                        <th className="text-center">
                                                                            Standard Rate <br></br>(INR)
                                                                        </th>
                                                                        <th className="text-center">Cut-off Date Rate<br />
                                                                            (INR)<br />
                                                                            (Up to 30-10-2026)</th>
                                                                        <th className="text-center">Onsite Rate <br />
                                                                            (INR)<br />
                                                                            (From 28-11-2026)</th>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <th className="text-center">
                                                                            Standard Rate <br></br>(USD)
                                                                        </th>
                                                                        <th className="text-center">Cut-off Date Rate<br />
                                                                            (USD)<br />
                                                                            (Up to 30-10-2026)</th>
                                                                        <th className="text-center">Onsite Rate<br />
                                                                            (USD)<br />
                                                                            (From 28-11-2026)</th>
                                                                    </>
                                                                )}
                                                                <th className="text-center">Connection</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {airPriceList.map((item, i) => (
                                                                <tr>
                                                                    <td className="text-center">{i + 1}</td>
                                                                    <td className="text-left" style={{ whiteSpace: "pre-line" }}>{item.DescriptionOfService}</td>
                                                                    <td className="text-center">{item.BarQuantity}</td>
                                                                    <td className="text-center">{item.CFMQuantity}</td>
                                                                    {CurrencyName == 'INR' ?
                                                                        <>
                                                                            <td style={{ textAlign: "right" }}>
                                                                                {item.StandardRateInINR ? formatAmount(item.StandardRateInINR) : ""}
                                                                            </td>
                                                                            <td style={{ textAlign: "right" }}>
                                                                                {item.CutOffDateRateInINR ? formatAmount(item.CutOffDateRateInINR) : ""}
                                                                            </td>
                                                                            <td style={{ textAlign: "right" }}>
                                                                                {item.OnSiteRateInINR ? formatAmount(item.OnSiteRateInINR) : ""}
                                                                            </td>
                                                                        </> :
                                                                        <>
                                                                            <td style={{ textAlign: "right" }}>
                                                                                {item.StandardRateInUSD ? formatAmount(item.StandardRateInUSD) : ""}
                                                                            </td>
                                                                            <td style={{ textAlign: "right" }}>
                                                                                {item.CutOffDateRateInUSD ? formatAmount(item.CutOffDateRateInUSD) : ""}
                                                                            </td>
                                                                            <td style={{ textAlign: "right" }}>
                                                                                {item.OnSiteRateInUSD ? formatAmount(item.OnSiteRateInUSD) : ""}
                                                                            </td>
                                                                        </>
                                                                    }
                                                                    <td className="text-center">Each Conn.</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                            : <></>
                                }
                            </div>


                            <div className="modal-footer py-1">
                                <button
                                    className="btn btn-gray"
                                    onClick={() => this.setState({ isOpenUtility: false })}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={this.state.minAreaPop1} >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Exhibitors with  9 sqm booth are not permitted to display products from any other company.
                                        <br />

                                    </p>

                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => {
                                            exhibitDetailsList.map(item => {
                                                if (item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '') {
                                                    item.ManufacturingCountry = ''
                                                }
                                            })
                                            this.setState({ exhibitDetailsList: exhibitDetailsList, minAreaPop1: false })
                                        }}
                                    >
                                        {" "}
                                        {/* <a
                                                                         className="text-center btn-next text-white"
                                                                         style={{ color: 'white' }}
                                                                     > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* </div> */}
                </Modal>
                <Modal isOpen={this.state.minAreaPop2} >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Since you will be displaying another company's products within your booth, the minimum booth area requirement will increase to 27 sqm.
                                        <br />

                                    </p>

                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => {

                                            if (internationalAreaSlabList.length > 0) {
                                                for (var i = 0; i < stallAreaList.length; i++) {
                                                    if (stallAreaList[i].StallArea == internationalAreaSlabList[0].FromRange) {
                                                        console.log(stallAreaList[i], internationalAreaSlabList, 'internationalAreaSlabList')
                                                        this.setState({
                                                            expectedArea: stallAreaList[i].StallArea, expectedAreaId: stallAreaList[i].Code
                                                        }, () => {
                                                            this.changetoExpArea().then(() => {
                                                                this.adjustCalculatedArea(this.state.expectedArea)
                                                            })
                                                        })
                                                    }
                                                }
                                            }
                                            this.setState({
                                                minAreaPop2: false
                                            })
                                        }}
                                    >
                                        {" "}
                                        {/* <a
                                                                         className="text-center btn-next text-white"
                                                                         style={{ color: 'white' }}
                                                                     > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* </div> */}
                </Modal>
                <Modal isOpen={this.state.prefferedPop} >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    <p style={{ textAlign: 'left', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Based on the exhibit details provided (brochures only), the booth type has been changed from Shell to Bare Space.
                                        {/* <br /> */}
                                    </p>

                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Would you like to
                                    </p>
                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <br></br>
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        style={{
                                            // width: "20%",
                                            // display: "block",
                                            background: "#4ec7be",
                                            // padding: 4
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                prefferedPop: false, prefferedType: 1, prefferedPopAsk: true
                                            }, () => {
                                                this.adjustCalculatedArea(area)
                                            })
                                        }}
                                    >
                                        Keep Bare Space and build the booth yourself
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        style={{
                                            // width: "20%",
                                            // display: "block",
                                            background: "#4ec7be",
                                            // padding: 4
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                prefferedPop: false, prefferedType: 2, prefferedPopAsk: true
                                            }, () => {
                                                this.onSchemeTypeChange(null, 2, 1)
                                            })
                                        }}
                                    >
                                        Continue with a Shell booth
                                    </button>
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        <strong> Note:</strong>  Space charges will be applied at the standard Shell rate in either case
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* </div> */}
                </Modal>
                <Modal isOpen={intAreaRulesPop} onRequestClose={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })} onAfterOpen={() => this.PdfRender()}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header" style={{ padding: "10px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    <b>International Area Calculation Rules</b>
                                </h5>
                                <button style={{ fontSize: '16px' }}
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })}
                                />
                            </div>

                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px", height: 'calc(90vh - 200px)', overflow: 'auto', overflowY: 'hidden' }}>
                                {/* <iframe
                                                                    id="myIframe" style={{ marginTop: '0px' }}
                                                                    src={`${DOC_BASE_URL + RandRpath}#toolbar=0&navpanes=0`}
                                                                    width="100%"
                                                                    height="100%"
                                                                    title="Bing"
                                                                /> */}
                                <div
                                    id="pdf-container"
                                    ref={this.pdfContainerRef}
                                    style={{
                                        width: "100%",
                                        height: "100%",       // keeps it scrollable inside card
                                        overflowY: "auto",    // ✅ allow auto scrollbar (not forced scroll)
                                        WebkitOverflowScrolling: "touch", // ✅ smooth scroll (mobile too)
                                        background: '#f5f5f5'
                                    }}
                                ></div>
                            </div>
                            <div className="form-row m-3 mt-2 mb-0 border-bottom">

                                <div className="col-md-10">
                                    <p> <div className="text-primary" style={{ cursor: 'pointer', display: 'contents' }} onClick={(e) => this.setState({ slabpop: true, intAreaRulesPop: false })}
                                    >Click here</div> to view Brochure slab.</p>
                                </div>
                                <div className="col-md-2">
                                    <button
                                        type="button"
                                        className="btn btn-gray"
                                        data-bs-dismiss="modal"
                                        style={{ padding: '4px 15px', float: 'right' }}
                                        onClick={e => this.setState({ intAreaRulesPop: false, isMixRuleAgree: true })}
                                    >
                                        Ok
                                    </button>
                                </div>


                            </div>
                            {/* <div className="modal-footer" style={{ padding: 3 }}>
                                
                                                            </div> */}
                        </div>
                    </div>

                </Modal >
            </>
        );
    }
}

export default withRouter(connect(null, {
    fill_action, primaryChapterAdd_action, getPreviewDetails_action, getAgentDetails_action, getPendingRegDetails_action, getDoubleStoreySSI_action, deleteSSicertificate_action, deleteTMMAITAMMA_action, generateNewForm_action, deleteChapterDoc_action, getExhibitionSSRCountryMappingData_action, getPowerConnectionList_action, getWaterDetails_action, getAirConnectionDetails_action
})(PrimaryChapter));

